
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aJMnP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bltJZ = parcelRequire("bltJZ");


var $cXPtd = parcelRequire("cXPtd");


var $jlJcq = parcelRequire("jlJcq");


var $kSwu1 = parcelRequire("kSwu1");

const $767e9a2862922504$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.jira",
        defaultMessage: "Jira"
    }
});


const $0a59bca40142140c$var$icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $0a59bca40142140c$export$b34e755010aed2b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (fallbackUrl, t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    let t2;
    if ($[2] !== options) {
        t2 = {
            apsKey: (0, $cXPtd.Products).JIRA_SOFTWARE,
            analyticsName: (0, $cXPtd.Products).JIRA_SOFTWARE,
            ...options
        };
        $[2] = options;
        $[3] = t2;
    } else t2 = $[3];
    return (0, $jlJcq.useAppGlobalShortcutLinkItem)($0a59bca40142140c$var$icon, (0, $767e9a2862922504$export$defe85febe8b728c).label, fallbackUrl, t2);
} : (fallbackUrl, options = {})=>(0, $jlJcq.useAppGlobalShortcutLinkItem)($0a59bca40142140c$var$icon, (0, $767e9a2862922504$export$defe85febe8b728c).label, fallbackUrl, {
        apsKey: (0, $cXPtd.Products).JIRA_SOFTWARE,
        analyticsName: (0, $cXPtd.Products).JIRA_SOFTWARE,
        ...options
    });
module.exports["useJira"] = $0a59bca40142140c$export$b34e755010aed2b2;

});

parcelRegister("4Mzej", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $5xvpm = parcelRequire("5xvpm");




const $18040aad49f819dd$export$a5c3144306783a42 = /*#__PURE__*/ (0, $cozmU.createContext)({
    impressedProducts: {
        JIRA_SOFTWARE: false,
        CONFLUENCE: false
    }
});



var $afGU4 = parcelRequire("afGU4");

/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 






var $55fM8 = parcelRequire("55fM8");











const $b38316b21effc154$export$437ae3f50102760d = (0, $cozmU.createContext)({
    status: 'idle'
});
const $b38316b21effc154$export$66a70772711988d1 = (0, $cozmU.createContext)(()=>{});
const $b38316b21effc154$export$69c89392124bbb84 = ()=>(0, $cozmU.useContext)($b38316b21effc154$export$437ae3f50102760d);
const $b38316b21effc154$export$5c3e277aaa23ea00 = ()=>(0, $cozmU.useContext)($b38316b21effc154$export$66a70772711988d1);


/* main.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");




const $4873b942c867c62b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    invitedLozenge: {
        id: "cross-join-nudges.invited-app-shortcuts.invited-lozenge",
        defaultMessage: "Invited"
    },
    popupMainTextWithCollaborators: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-main-text-with-collaborators",
        defaultMessage: "You're invited to join your team"
    },
    popupMainTextWithoutCollaborators: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-main-text-without-collaborators",
        defaultMessage: "Don't lose access, accept invite now"
    },
    popupAcceptInviteButton: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-accept-invite-button",
        defaultMessage: "Accept invite"
    },
    popupCollaboratorsTooltip: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-collaborators-tooltip",
        defaultMessage: "{numberOfCollaborators} more {numberOfCollaborators, plural, one {teammate} other {teammates}} are using {app}"
    },
    jira: {
        id: "cross-join-nudges.invited-app-shortcuts.jira",
        defaultMessage: "Jira"
    },
    confluence: {
        id: "cross-join-nudges.invited-app-shortcuts.confluence",
        defaultMessage: "Confluence"
    }
});









const $81a0f55aa5e72ab7$var$styles = {
    container: "_1e0c11p5 _yv0e5bpd _4cvr1h6o _1bsb1osq",
    lozengeContainer: "_1e0c1txw _1bahesu3 _4cvr1h6o _1ul9idpf"
};
const $81a0f55aa5e72ab7$var$INITIAL_ANIMATION_DELAY = 2000; // apsKeys that have already played their initial animation. Module-scoped so it survives the
// frequent subtree remounts (a `useRef` would be discarded); keyed by apsKey so products stay
// independent; not React state so flipping it can't re-render and cut the animation short.
const $81a0f55aa5e72ab7$var$impressedApsKeys = new Set();

const $81a0f55aa5e72ab7$export$f60dc2630a14000a = ({ label: label, apsKey: apsKey })=>{
    const { impressedProducts: impressedProducts } = (0, $cozmU.useContext)((0, $18040aad49f819dd$export$a5c3144306783a42));
    const hasAlreadySeenThisInvitedAppShortcut = impressedProducts[apsKey] || $81a0f55aa5e72ab7$var$impressedApsKeys.has(apsKey);
    const [AnimatedLozengeComponent, setAnimatedLozengeComponent] = (0, $cozmU.useState)(null);
    const { fireViewedAnimatedLozenge: fireViewedAnimatedLozenge } = (0, $afGU4.useInvitedAppAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        // Keep SSR and initial hydration light by rendering static Lozenge first.
        if (hasAlreadySeenThisInvitedAppShortcut) return;
         // Load animation code only for users who can actually see the animated treatment.
        (parcelRequire("kT3wS")).then((module)=>{
            setAnimatedLozengeComponent(module.default);
        });
    }, [
        hasAlreadySeenThisInvitedAppShortcut
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (AnimatedLozengeComponent && (0, $iDrrr.fg)('puma-1895-fire-viewed-animated-lozenge')) fireViewedAnimatedLozenge({
            app: (0, $5xvpm.getAppKeyByApsKey)(apsKey)
        });
    }, [
        AnimatedLozengeComponent,
        fireViewedAnimatedLozenge,
        apsKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            $81a0f55aa5e72ab7$var$impressedApsKeys.add(apsKey);
        }, $81a0f55aa5e72ab7$var$INITIAL_ANIMATION_DELAY);
        return ()=>clearTimeout(timeoutId);
    }, [
        apsKey
    ]);
    const LozengeComponent = !hasAlreadySeenThisInvitedAppShortcut && AnimatedLozengeComponent ? AnimatedLozengeComponent : (0, $9KSWX.default);
    const lozengeProps = LozengeComponent === AnimatedLozengeComponent ? {
        initialAnimationDelay: $81a0f55aa5e72ab7$var$INITIAL_ANIMATION_DELAY
    } : {};
    const shouldRenderLozenge = hasAlreadySeenThisInvitedAppShortcut || AnimatedLozengeComponent !== null;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $81a0f55aa5e72ab7$var$styles.container
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), null, label), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $81a0f55aa5e72ab7$var$styles.lozengeContainer
        ])
    }, shouldRenderLozenge ? /*#__PURE__*/ $cozmU.createElement(LozengeComponent, {
        appearance: "inprogress",
        ...lozengeProps
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $4873b942c867c62b$export$defe85febe8b728c).invitedLozenge)) : null));
};


/* main.tsx generated by @compiled/babel-plugin v0.40.0 */ 






var $bcDqz = parcelRequire("bcDqz");


var $i1t43 = parcelRequire("i1t43");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");




var $a9aSv = parcelRequire("a9aSv");









/* main.tsx generated by @compiled/babel-plugin v0.40.0 */ 









var $lpNn5 = parcelRequire("lpNn5");

var $1B9Aq = parcelRequire("1B9Aq");








const $d3d3f7f5454077a5$var$styles = {
    root: "_2rkofajl _11c8wadc _vchhusvi _p12f1mjv _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna"
}; /**
    * As truncate is deprecated, we need to use a custom tooltip component to ensure the tooltip can show the message in one line.
    */ 
const $d3d3f7f5454077a5$var$CustomTooltip = /*#__PURE__*/ (0, $cozmU.forwardRef)(function CustomTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ $cozmU.createElement((0, $1B9Aq.default), {
        ...rest,
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hekY6.default)([
            $d3d3f7f5454077a5$var$styles.root,
            className
        ]),
        ref: ref,
        testId: "invited-app-collaborators-tooltip"
    }, children);
});
const $d3d3f7f5454077a5$export$cb6b49c74b6579bc = ({ children: children, currentApsKey: currentApsKey, currentAppCollaborators: currentAppCollaborators })=>{
    const { fireViewedMoreCollaboratorsTooltip: fireViewedMoreCollaboratorsTooltip } = (0, $afGU4.useInvitedAppAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const appMessage = (0, $cozmU.useMemo)(()=>{
        switch(currentApsKey){
            case 'JIRA_SOFTWARE':
                return (0, $4873b942c867c62b$export$defe85febe8b728c).jira;
            case 'CONFLUENCE':
                return (0, $4873b942c867c62b$export$defe85febe8b728c).confluence;
        }
    }, [
        currentApsKey
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        position: "right",
        component: $d3d3f7f5454077a5$var$CustomTooltip,
        onShow: ()=>fireViewedMoreCollaboratorsTooltip({
                app: (0, $5xvpm.getAppKeyByApsKey)(currentApsKey),
                collaborators: currentAppCollaborators.length
            }),
        content: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $4873b942c867c62b$export$defe85febe8b728c).popupCollaboratorsTooltip,
            values: {
                numberOfCollaborators: currentAppCollaborators.length - 1,
                app: formatMessage(appMessage)
            }
        })
    }, children);
};



const $5bb332a674b99b83$var$InvitedAppPopup = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("6YJ24")).then((module)=>({
            default: module.InvitedAppPopup
        })));
// Loading skeleton dimensions, matching the "No collaborators (Skeleton)"
// Figma spec: two stacked lines of equal height and different widths that
// stand in for the popup's title + subtitle text while collaborators load.
const $5bb332a674b99b83$var$SKELETON_LINE_HEIGHT = '12px';
const $5bb332a674b99b83$var$SKELETON_TITLE_WIDTH = '180px';
const $5bb332a674b99b83$var$SKELETON_SUBTITLE_WIDTH = '120px'; /**
                                          * Renders the avatar group + tooltip for the given collaborators.
                                          * Returns `null` when there are no collaborators to show (error / idle / empty
                                          * all collapse to this branch).
                                          */ 
const $5bb332a674b99b83$var$PopupCollaboratorsBody = ({ collaborators: collaborators, currentApsKey: currentApsKey })=>{
    if (collaborators.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
        data: collaborators.map((collaborator)=>({
                ...collaborator,
                appearance: 'circle',
                size: 'medium'
            })),
        maxCount: 2,
        overrides: {
            MoreIndicator: {
                render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3d3f7f5454077a5$export$cb6b49c74b6579bc), {
                        currentApsKey: currentApsKey,
                        currentAppCollaborators: collaborators
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                        ...props,
                        isActive: false,
                        onClick: ()=>{}
                    }))
            }
        }
    }));
};
/**
 * Resolves the collaborator slice + loading flag for a given
 * `CollaboratorsSource`.
 * - `kind: 'static'` — synchronous read from the prop; never loading.
 * - `kind: 'lazy'`   — reads `useInvitedAppCollaboratorsLazy()` and slices
 *   by `app`. `isLoading` is true for every not-yet-resolved state (`idle`
 *   AND `loading`) so the popup shows the skeleton from the first frame
 *   rather than flashing the empty-state text before the fetch starts.
 *   `error` / missing-slice resolve to `[]` with `isLoading: false`.
 */ const $5bb332a674b99b83$var$useResolveCollaborators = (collaboratorsSource)=>{
    // Called unconditionally to keep hook order stable across variants. In
    // experiment mode the provider is not mounted, so this reads the default
    // `{ status: 'idle' }` — no re-renders since its identity is fixed at
    // module load.
    const lazyState = (0, $b38316b21effc154$export$69c89392124bbb84)();
    if (collaboratorsSource.kind === 'static') return {
        collaborators: collaboratorsSource.collaborators,
        isLoading: false
    };
     // Not yet resolved (before the fetch starts, or while it's in flight) —
    // treat both as loading so the popup opens straight into the skeleton.
    if (lazyState.status === 'idle' || lazyState.status === 'loading') return {
        collaborators: [],
        isLoading: true
    };
    if (lazyState.status !== 'ready') return {
        collaborators: [],
        isLoading: false
    };
    return {
        collaborators: lazyState.collaboratorsByApp[collaboratorsSource.app] ?? [],
        isLoading: false
    };
};
/** Resolves collaborators + count + `hasCollaborators` + `isLoading` for the popup. */ const $5bb332a674b99b83$var$useCollaboratorsInfo = (collaboratorsSource)=>{
    const { collaborators: collaborators, isLoading: isLoading } = $5bb332a674b99b83$var$useResolveCollaborators(collaboratorsSource);
    return {
        collaborators: collaborators,
        collaboratorsCount: collaborators.length,
        hasCollaborators: collaborators.length > 0,
        isLoading: isLoading
    };
};
const $5bb332a674b99b83$export$dcca2f78da63545d = ({ collaboratorsSource: collaboratorsSource, currentApsKey: currentApsKey, currentShortcutLink: currentShortcutLink, onAcceptInvite: onAcceptInvite, onMouseEnterPopup: onMouseEnterPopup, onMouseLeavePopup: onMouseLeavePopup, trigger: trigger })=>{
    const { fireLinkClickedAcceptInvite: fireLinkClickedAcceptInvite } = (0, $afGU4.useInvitedAppAnalytics)();
    const { collaborators: collaborators, collaboratorsCount: collaboratorsCount, hasCollaborators: hasCollaborators, isLoading: isLoading } = $5bb332a674b99b83$var$useCollaboratorsInfo(collaboratorsSource);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5bb332a674b99b83$var$InvitedAppPopup, {
        trigger: trigger,
        onMouseEnterPopup: onMouseEnterPopup,
        onMouseLeavePopup: onMouseLeavePopup,
        currentApsKey: currentApsKey,
        hasCollaborators: hasCollaborators,
        collaboratorsCount: collaboratorsCount
    }, isLoading ? // While the lazy collaborators fetch is in flight, show only the
    // loading skeleton — two stacked lines standing in for the title +
    // subtitle text, no descriptive text or accept-invite link.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100",
        testId: "invited-app-collaborators-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: $5bb332a674b99b83$var$SKELETON_TITLE_WIDTH,
        height: $5bb332a674b99b83$var$SKELETON_LINE_HEIGHT,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: $5bb332a674b99b83$var$SKELETON_SUBTITLE_WIDTH,
        height: $5bb332a674b99b83$var$SKELETON_LINE_HEIGHT,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        alignBlock: "start",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, hasCollaborators ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4873b942c867c62b$export$defe85febe8b728c).popupMainTextWithCollaborators) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4873b942c867c62b$export$defe85febe8b728c).popupMainTextWithoutCollaborators)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: currentShortcutLink,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: ()=>{
            const app = (0, $5xvpm.getAppKeyByApsKey)(currentApsKey);
            fireLinkClickedAcceptInvite({
                app: app
            });
            onAcceptInvite(app);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4873b942c867c62b$export$defe85febe8b728c).popupAcceptInviteButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5bb332a674b99b83$var$PopupCollaboratorsBody, {
        collaborators: collaborators,
        currentApsKey: currentApsKey
    }))));
};


const $73d2e10bc3159305$var$DEFAULT_HOVER_DELAY_MS = 300;
const $73d2e10bc3159305$var$DEFAULT_PREFETCH_DEBOUNCE_MS = 100;
const $73d2e10bc3159305$export$80ba7e5efcca528b = ({ shortcutsConfig: shortcutsConfig, resolverResult: resolverResult, hoverDelayTimeMs: hoverDelayTimeMs = $73d2e10bc3159305$var$DEFAULT_HOVER_DELAY_MS, prefetchDebounceMs: prefetchDebounceMs = $73d2e10bc3159305$var$DEFAULT_PREFETCH_DEBOUNCE_MS, excludeLastFromRefs: excludeLastFromRefs = 0, children: children })=>{
    const { fireViewedInvitedAppShortcuts: fireViewedInvitedAppShortcuts } = (0, $afGU4.useInvitedAppAnalytics)();
    const prefetchAll = (0, $b38316b21effc154$export$5c3e277aaa23ea00)();
    const [isPopupShown, setIsPopupShown] = (0, $cozmU.useState)(false);
    const closePopupTimerRef = (0, $cozmU.useRef)(null);
    const jiraShortcutRef = (0, $cozmU.useRef)(null);
    const confluenceShortcutRef = (0, $cozmU.useRef)(null);
    const unbindFunctionsRef = (0, $cozmU.useRef)(new Map());
    const [currentShortcutRef, setCurrentShortcutRef] = (0, $cozmU.useState)();
    const shortcutRefs = (0, $cozmU.useMemo)(()=>({
            JIRA_SOFTWARE: jiraShortcutRef,
            CONFLUENCE: confluenceShortcutRef
        }), []);
    const clearClosePopupTimer = (0, $cozmU.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const hidePopup = (0, $cozmU.useCallback)(()=>{
        setIsPopupShown(false);
        setCurrentShortcutRef(undefined);
    }, []);
    const showPopup = (0, $cozmU.useCallback)(()=>{
        setIsPopupShown(true);
    }, []);
    const startClosePopupTimer = (0, $cozmU.useCallback)(()=>{
        clearClosePopupTimer();
        closePopupTimerRef.current = setTimeout(hidePopup, hoverDelayTimeMs);
    }, [
        clearClosePopupTimer,
        hidePopup,
        hoverDelayTimeMs
    ]); // Debounced singleton prefetch — quick cursor sweeps don't fire the
    // request; an already in-flight HTTP request is never cancelled.
    const debouncedPrefetchAll = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>prefetchAll(), prefetchDebounceMs, {
            leading: false,
            trailing: true
        }), [
        prefetchAll,
        prefetchDebounceMs
    ]);
    (0, $cozmU.useEffect)(()=>()=>debouncedPrefetchAll.cancel(), [
        debouncedPrefetchAll
    ]);
    const handleMouseOverWithRef = (0, $cozmU.useCallback)((targetRef)=>()=>{
            clearClosePopupTimer();
            setCurrentShortcutRef(targetRef);
            showPopup();
            debouncedPrefetchAll();
        }, [
        clearClosePopupTimer,
        showPopup,
        debouncedPrefetchAll
    ]); // Direct handler (no factory) — it doesn't capture per-ref state, so a
    // single stable function can be re-used across both `mouseleave` and
    // `blur` bindings without allocating duplicates per ref.
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        debouncedPrefetchAll.cancel();
        startClosePopupTimer();
    }, [
        startClosePopupTimer,
        debouncedPrefetchAll
    ]);
    const setShortcutRef = (0, $cozmU.useCallback)((targetRef)=>(node)=>{
            const existing = unbindFunctionsRef.current.get(targetRef);
            if (existing) {
                existing();
                unbindFunctionsRef.current.delete(targetRef);
            } // oxlint-disable-next-line no-param-reassign
            targetRef.current = node;
            if (node) {
                const mouseoverListener = handleMouseOverWithRef(targetRef);
                const focusListener = handleMouseOverWithRef(targetRef);
                const unbind = (0, $cbY7C.bindAll)(node, [
                    {
                        type: 'mouseover',
                        listener: mouseoverListener
                    },
                    {
                        type: 'focus',
                        listener: focusListener
                    },
                    {
                        type: 'mouseleave',
                        listener: handleMouseLeave
                    },
                    {
                        type: 'blur',
                        listener: handleMouseLeave
                    }
                ]);
                unbindFunctionsRef.current.set(targetRef, unbind);
            }
        }, [
        handleMouseOverWithRef,
        handleMouseLeave
    ]);
    const handleOnMouseEnterPopup = (0, $cozmU.useCallback)(()=>{
        clearClosePopupTimer();
        if (currentShortcutRef?.current) {
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = "var(--ds-surface-hovered, #F0F1F2)";
        }
        showPopup();
    }, [
        clearClosePopupTimer,
        showPopup,
        currentShortcutRef
    ]);
    const handleOnMouseLeavePopup = (0, $cozmU.useCallback)(()=>{
        if (currentShortcutRef?.current) {
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = '';
        }
        startClosePopupTimer();
    }, [
        currentShortcutRef,
        startClosePopupTimer
    ]);
    const referrableShortcuts = (0, $cozmU.useMemo)(()=>{
        const entries = Object.entries(shortcutsConfig);
        const max = Math.min(entries.length, Object.values(resolverResult.invitedApps ?? {}).filter((app)=>app?.eligible).length);
        const refsLimit = max - excludeLastFromRefs;
        let createdRefsCount = 0;
        return entries.reduce((acc, [key, shortcut])=>{
            if (createdRefsCount < refsLimit && shortcut.type === 'link' && shortcut.apsKey && resolverResult.invitedApps?.[(0, $5xvpm.getAppKeyByApsKey)(shortcut.apsKey)]?.eligible) {
                const apsKey = shortcut.apsKey;
                const targetRef = shortcutRefs[apsKey];
                acc[key] = {
                    ...shortcut,
                    ref: targetRef ? setShortcutRef(targetRef) : undefined,
                    labelElem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81a0f55aa5e72ab7$export$f60dc2630a14000a), {
                        apsKey: apsKey,
                        label: shortcut.label
                    })
                }; // oxlint-disable-next-line no-plusplus
                createdRefsCount++;
            } else acc[key] = shortcut;
            return acc;
        }, {});
    }, [
        shortcutsConfig,
        resolverResult.invitedApps,
        excludeLastFromRefs,
        shortcutRefs,
        setShortcutRef
    ]);
    const currentApsKey = (0, $cozmU.useMemo)(()=>{
        const entry = Object.entries(shortcutRefs).find(([, ref])=>ref === currentShortcutRef);
        return entry ? entry[0] : undefined;
    }, [
        currentShortcutRef,
        shortcutRefs
    ]);
    const currentApp = currentApsKey ? (0, $5xvpm.getAppKeyByApsKey)(currentApsKey) : undefined;
    const collaboratorsSource = (0, $cozmU.useMemo)(()=>currentApp ? {
            kind: 'lazy',
            app: currentApp
        } : undefined, [
        currentApp
    ]);
    const handleAcceptInvite = (0, $cozmU.useCallback)((app)=>resolverResult?.registerActivation(app), [
        resolverResult
    ]);
    const currentShortcutLink = (0, $cozmU.useMemo)(()=>currentShortcutRef?.current?.href, [
        currentShortcutRef
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            unbindFunctionsRef.current.forEach((unbind)=>unbind());
            unbindFunctionsRef.current.clear();
            clearClosePopupTimer();
        }, [
        clearClosePopupTimer
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Collect target-app keys for shortcuts we attached a ref to. Mirrors
        // the Inner reducer pattern; analytics signature expects target-app
        // keys (e.g. `confluence` / `jira`) not aps keys.
        const invitedAppShortcutKeys = Object.values(referrableShortcuts).reduce((acc, shortcut)=>{
            if (shortcut.type === 'link' && (0, $5xvpm.isAllowedApsKey)(shortcut.apsKey) && !!shortcut.ref) acc.push((0, $5xvpm.getAppKeyByApsKey)(shortcut.apsKey));
            return acc;
        }, []);
        if (invitedAppShortcutKeys.length > 0) // Productionisation mode: Post Office owns impressions, so the
        // "first impressed" list is always empty — pass `[]` to keep the
        // analytics signature intact.
        fireViewedInvitedAppShortcuts(invitedAppShortcutKeys, []);
    }, [
        referrableShortcuts,
        fireViewedInvitedAppShortcuts
    ]); // Productionisation mode: impressions are owned by Post Office. The
    // productionisation hook never sets `firstImpressionAt`, so the legacy
    // `impressedProducts` flags are always `false` here by construction.
    const contextValue = (0, $cozmU.useMemo)(()=>({
            impressedProducts: {
                JIRA_SOFTWARE: false,
                CONFLUENCE: false
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18040aad49f819dd$export$a5c3144306783a42).Provider, {
        value: contextValue
    }, children({
        referrableShortcuts: referrableShortcuts
    }), isPopupShown && currentShortcutRef && currentShortcutLink && currentApsKey && collaboratorsSource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5bb332a674b99b83$export$dcca2f78da63545d), {
        trigger: currentShortcutRef,
        onMouseEnterPopup: handleOnMouseEnterPopup,
        onMouseLeavePopup: handleOnMouseLeavePopup,
        currentApsKey: currentApsKey,
        collaboratorsSource: collaboratorsSource,
        currentShortcutLink: currentShortcutLink,
        onAcceptInvite: handleAcceptInvite
    }));
};






var $3H3Mp = parcelRequire("3H3Mp");





/**
 * Narrows a BFF `CollaboratorProduct` to the subset accepted by
 * `InvitedAppShortcutAllowedTargetAppKey`. Both describe `'jira' | 'confluence'`
 * today; this isolates the cast so the call site stays cast-free, and any
 * future BFF-only product is filtered out at runtime.
 */ const $91347877233fc6d6$var$isAllowedTargetApp = (product, allowed)=>allowed.includes(product);
const $91347877233fc6d6$export$86a637885215f4b1 = ({ cloudId: cloudId, userId: userId, eligibleApps: eligibleApps, sourceApp: sourceApp, children: children })=>{
    const analytics = (0, $afGU4.useInvitedAppAnalytics)();
    const [state, setState] = (0, $cozmU.useState)(()=>eligibleApps.length === 0 ? {
            status: 'ready',
            collaboratorsByApp: {}
        } : {
            status: 'idle'
        });
    // Singleton guard. Cleared on `.catch` for retry; kept after `.then`
    // so a successful fetch is never re-issued.
    const inFlightRef = (0, $cozmU.useRef)(null);
    // Prevents state updates after unmount.
    const isMountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>()=>{
            isMountedRef.current = false;
        }, []);
    // Latest-props ref keeps `prefetchAll` identity-stable so an unmemoised
    // `eligibleApps` array doesn't invalidate hover handlers downstream.
    const depsRef = (0, $cozmU.useRef)({
        analytics: analytics,
        cloudId: cloudId,
        eligibleApps: eligibleApps,
        sourceApp: sourceApp,
        userId: userId
    });
    depsRef.current = {
        analytics: analytics,
        cloudId: cloudId,
        eligibleApps: eligibleApps,
        sourceApp: sourceApp,
        userId: userId
    };
    const prefetchAll = (0, $cozmU.useCallback)(()=>{
        if (inFlightRef.current !== null) return;
        const { analytics: analytics, cloudId: cloudId, eligibleApps: eligibleApps, sourceApp: sourceApp, userId: userId } = depsRef.current;
        if (eligibleApps.length === 0) // Nothing to fetch; provider is already in the `ready` empty state.
        return;
        setState({
            status: 'loading'
        });
        // Cross-validated against `InvitedAppShortcutAllowedTargetAppKey` inside
        // the response loop via `isAllowedTargetApp`. Any future BFF-only
        // product will be filtered out, never indexed into `collaboratorsByApp`.
        const products = eligibleApps;
        // Guard against a synchronous throw before the Promise is created —
        // otherwise `setState('loading')` would leave the provider stuck.
        let pending;
        try {
            pending = (0, $3H3Mp.getCollaboratorsInProducts)({
                cloudId: cloudId,
                userId: userId,
                products: products
            });
        } catch (error) {
            inFlightRef.current = null;
            if (!isMountedRef.current) return;
            setState({
                status: 'error',
                error: error
            });
            analytics.fireFetchCollaboratorsAccessFailed({
                sourceApp: sourceApp,
                targetApps: eligibleApps,
                error: error instanceof Error ? error.message : 'unknown'
            });
            return;
        }
        inFlightRef.current = pending.then((rows)=>{
            if (!isMountedRef.current) return;
            const collaboratorsByApp = {};
            for (const { collaborator: collaborator, products: collaboratorProducts } of rows)for (const product of collaboratorProducts){
                if (!$91347877233fc6d6$var$isAllowedTargetApp(product, eligibleApps)) continue;
                // `product` is narrowed to `InvitedAppShortcutAllowedTargetAppKey`.
                const slice = collaboratorsByApp[product] ?? [];
                slice.push({
                    key: collaborator.id,
                    name: collaborator.name,
                    src: collaborator.avatar
                });
                collaboratorsByApp[product] = slice;
            }
            setState({
                status: 'ready',
                collaboratorsByApp: collaboratorsByApp
            });
            analytics.fireFetchCollaboratorsAccessSucceeded({
                sourceApp: sourceApp,
                targetApps: eligibleApps,
                collaborators: rows.length
            });
        }).catch((error)=>{
            // Allow caller-driven retry on the next hover when the fetch
            // failed (network blip, 5xx, etc.). Successful fetches keep
            // the ref set so they are not re-issued.
            inFlightRef.current = null;
            if (!isMountedRef.current) return;
            setState({
                status: 'error',
                error: error
            });
            analytics.fireFetchCollaboratorsAccessFailed({
                sourceApp: sourceApp,
                targetApps: eligibleApps,
                // Normalize to avoid leaking raw server error detail into analytics.
                error: error instanceof Error ? error.message : 'unknown'
            });
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b38316b21effc154$export$66a70772711988d1).Provider, {
        value: prefetchAll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b38316b21effc154$export$437ae3f50102760d).Provider, {
        value: state
    }, children));
};




class $31e56fce7833b94e$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, _errorInfo) {
        this.props.fireInvitedAppShortcutsContainerRenderFailed({
            error: error.message,
            errorStack: error.stack,
            targetApps: Object.values(this.props.shortcutsConfig).map((shortcut)=>shortcut.analyticsName).filter(Boolean)
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback({
            referrableShortcuts: this.props.shortcutsConfig
        });
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $31e56fce7833b94e$var$InvitedAppShortcutsContainerExperiment = ({ shortcutsConfig: shortcutsConfig, resolverResult: resolverResult, hoverDelayTimeMs: hoverDelayTimeMs = 300, excludeLastFromRefs: excludeLastFromRefs = 0, children: children })=>{
    const { fireViewedInvitedAppShortcuts: fireViewedInvitedAppShortcuts } = (0, $afGU4.useInvitedAppAnalytics)(); // the popup shown state
    const [isPopupShown, setIsPopupShown] = (0, $cozmU.useState)(false);
    const closePopupTimerRef = (0, $cozmU.useRef)(null); // refs for the shortcut items
    const jiraShortcutRef = (0, $cozmU.useRef)(null);
    const confluenceShortcutRef = (0, $cozmU.useRef)(null); // Store unbind functions for cleanup
    const unbindFunctionsRef = (0, $cozmU.useRef)(new Map()); // Ref for the current shortcut item
    // the current shortcut item is unset when the popup is hidden after a delay
    const [currentShortcutRef, setCurrentShortcutRef] = (0, $cozmU.useState)(); // map of the shortcut items to their refs
    const shortcutRefs = (0, $cozmU.useMemo)(()=>({
            JIRA_SOFTWARE: jiraShortcutRef,
            CONFLUENCE: confluenceShortcutRef
        }), // Refs are stable, no dependencies needed
    []);
    const showPopup = (0, $cozmU.useCallback)(()=>{
        setIsPopupShown(true);
    }, [
        setIsPopupShown
    ]);
    const hidePopup = (0, $cozmU.useCallback)(()=>{
        setIsPopupShown(false);
        setCurrentShortcutRef(undefined);
    }, [
        setIsPopupShown,
        setCurrentShortcutRef
    ]);
    const clearClosePopupTimer = (0, $cozmU.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const startClosePopupTimer = (0, $cozmU.useCallback)(()=>{
        clearClosePopupTimer();
        closePopupTimerRef.current = setTimeout(()=>{
            hidePopup();
        }, hoverDelayTimeMs);
    }, [
        clearClosePopupTimer,
        hoverDelayTimeMs,
        hidePopup
    ]); /**
                                                            * @param targetRef - the ref to the shortcut item
                                                            * @returns a handler for the mouse over event on the shortcut item
                                                            */ 
    const handleMouseOverWithRef = (0, $cozmU.useCallback)((targetRef)=>()=>{
            // clear the close popup timer to avoid closing the popup
            // when moving the mouse from the popup to the shortcut item
            clearClosePopupTimer();
            setCurrentShortcutRef(targetRef);
            showPopup();
        }, [
        clearClosePopupTimer,
        showPopup
    ]); /**
                                          * @param targetRef - the ref to the shortcut item
                                          * @returns a handler for the mouse leave event on the shortcut item
                                          */ 
    const handleMouseLeaveWithRef = (0, $cozmU.useCallback)(()=>()=>{
            if (currentShortcutRef?.current) currentShortcutRef.current.style.backgroundColor = '';
            startClosePopupTimer();
        }, [
        currentShortcutRef,
        startClosePopupTimer
    ]); /**
                                                   * @param targetRef - the ref to the shortcut item
                                                   * @returns a callback ref for a shortcut item
                                                   */ 
    const createShortcutRef = (0, $cozmU.useCallback)((targetRef)=>(node)=>{
            // Cleanup previous element if it exists
            const existingUnbind = unbindFunctionsRef.current.get(targetRef);
            if (existingUnbind) {
                existingUnbind();
                unbindFunctionsRef.current.delete(targetRef);
            } // Store the new element
            // oxlint-disable-next-line no-param-reassign
            targetRef.current = node; // Attach listeners to new element
            if (node) {
                const mouseoverListener = handleMouseOverWithRef(targetRef);
                const focusListener = handleMouseOverWithRef(targetRef);
                const mouseleaveListener = handleMouseLeaveWithRef();
                const blurListener = handleMouseLeaveWithRef(); // Use bind-event-listener to bind all events and get an unbind function
                const unbind = (0, $cbY7C.bindAll)(node, [
                    {
                        type: 'mouseover',
                        listener: mouseoverListener
                    },
                    {
                        type: 'focus',
                        listener: focusListener
                    },
                    {
                        type: 'mouseleave',
                        listener: mouseleaveListener
                    },
                    {
                        type: 'blur',
                        listener: blurListener
                    }
                ]); // Store the unbind function for cleanup
                unbindFunctionsRef.current.set(targetRef, unbind);
            }
        }, [
        handleMouseOverWithRef,
        handleMouseLeaveWithRef
    ]); /**
                                                          * Handles the popup shown event
                                                          * @returns a handler for the popup shown event
                                                          */ 
    const handleOnMouseEnterPopup = (0, $cozmU.useCallback)(()=>{
        // clear the close popup timer to avoid closing the popup too early
        clearClosePopupTimer();
        if (currentShortcutRef?.current) {
            // Get the parent element of the shortcut item
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) // reference the background color variable from the design system
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/4ff76dcfb3ce12b4344e5345be748ce472ac56e7/platform/packages/design-system/navigation-system/src/ui/menu-item/menu-item.tsx#lines-166
            parentElement.style.backgroundColor = "var(--ds-surface-hovered, #F0F1F2)";
        } // ensure the popup is shown when mouse leaves the shortcut item and over the popup
        showPopup();
    }, [
        clearClosePopupTimer,
        showPopup,
        currentShortcutRef
    ]); /**
                                                              * Handles the popup closed event
                                                              * @returns a handler for the popup closed event
                                                              */ 
    const handleOnMouseLeavePopup = (0, $cozmU.useCallback)(()=>{
        if (currentShortcutRef?.current) {
            // Get the parent element of the shortcut item
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = '';
        }
        startClosePopupTimer();
    }, [
        currentShortcutRef,
        startClosePopupTimer
    ]);
    const referrableShortcuts = (0, $cozmU.useMemo)(()=>{
        const entries = Object.entries(shortcutsConfig);
        const max = Math.min(entries.length, Object.values(resolverResult.invitedApps ?? {}).filter((app)=>app?.eligible).length);
        const refsLimit = max - excludeLastFromRefs;
        let createdRefsCount = 0;
        return entries.reduce((acc, [key, shortcut])=>{
            // only add ref to shortcuts that are within the refs limit
            // and if it is a link and the aps key is allowed
            if (createdRefsCount < refsLimit && shortcut.type === 'link' && shortcut.apsKey && resolverResult.invitedApps?.[(0, $5xvpm.getAppKeyByApsKey)(shortcut.apsKey)]?.eligible) {
                const apsKey = shortcut.apsKey;
                const app = (0, $5xvpm.getAppKeyByApsKey)(apsKey);
                const targetRef = shortcutRefs[apsKey];
                const originalOnClick = shortcut.onClick;
                acc[key] = {
                    ...shortcut,
                    onClick: (evt)=>{
                        resolverResult.registerActivation(app);
                        return originalOnClick?.(evt);
                    },
                    ref: targetRef ? createShortcutRef(targetRef) : undefined,
                    labelElem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81a0f55aa5e72ab7$export$f60dc2630a14000a), {
                        apsKey: apsKey,
                        label: shortcut.label
                    })
                }; // oxlint-disable-next-line no-plusplus
                createdRefsCount++;
            } else acc[key] = shortcut;
            return acc;
        }, {});
    }, [
        shortcutsConfig,
        resolverResult,
        createShortcutRef,
        shortcutRefs,
        excludeLastFromRefs
    ]);
    (0, $cozmU.useEffect)(()=>{
        const currentUnbindFunctions = unbindFunctionsRef.current;
        const currentShortcutRefs = shortcutRefs;
        return ()=>{
            // Clean up all event listeners using the stored unbind functions
            Object.values(currentShortcutRefs).forEach((ref)=>{
                const unbind = currentUnbindFunctions.get(ref);
                if (unbind) {
                    unbind();
                    currentUnbindFunctions.delete(ref);
                }
            });
            clearClosePopupTimer();
        };
    }, [
        clearClosePopupTimer,
        shortcutRefs
    ]);
    const currentApsKey = (0, $cozmU.useMemo)(()=>Object.keys(shortcutRefs).find((apsKey)=>currentShortcutRef?.current === shortcutRefs[apsKey]?.current), [
        shortcutRefs,
        currentShortcutRef
    ]);
    const currentAppKey = currentApsKey && (0, $5xvpm.getAppKeyByApsKey)(currentApsKey);
    const currentAppResolved = currentAppKey && resolverResult.invitedApps?.[currentAppKey];
    const currentAppCollaborators = (0, $cozmU.useMemo)(()=>currentAppResolved?.collaborators?.map((collab)=>({
                name: '',
                src: collab?.avatar
            })) ?? [], [
        currentAppResolved?.collaborators
    ]); // Stable identity for the popup's discriminated union prop so the popup
    // boundary stays memo-friendly (avoids re-renders on unrelated container
    // updates). PUMA-1997 will introduce a `kind: 'lazy'` branch here.
    const collaboratorsSource = (0, $cozmU.useMemo)(()=>({
            kind: 'static',
            collaborators: currentAppCollaborators
        }), [
        currentAppCollaborators
    ]); // Stable callback for the popup's accept-invite click. Re-created only
    // when `resolverResult` identity changes.
    const handleAcceptInvite = (0, $cozmU.useCallback)((app)=>resolverResult?.registerActivation(app), [
        resolverResult
    ]);
    const currentShortcutLink = (0, $cozmU.useMemo)(()=>currentShortcutRef?.current?.href, [
        currentShortcutRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        // These are the app keys for which we'll be displaying our treatment
        const invitedAppShortcutKeys = Object.values(referrableShortcuts).reduce((acc, shortcut)=>{
            if (shortcut.type === 'link' && (0, $5xvpm.isAllowedApsKey)(shortcut.apsKey) && !!shortcut.ref) acc.push((0, $5xvpm.getAppKeyByApsKey)(shortcut.apsKey));
            return acc;
        }, []);
        resolverResult.registerImpression({
            products: invitedAppShortcutKeys
        }); // Fire an analytics event when the user views the invited app shortcuts
        if (invitedAppShortcutKeys.length > 0) {
            const firstImpressedApps = invitedAppShortcutKeys.filter((app)=>!resolverResult.invitedApps?.[app]?.firstImpressionAt);
            fireViewedInvitedAppShortcuts(invitedAppShortcutKeys, firstImpressedApps);
        }
    }, [
        referrableShortcuts,
        resolverResult,
        fireViewedInvitedAppShortcuts
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18040aad49f819dd$export$a5c3144306783a42).Provider, {
        value: (0, $cozmU.useMemo)(()=>({
                impressedProducts: {
                    JIRA_SOFTWARE: $31e56fce7833b94e$var$isAppImpressed(resolverResult.invitedApps?.jira),
                    CONFLUENCE: $31e56fce7833b94e$var$isAppImpressed(resolverResult.invitedApps?.confluence)
                }
            }), [
            resolverResult.invitedApps
        ])
    }, children({
        referrableShortcuts: referrableShortcuts
    }), isPopupShown && currentShortcutRef && currentShortcutLink && currentApsKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5bb332a674b99b83$export$dcca2f78da63545d), {
        trigger: currentShortcutRef,
        onMouseEnterPopup: handleOnMouseEnterPopup,
        onMouseLeavePopup: handleOnMouseLeavePopup,
        currentApsKey: currentApsKey,
        collaboratorsSource: collaboratorsSource,
        currentShortcutLink: currentShortcutLink,
        onAcceptInvite: handleAcceptInvite
    }));
};
const $31e56fce7833b94e$export$a06354f64c80dd3d = (props)=>{
    const { fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed } = (0, $afGU4.useInvitedAppAnalytics)(); // Branch first on the discriminant so each branch destructures with
    // full type narrowing (no `as` cast, no IIFE).
    if (props.mode === 'productionisation') {
        const { mode: _mode, cloudId: cloudId, userId: userId, recommendedApps: recommendedApps, sourceApp: sourceApp, ...inner } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($31e56fce7833b94e$var$ErrorBoundary, {
            fallback: inner.children,
            shortcutsConfig: inner.shortcutsConfig,
            fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91347877233fc6d6$export$86a637885215f4b1), {
            cloudId: cloudId,
            userId: userId,
            eligibleApps: recommendedApps,
            sourceApp: sourceApp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73d2e10bc3159305$export$80ba7e5efcca528b), inner)));
    }
    const { mode: _mode, ...inner } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($31e56fce7833b94e$var$ErrorBoundary, {
        fallback: inner.children,
        shortcutsConfig: inner.shortcutsConfig,
        fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($31e56fce7833b94e$var$InvitedAppShortcutsContainerExperiment, inner));
};
const $31e56fce7833b94e$var$isAppImpressed = (appDetails)=>!!appDetails?.firstImpressionAt;
module.exports["InvitedAppShortcutsContainer"] = $31e56fce7833b94e$export$a06354f64c80dd3d;

});

parcelRegister("5xvpm", function(module, exports) {

var $5yEp5 = parcelRequire("5yEp5");

const $3438d3c23d3dc967$export$f45e7800f1f61594 = (apsKey)=>{
    if (!apsKey) return false;
    return (0, $5yEp5.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS).includes(apsKey);
};
const $3438d3c23d3dc967$export$ab70dfefed87a731 = (targetApp)=>{
    if (!targetApp) return false;
    return (0, $5yEp5.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS).includes(targetApp);
};
const $3438d3c23d3dc967$export$b8c071b2cc567f75 = (apsKey)=>{
    switch(apsKey){
        case 'JIRA_SOFTWARE':
            return 'jira';
        case 'CONFLUENCE':
            return 'confluence';
        default:
            // This should never happen, throw it just in case if we add a new APS key without adding a new app key
            throw new Error(`Invalid APS key: ${apsKey}`);
    }
};
module.exports["isAllowedApsKey"] = $3438d3c23d3dc967$export$f45e7800f1f61594;
module.exports["isAllowedTargetAppForInvitedAppShortcuts"] = $3438d3c23d3dc967$export$ab70dfefed87a731;
module.exports["getAppKeyByApsKey"] = $3438d3c23d3dc967$export$b8c071b2cc567f75;

});

parcelRegister("afGU4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fmu9K = parcelRequire("fmu9K");


var $9DHhW = parcelRequire("9DHhW");


var $7dBf8 = parcelRequire("7dBf8");

const $0d7db9ca463f83df$export$85183a312807388d = (0, $fmu9K.FabricChannel).growth;
const $0d7db9ca463f83df$export$43a7f5e28cb0f314 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isViewedInvitedAppShortcutsFired = (0, $cozmU.useRef)(false);
    return (0, $cozmU.useMemo)(()=>({
            /**
			 * Fire an analytics event when the user views the invited app shortcuts.
			 */ fireViewedInvitedAppShortcuts: (apps, firstImpressedApps)=>{
                if (isViewedInvitedAppShortcutsFired.current) return;
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'invitedAppShortcuts',
                    attributes: {
                        apps: apps,
                        firstImpressedApps: firstImpressedApps
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
                isViewedInvitedAppShortcutsFired.current = true;
            },
            fireViewedInvitedAppShortcutPopup: ({ app: app, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'invitedAppShortcutPopup',
                    attributes: {
                        app: app,
                        collaborators: collaborators
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            fireLinkClickedAcceptInvite: ({ app: app })=>{
                createAnalyticsEvent({
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'acceptInvite',
                    attributes: {
                        app: app
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            fireViewedMoreCollaboratorsTooltip: ({ app: app, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'moreCollaboratorsTooltip',
                    attributes: {
                        app: app,
                        collaborators: collaborators
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            /**
			 * Fire an analytics event when eligibility for invited app shortcuts is checked.
			 *
			 * This event is deduplicated across sessions using a hashed key stored in local storage.
			 * If the combination of userId, cloudId, and ineligibilityReason has not changed since the
			 * last time the event was fired, subsequent calls are suppressed — even after page reloads.
			 *
			 * @param ineligibilityReason - the reason the user is ineligible
			 * @param userId - the current user's ID
			 * @param cloudId - the current cloud/site ID
			 */ fireInvitedAppShortcutsEligibilityChecked: async ({ ineligibilityReason: ineligibilityReason, userId: userId, cloudId: cloudId })=>{
                const rawCacheKey = `${userId ?? ''}:${cloudId ?? ''}:${ineligibilityReason}`;
                if (await $0d7db9ca463f83df$var$hasAlreadyBeenFired($0d7db9ca463f83df$var$ELIGIBILITY_CHECKED_STORAGE_KEY, rawCacheKey)) return;
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'checked',
                    actionSubject: 'eligibility',
                    attributes: {
                        flagKey: 'twcg-460-personalised-invite-notifications-m2',
                        ineligibilityReason: ineligibilityReason
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
                await $0d7db9ca463f83df$var$markAsFired($0d7db9ca463f83df$var$ELIGIBILITY_CHECKED_STORAGE_KEY, rawCacheKey);
            },
            /**
			 * Fire an analytics event when the feature is exposed.
			 *
			 * This event is deduplicated across sessions using a hashed key stored in local storage.
			 * If the combination of userId, cloudId, and isEnabled has not changed since the last time
			 * the event was fired, subsequent calls are suppressed — even after page reloads.
			 *
			 * When the event fires, the eligibility-checked storage key is also cleared so that
			 * eligibility is re-evaluated after the user enters the experiment.
			 *
			 * @param isEnabled - the experiment's isEnabled value
			 * @param userId - the current user's ID
			 * @param cloudId - the current cloud/site ID
			 */ fireFeatureExposed: async ({ isEnabled: isEnabled, userId: userId, cloudId: cloudId, mode: mode })=>{
                // Include the current date (YYYY-MM-DD) so the event fires at most once per day
                const today = new Date().toISOString().split('T')[0];
                const rawCacheKey = `${userId ?? ''}:${cloudId ?? ''}:${String(isEnabled)}:${today}`;
                if (await $0d7db9ca463f83df$var$hasAlreadyBeenFired($0d7db9ca463f83df$var$FEATURE_EXPOSED_STORAGE_KEY, rawCacheKey)) return;
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: {
                        featureKey: mode === 'experiment' ? 'twcg-460-personalised-invite-notifications-m2' : 'twcg-460-preload-grs-invited-app-shortcuts',
                        cohort: isEnabled ? 'variant' : 'control',
                        mode: mode
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
                await $0d7db9ca463f83df$var$markAsFired($0d7db9ca463f83df$var$FEATURE_EXPOSED_STORAGE_KEY, rawCacheKey);
                // Clear the eligibility checked flag since the feature is now exposed,
                // so that the next eligibility check will fire.
                $0d7db9ca463f83df$var$clearStorageKey($0d7db9ca463f83df$var$ELIGIBILITY_CHECKED_STORAGE_KEY);
            },
            fireFetchInvitedAppShortcutsTraitsSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'fetchInvitedAppShortcutsTraits',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            fireFetchInvitedAppShortcutsTraitsFailed: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'fetchInvitedAppShortcutsTraits',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            fireFetchCollaboratorsAccessSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'fetchCollaboratorsAccess',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        collaborators: collaborators
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            fireFetchCollaboratorsAccessFailed: ({ sourceApp: sourceApp, targetApps: targetApps, error: error })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'fetchCollaboratorsAccess',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        error: error
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            fireEligibilityUpdateSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'eligibilityUpdate',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            fireEligibilityUpdateFailed: ({ sourceApp: sourceApp, targetApps: targetApps, error: error })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'eligibilityUpdate',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        error: error
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            fireInvitedAppShortcutsContainerRenderFailed: ({ targetApps: targetApps, error: error, errorStack: errorStack })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'invitedAppShortcutsContainerRender',
                    attributes: {
                        targetApps: targetApps,
                        error: error,
                        errorStack: errorStack
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            fireAppAccessRemoved: ({ targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'removed',
                    actionSubject: 'appAccess',
                    attributes: {
                        targetApps: targetApps
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            },
            fireViewedAnimatedLozenge: ({ app: app })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'animatedLozenge',
                    attributes: {
                        app: app
                    }
                }).fire($0d7db9ca463f83df$export$85183a312807388d);
            }
        }), [
        createAnalyticsEvent
    ]);
};
// ── Cross-session analytics dedup helpers ──────────────────────────────────────
//
// These helpers store a hashed fingerprint in local storage so that analytics
// events are only fired once per unique combination of parameters — even across
// page reloads. Each event type has its own storage key so they can be checked
// and cleared independently.
const $0d7db9ca463f83df$var$ELIGIBILITY_CHECKED_STORAGE_KEY = 'invitedAppShortcuts.eligibilityChecked';
const $0d7db9ca463f83df$var$FEATURE_EXPOSED_STORAGE_KEY = 'invitedAppShortcuts.featureExposed';
// In-memory cache of the latest hash written per analytics storage key.
// This preserves dedupe within the current page session even if localStorage fails.
const $0d7db9ca463f83df$var$firedHashByStorageKey = new Map();
// Circuit breaker for browser storage writes.
// Once a storage write throws (e.g. quota exceeded), we stop touching localStorage
// and fall back to in-memory dedupe only to avoid repeated runtime errors.
let $0d7db9ca463f83df$var$shouldUseLocalStorage = true;
/**
 * Produces a non-reversible hash of the given raw string so we never store
 * plain-text identifiers in local storage.
 *
 * Prefers SHA-256 via the Web Crypto API when available, otherwise falls back
 * to a synchronous FNV-1a 32-bit hash for environments where the Web Crypto API
 * is not supported.
 *
 * @param raw - the raw string to hash
 * @returns a hex-encoded hash string
 */ async function $0d7db9ca463f83df$var$hashString(raw) {
    // Primary path: SHA-256 via the Web Crypto API.
    // crypto.subtle is available in all modern browsers but requires a secure context (HTTPS).
    // It may be unavailable in:
    //   - Non-HTTPS pages (e.g. http://localhost without a secure context flag)
    //   - SSR / Node environments where the Web Crypto API is not globally available
    //   - Very old browsers (pre-Chrome 37, pre-Firefox 34, pre-Safari 11)
    if (typeof crypto !== 'undefined' && crypto.subtle) try {
        const data = new TextEncoder().encode(raw);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch  {
    // Fall through to the fallback hash
    }
    // Fallback: FNV-1a 32-bit hash.
    // Not cryptographically secure, but sufficient to avoid storing plain-text
    // identifiers in local storage. This path is only reached when the Web Crypto
    // API is unavailable (see conditions above) or throws unexpectedly.
    let hash = 0x811c9dc5;
    for(let i = 0; i < raw.length; i++){
        hash ^= raw.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(16);
}
/**
 * Checks whether an analytics event has already been fired for the given
 * parameters by comparing a hashed fingerprint stored under `storageKey`.
 *
 * @param storageKey - the local storage key to read from
 * @param raw - the raw string representing the current parameter combination
 * @returns `true` if the stored hash matches, meaning the event should be suppressed.
 *          Returns `false` on any storage error.
 */ async function $0d7db9ca463f83df$var$hasAlreadyBeenFired(storageKey, raw) {
    try {
        const hashed = await $0d7db9ca463f83df$var$hashString(raw);
        if ($0d7db9ca463f83df$var$firedHashByStorageKey.get(storageKey) === hashed) return true;
        if (!$0d7db9ca463f83df$var$shouldUseLocalStorage) return false;
        const stored = (0, $7dBf8.AtlBrowserStorageLocal).getItem(storageKey);
        return stored === hashed;
    } catch  {
        return false;
    }
}
/**
 * Persists a hashed fingerprint so that future calls to {@link hasAlreadyBeenFired}
 * with the same `storageKey` and `raw` value will return `true`.
 *
 * Storage errors (e.g. private browsing, quota exceeded) are silently ignored.
 *
 * @param storageKey - the local storage key to write to
 * @param raw - the raw string representing the current parameter combination
 */ async function $0d7db9ca463f83df$var$markAsFired(storageKey, raw) {
    try {
        const hashed = await $0d7db9ca463f83df$var$hashString(raw);
        // Always keep an in-memory copy so we can still dedupe within a page session
        // even when browser storage is unavailable or full.
        $0d7db9ca463f83df$var$firedHashByStorageKey.set(storageKey, hashed);
        if (!$0d7db9ca463f83df$var$shouldUseLocalStorage) return;
        await (0, $7dBf8.AtlBrowserStorageLocal).setItem(storageKey, hashed);
    } catch  {
        // Storage quota/state can change at runtime (e.g. low storage, private mode).
        // Disable future localStorage writes to avoid repeated runtime errors.
        $0d7db9ca463f83df$var$shouldUseLocalStorage = false;
    // Silently ignore storage errors (e.g. private browsing, quota exceeded)
    }
}
/**
 * Removes the stored fingerprint for the given storage key, allowing the
 * corresponding event to fire again regardless of previous parameters.
 *
 * @param storageKey - the local storage key to clear
 */ function $0d7db9ca463f83df$var$clearStorageKey(storageKey) {
    try {
        $0d7db9ca463f83df$var$firedHashByStorageKey.delete(storageKey);
        if (!$0d7db9ca463f83df$var$shouldUseLocalStorage) return;
        (0, $7dBf8.AtlBrowserStorageLocal).removeItem(storageKey);
    } catch  {
    // Silently ignore storage errors
    }
}
module.exports["useInvitedAppAnalytics"] = $0d7db9ca463f83df$export$43a7f5e28cb0f314;

});

parcelRegister("kT3wS", function(module, exports) {

let $f34bae8426b3aa1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f34bae8426b3aa1c$var$load("kd8Gw").then(()=>parcelRequire('chjT2'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("6YJ24", function(module, exports) {

let $514b472d53b42c8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $514b472d53b42c8c$var$load("ko1nX").then(()=>parcelRequire('78NWo'));

});

parcelRegister("fIjXZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cXPtd = parcelRequire("cXPtd");


var $5xvpm = parcelRequire("5xvpm");

const $12209e126664a47e$export$f96c96985b06f150 = ({ shortcutItemsConfig: shortcutItemsConfig, getCachedProductLinks: getCachedProductLinks, updateHydratedProductLinks: updateHydratedProductLinks })=>{
    const invitedAppProductLinks = (0, $cozmU.useMemo)(()=>$12209e126664a47e$var$resolveCachedInvitedAppProductLinks(shortcutItemsConfig, getCachedProductLinks), [
        shortcutItemsConfig,
        getCachedProductLinks
    ]);
    /**
	 * Update invited app product links when getFilteredProductLinks changes
	 */ const handleUpdateInvitedAppProductLinks = (0, $cozmU.useCallback)((getFilteredProductLinks)=>{
        if (typeof getFilteredProductLinks === 'function') {
            const hydratedLinks = $12209e126664a47e$var$resolveInvitedAppProductLinks(getFilteredProductLinks, shortcutItemsConfig);
            if (Object.keys(hydratedLinks).length > 0) updateHydratedProductLinks($12209e126664a47e$var$toProductLinksByProduct(hydratedLinks));
        }
    }, [
        shortcutItemsConfig,
        updateHydratedProductLinks
    ]);
    /**
	 * Persist the product links derived from GSN's settled shortcuts into the cookie cache, so the
	 * next visit can seed the shortcuts menu during SSR (the GSN itself does not cache product
	 * links). Mirrors `handleUpdateInvitedAppProductLinks`, but sources the links from the already
	 * hydrated shortcuts instead of a `getFilteredProductLinks` filter.
	 */ const handleUpdateProductLinksFromSettledShortcuts = (0, $cozmU.useCallback)((settled)=>{
        const resolved = $12209e126664a47e$var$resolveProductLinksFromSettledShortcuts(settled, shortcutItemsConfig);
        if (Object.keys(resolved).length > 0) updateHydratedProductLinks($12209e126664a47e$var$toProductLinksByProduct(resolved));
    }, [
        shortcutItemsConfig,
        updateHydratedProductLinks
    ]);
    return {
        invitedAppProductLinks: invitedAppProductLinks,
        handleUpdateInvitedAppProductLinks: handleUpdateInvitedAppProductLinks,
        handleUpdateProductLinksFromSettledShortcuts: handleUpdateProductLinksFromSettledShortcuts
    };
};
/**
 * Derive product links from GSN's settled shortcuts, keyed by APS key.
 *
 * For each app the shortcuts menu is configured for, look up the matching settled shortcut and
 * turn its hydrated `url` into a single-element `ProductLink[]`. When the settled shortcut has no
 * hydrated URL (the user has no resolvable link for that app), an empty array is written; downstream
 * `toProductLinksByProduct` then drops those empty entries so no linkless product is persisted.
 */ const $12209e126664a47e$var$resolveProductLinksFromSettledShortcuts = (settledShortcuts, shortcutItemsConfig)=>{
    if (Object.keys(shortcutItemsConfig).length === 0) return {};
    // Map each settled shortcut's APS key to its hydrated URL.
    const urlByApsKey = new Map();
    for (const shortcut of Object.values(settledShortcuts))if (shortcut.type === 'link' && shortcut.apsKey && shortcut.url) urlByApsKey.set(shortcut.apsKey, shortcut.url);
    return Object.values(shortcutItemsConfig).reduce((acc, config)=>{
        if (config.type === 'link' && config.apsKey) {
            const url = urlByApsKey.get(config.apsKey);
            acc[config.apsKey] = url ? [
                {
                    url: url
                }
            ] : [];
        }
        return acc;
    }, {});
};
const $12209e126664a47e$var$resolveInvitedAppProductLinks = (getFilteredProductLinks, shortcutItemsConfig)=>{
    // No need to resolve links if there are no shortcut items config
    if (Object.keys(shortcutItemsConfig).length === 0) return {};
    let loaded = false;
    const resolved = Object.entries(shortcutItemsConfig).reduce((acc, [, config])=>{
        if (config.type === 'link' && config.apsKey) {
            const { links: links, status: status } = getFilteredProductLinks(config.apsKey);
            // the status is same across all links, so we can use it to determine if the links are loaded
            if (status === (0, $cXPtd.RequestStatus).COMPLETE) loaded = true;
            acc[config.apsKey] = links;
        }
        return acc;
    }, {});
    return loaded ? resolved : {};
};
const $12209e126664a47e$var$resolveCachedInvitedAppProductLinks = (shortcutItemsConfig, getCachedProductLinks)=>{
    const cachedProductLinks = getCachedProductLinks();
    if (!cachedProductLinks) return {};
    return Object.values(shortcutItemsConfig).reduce((acc, config)=>{
        if (config.type === 'link' && config.apsKey && (0, $5xvpm.isAllowedApsKey)(config.apsKey)) {
            const product = (0, $5xvpm.getAppKeyByApsKey)(config.apsKey);
            const links = cachedProductLinks[product];
            if (links) acc[config.apsKey] = links;
        }
        return acc;
    }, {});
};
const $12209e126664a47e$var$toProductLinksByProduct = (productLinksByApsKey)=>Object.entries(productLinksByApsKey).reduce((acc, [apsKey, links])=>{
        // Only update when the links are not empty
        // This is to avoid overwriting the cached product links when shortcuts are not added to the shortcuts menu
        // A caveat is when the users lose access to the product, the cached links will not be updated until the next page
        if ((0, $5xvpm.isAllowedApsKey)(apsKey) && links.length > 0) {
            const product = (0, $5xvpm.getAppKeyByApsKey)(apsKey);
            acc[product] = links;
        }
        return acc;
    }, {});
module.exports["useInvitedAppProductLinks"] = $12209e126664a47e$export$f96c96985b06f150;

});

parcelRegister("4RzTC", function(module, exports) {
/* SimplifyNavNewUserSpotlight.tsx generated by @compiled/babel-plugin v0.40.0 */ /**
 * Spotlight anchored to the "Recent" item in the main nav (ACTIVATION-2059).
 * Shown only when: eligible for simplify-nav experiment, treatment variant, D1+,
 * Recent is in main nav, not seen/dismissed, and user hasn't opened customize dialog.
 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $9chzr = parcelRequire("9chzr");


var $2K2hA = parcelRequire("2K2hA");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $2Vz7H = parcelRequire("2Vz7H");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $3eYzF = parcelRequire("3eYzF");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $e4o8D = parcelRequire("e4o8D");


var $1UApO = parcelRequire("1UApO");


var $17wUi = parcelRequire("17wUi");


var $hSqtY = parcelRequire("hSqtY");


var $3IBnw = parcelRequire("3IBnw");


var $lsxnT = parcelRequire("lsxnT");


var $77zGl = parcelRequire("77zGl");

const $e8cb5a3d9666ba33$var$DEFAULT_REPOSITION_SELECTORS = [
    'nav#side-navigation'
];
const $e8cb5a3d9666ba33$var$spotlightHeadlineStyles = {
    headingOneLine: "_o5721q9c"
};
const $e8cb5a3d9666ba33$var$i18n = (0, $kSwu1.defineMessages)({
    spotlightHeading: {
        id: "experiment-simplify-nav-new-user.spotlight-heading",
        defaultMessage: "We added features to your sidebar"
    },
    spotlightBody: {
        id: "experiment-simplify-nav-new-user.spotlight-body",
        defaultMessage: "Customize what appears here by selecting {more} at the bottom of your sidebar."
    },
    more: {
        id: "experiment-simplify-nav-new-user.more",
        defaultMessage: "More"
    },
    gotIt: {
        id: "experiment-simplify-nav-new-user.got-it",
        defaultMessage: "Got it"
    }
});
const $e8cb5a3d9666ba33$var$SimplifyNavNewUserSpotlightComponent = ({ children: children, shouldShowSpotlight: shouldShowSpotlight = false, source: source = 'new-user', repositionSelectors: repositionSelectors = $e8cb5a3d9666ba33$var$DEFAULT_REPOSITION_SELECTORS })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [hasDismissed, setHasDismissed] = (0, $cozmU.useState)(false);
    const [hasSeenOrDismissed] = (0, $cozmU.useState)(()=>$e8cb5a3d9666ba33$var$getHasSeenOrDismissed());
    const [hasOpenedCustomize] = (0, $77zGl.useSimplifyNavNewUserSpotlightStore)(); // Parent gates with useSimplifiedNavSpotlight (eligibility, treatment, D1+). We only check session-specific conditions.
    const shouldShow = shouldShowSpotlight && !hasSeenOrDismissed && !hasOpenedCustomize && !hasDismissed && !renderServerPlaceholder;
    const handleDismiss = (0, $cozmU.useCallback)((reason)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `simplifyNavNewUserSpotlight${reason === 'dismiss-control' ? 'Dismiss' : 'CTA'}`,
                source: $e8cb5a3d9666ba33$var$getMessageId(source)
            }
        }).fire();
        $e8cb5a3d9666ba33$var$markSeenOrDismissed();
        setHasDismissed(true);
    }, [
        createAnalyticsEvent,
        source
    ]); // Always render PopoverProvider/PopoverTarget so children's parent never changes,
    // preserving React state (e.g., RecentItem flyout state) when spotlight visibility toggles.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), shouldShow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9chzr.UNSAFE_UpdateOnChange), {
        selectors: repositionSelectors
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PopoverContent, {
        messageId: $e8cb5a3d9666ba33$var$getMessageId(source),
        messageType: "engagement",
        placement: "right-end",
        offset: [
            0,
            16
        ],
        dismiss: ()=>handleDismiss('auto'),
        isVisible: shouldShow,
        onMessageDisposition: (status)=>{
            if (status === 'started') {
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: $e8cb5a3d9666ba33$var$getScreenEventName(source),
                        attributes: {
                            source: 'RecentItem'
                        }
                    }
                }).fire();
                $e8cb5a3d9666ba33$var$markSeenOrDismissed();
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "simplify-nav-new-user-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $e8cb5a3d9666ba33$var$spotlightHeadlineStyles.headingOneLine
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e8cb5a3d9666ba33$var$i18n.spotlightHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
        onClick: ()=>handleDismiss('dismiss-control'),
        autoFocus: false
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$e8cb5a3d9666ba33$var$i18n.spotlightBody,
        values: {
            more: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                as: "strong"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e8cb5a3d9666ba33$var$i18n.more))
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: ()=>handleDismiss('primary-action')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e8cb5a3d9666ba33$var$i18n.gotIt))))))));
};
const $e8cb5a3d9666ba33$export$bbe775696798290c = ({ source: source, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: source === 'xflow' ? (0, $3IBnw.Attribution).GROWTH_CFIND : (0, $3IBnw.Attribution).CE_MAU
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8cb5a3d9666ba33$var$SimplifyNavNewUserSpotlightComponent, {
        source: source,
        ...rest
    }));
const $e8cb5a3d9666ba33$var$getMessageId = (source)=>source === 'xflow' ? 'cfind-5565-nav-spotlight' : 'simplify-nav-new-user-spotlight';
const $e8cb5a3d9666ba33$var$getScreenEventName = (source)=>source === 'xflow' ? 'Cfind5565NavSpotlight' : 'SimplifyNavNewUserSpotlight';
const $e8cb5a3d9666ba33$var$getHasSeenOrDismissed = ()=>{
    try {
        return (0, $17wUi.confluenceLocalStorageInstance)?.getItemAsBoolean((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SIMPLIFY_NAV_NEW_USER_SPOTLIGHT_DISMISSED) ?? false;
    } catch  {
        return false;
    }
};
const $e8cb5a3d9666ba33$var$markSeenOrDismissed = ()=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SIMPLIFY_NAV_NEW_USER_SPOTLIGHT_DISMISSED, 'true');
    } catch  {}
};
module.exports["SimplifyNavNewUserSpotlight"] = $e8cb5a3d9666ba33$export$bbe775696798290c;

});

parcelRegister("77zGl", function(module, exports) {
/**
 * Store and hooks for Simplify Nav New User spotlight state (ACTIVATION-2059).
 * Centralizes hasOpenedCustomize so we can clean up in one place if the experiment is abandoned.
 */ 
var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $4bc89b0e707470fb$var$getInitialHasOpenedCustomize = ()=>{
    try {
        return (0, $17wUi.confluenceLocalStorageInstance)?.getItemAsBoolean((0, $1UApO.keys).SIMPLIFY_NAV_NEW_USER_SPOTLIGHT_CUSTOMIZE_OPENED) ?? false;
    } catch  {
        return false;
    }
};
const $4bc89b0e707470fb$var$initialState = {
    hasOpenedCustomize: $4bc89b0e707470fb$var$getInitialHasOpenedCustomize()
};
const $4bc89b0e707470fb$export$8933eed9fee477e = (0, $8s9DV.createStore)({
    initialState: $4bc89b0e707470fb$var$initialState,
    actions: {
        setHasOpenedCustomize: ()=>({ setState: setState, getState: getState })=>{
                if (getState().hasOpenedCustomize) return;
                setState({
                    hasOpenedCustomize: true
                });
                try {
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).SIMPLIFY_NAV_NEW_USER_SPOTLIGHT_CUSTOMIZE_OPENED, 'true');
                } catch  {
                // storage unavailable
                }
            }
    },
    name: 'simplifyNavNewUserSpotlightStore'
});
const $4bc89b0e707470fb$export$5dbbd2025a13ab73 = (0, $kBr4q.createHook)($4bc89b0e707470fb$export$8933eed9fee477e, {
    selector: (state)=>state.hasOpenedCustomize
});
const $4bc89b0e707470fb$export$9168e89189b336b6 = (0, $kBr4q.createActionsHook)($4bc89b0e707470fb$export$8933eed9fee477e);
module.exports["useSimplifyNavNewUserSpotlightStore"] = $4bc89b0e707470fb$export$5dbbd2025a13ab73;
module.exports["useSimplifyNavNewUserSpotlightStoreActions"] = $4bc89b0e707470fb$export$9168e89189b336b6;

});

parcelRegister("86Bi3", function(module, exports) {

var $41KFX = parcelRequire("41KFX");

const $02947314900d85ba$export$79c4a1ca811bb387 = ({ globalMenuItems: globalMenuItems, navStyle: navStyle, isWithinD0: isWithinD0 })=>{
    const isRecentInMainNav = globalMenuItems.some((item)=>item.menuId === 'recent');
    const isEligibleForSpotlight = isRecentInMainNav && (0, $41KFX.TREATMENT_COHORTS).has(navStyle);
    return {
        shouldShowSpotlight: isEligibleForSpotlight && !isWithinD0,
        shouldPersistCustomizeOpen: isEligibleForSpotlight
    };
};
module.exports["useSimplifiedNavSpotlight"] = $02947314900d85ba$export$79c4a1ca811bb387;

});

parcelRegister("8dN99", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $V3JOP = parcelRequire("V3JOP");


var $bltJZ = parcelRequire("bltJZ");


var $huaOC = parcelRequire("huaOC");


var $9wGTI = parcelRequire("9wGTI");








var $9DHhW = parcelRequire("9DHhW");


var $7aRa9 = parcelRequire("7aRa9");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $63PsI = parcelRequire("63PsI");


var $1NBp8 = parcelRequire("1NBp8");


var $1kHsc = parcelRequire("1kHsc");


const $244d7de71b5a933d$var$lazyOnClick = async (args)=>{
    const { companyHubItemCallback: companyHubItemCallback } = await (parcelRequire("kX2dA"));
    await companyHubItemCallback(args);
};
const $244d7de71b5a933d$export$40e9528e11a75d6b = (0, $7aRa9.withFlags)(/*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, flags: flags, navVersion: navVersion } = t0;
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    const { match: match, push: push } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const routeName = match?.name;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== experienceTracker || $[2] !== flags || $[3] !== navVersion || $[4] !== push || $[5] !== routeName) {
        t1 = async ()=>{
            $244d7de71b5a933d$var$lazyOnClick({
                createAnalyticsEvent: createAnalyticsEvent,
                experienceTracker: experienceTracker,
                flags: flags,
                isFirstTimeVisit: false,
                push: push,
                routeName: routeName,
                navVersion: navVersion
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = experienceTracker;
        $[2] = flags;
        $[3] = navVersion;
        $[4] = push;
        $[5] = routeName;
        $[6] = t1;
    } else t1 = $[6];
    const onClick = t1;
    let t2;
    if ($[7] !== children || $[8] !== companyHubName || $[9] !== onClick || $[10] !== routeName || $[11] !== spaceKey) {
        const isSelected = routeName === (0, $1NBp8.COMPANY_HUB).name || routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name && routeName !== (0, $1NBp8.COMPANY_HUB_ANALYTICS).name && routeName !== (0, $1NBp8.COMPANY_HUB_SETTINGS).name && (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        t2 = children({
            companyHubName: companyHubName,
            isSelected: isSelected,
            namedRoute: (0, $1NBp8.COMPANY_HUB),
            onClick: onClick
        });
        $[7] = children;
        $[8] = companyHubName;
        $[9] = onClick;
        $[10] = routeName;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
}));


const $e47020b4a0088e3d$var$DEFAULT_COMPANY_HUB_NAME = 'Company Hub';
const $e47020b4a0088e3d$var$i18n = (0, $kSwu1.defineMessages)({
    CompanyHubName: {
        id: "side-navigation.custom.company-hub.shortcut-name",
        defaultMessage: "Company Hub"
    }
});
const $e47020b4a0088e3d$export$7d5e579a7612f1c2 = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let isHidden;
    let onClick;
    let rest;
    if ($[0] !== t0) {
        ({ isHidden: isHidden, onClick: onClick, ...rest } = t0);
        $[0] = t0;
        $[1] = isHidden;
        $[2] = onClick;
        $[3] = rest;
    } else {
        isHidden = $[1];
        onClick = $[2];
        rest = $[3];
    }
    if (isHidden) return null;
    let t1;
    if ($[4] !== onClick || $[5] !== rest) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $244d7de71b5a933d$export$40e9528e11a75d6b), {
            navVersion: "4"
        }, (t2)=>{
            const { companyHubName: companyHubName, isSelected: isSelected, namedRoute: namedRoute, onClick: onAbstractCompanyHubItemClick } = t2;
            const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.HubIcon), {
                size: "xsmall"
            });
            const elemAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
                label: "",
                spacing: "spacious",
                size: "small"
            });
            const onMenuLinkItemClick = ()=>{
                onClick?.();
                onAbstractCompanyHubItemClick();
            };
            const isDefaultCompanyHubName = companyHubName === $e47020b4a0088e3d$var$DEFAULT_COMPANY_HUB_NAME;
            if ((0, $9wGTI.fg)("navx-global-side-nav-confluence")) {
                const { peekingId: _peekingId, setPeekingId: _setPeekingId, draggableRef: draggableRef, ...dndProps } = rest;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
                    ref: draggableRef,
                    elemAfter: elemAfter,
                    elemBefore: elemBefore,
                    href: namedRoute?.toUrl() || "#",
                    isSelected: isSelected,
                    onClick: onMenuLinkItemClick,
                    target: "_blank",
                    ...dndProps
                }, isDefaultCompanyHubName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e47020b4a0088e3d$var$i18n.CompanyHubName) : companyHubName);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
                elemAfter: elemAfter,
                elemBefore: elemBefore,
                href: namedRoute?.toUrl() || "#",
                isSelected: isSelected,
                onClick: onMenuLinkItemClick,
                target: "_blank"
            }, isDefaultCompanyHubName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e47020b4a0088e3d$var$i18n.CompanyHubName) : companyHubName);
        });
        $[4] = onClick;
        $[5] = rest;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["CompanyHubItem"] = $e47020b4a0088e3d$export$7d5e579a7612f1c2;

});

parcelRegister("kX2dA", function(module, exports) {

let $f40b09d50443ad04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f40b09d50443ad04$var$load("aGsq7").then(()=>parcelRequire('eXmLL'));

});

parcelRegister("fPgmM", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6LqoL = parcelRequire("6LqoL");

var $1Qi0Q = parcelRequire("1Qi0Q");

var $lnexi = parcelRequire("lnexi");

var $kaBJT = parcelRequire("kaBJT");


var $8SIV6 = parcelRequire("8SIV6");

const $ccb124cb90058c47$var$cacheKey = 'invitedAppShortcuts';
const $ccb124cb90058c47$var$localStorageCacheDebugKey = `${$ccb124cb90058c47$var$cacheKey}Debug`;
class $ccb124cb90058c47$export$7bddb475c47d45d {
    async write(state) {
        if ($ccb124cb90058c47$var$cacheDebugMode() === 'local-storage') {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage[$ccb124cb90058c47$var$cacheKey] = JSON.stringify(state);
            return true;
        }
        const result = await this.setCookie($ccb124cb90058c47$var$cacheKey, JSON.stringify(state), {
            expires: new Date(Date.now() + (0, $8SIV6.getConfig)().CACHE_TIME_UNTIL_EXPIRY),
            sameSite: 'strict'
        });
        return result === true || result === (0, $kaBJT.Status).SUCCESS;
    }
    read({ ssr: ssr }) {
        const throwOnError = ssr;
        if ($ccb124cb90058c47$var$cacheDebugMode() === 'local-storage') {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            if (localStorage?.[$ccb124cb90058c47$var$cacheKey]) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            return this.parseCachedState({
                rawValue: localStorage[$ccb124cb90058c47$var$cacheKey],
                throwOnError: throwOnError
            });
        } else {
            const cookieValueString = this.getCookie($ccb124cb90058c47$var$cacheKey, ssr);
            if (cookieValueString) return this.parseCachedState({
                rawValue: cookieValueString,
                throwOnError: throwOnError
            });
        }
        return null;
    }
    parseCachedState({ rawValue: rawValue, throwOnError: throwOnError }) {
        // Reuse parsed state for identical cookie/localStorage payloads during the same render lifecycle.
        if (this.lastParsedRawValue === rawValue) return this.lastParsedState;
        try {
            const decoded = $ccb124cb90058c47$var$isUrlEncodedJson(rawValue) ? decodeURIComponent(rawValue) : rawValue;
            const parsed = JSON.parse(decoded) || null;
            this.lastParsedRawValue = rawValue;
            this.lastParsedState = parsed;
            return parsed;
        } catch (error) {
            if (throwOnError) throw error;
            // Subsequent client reads: swallow parse errors for robustness; treat as cache miss.
            this.lastParsedRawValue = rawValue;
            this.lastParsedState = null;
            return null;
        }
    }
    constructor({ getCookie: getCookie = (0, $1Qi0Q.getCookie), setCookie: setCookie = (0, $lnexi.setCookie) } = {}){
        this.getCookie = void 0;
        this.setCookie = void 0;
        this.lastParsedRawValue = null;
        this.lastParsedState = null;
        this.getCookie = getCookie;
        this.setCookie = setCookie;
    }
}
const $ccb124cb90058c47$var$isUrlEncodedJson = (json)=>json && (json.startsWith(`{%22`) || // `{"` with only `"` encoded -- this was value was observed in Confluence
    json.startsWith(`%7B%22`)); // `{"` encoded
const $ccb124cb90058c47$var$cacheDebugMode = ()=>{
    const debugMode = typeof localStorage !== 'undefined' && localStorage && // Extra safety while we're in the debug-only phase,
    // before we've switched to the proper browser controls (to be removed when that happens).
    // Requires manually setting localStorage.invitedAppShortcutsDebug = "true" in the console
    // to allow our code to write anything into the local storage cache.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage[$ccb124cb90058c47$var$localStorageCacheDebugKey];
    if (debugMode === 'cookie-delete') {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage[$ccb124cb90058c47$var$localStorageCacheDebugKey] = null;
        (0, $6LqoL.deleteCookie)($ccb124cb90058c47$var$cacheKey);
    } else if (debugMode && ![
        'null',
        'false'
    ].includes(debugMode)) return 'local-storage';
    return null;
};



var $1rYMO = parcelRequire("1rYMO");


var $68uaC = parcelRequire("68uaC");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");


var $1jJCz = parcelRequire("1jJCz");

const $082cea242d4d809f$var$targetProductsJira = [
    'jira'
];
const $082cea242d4d809f$var$targetProductsEmpty = [];
const $082cea242d4d809f$var$useInvitedAppShortcutsSiteUserTraits = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { variables: variables, skip: skip } = t0;
    let t1;
    if ($[0] !== skip || $[1] !== variables) {
        t1 = {
            url: $082cea242d4d809f$var$_temp,
            method: "GET",
            variables: variables,
            parseResult: $082cea242d4d809f$var$_temp2,
            skip: skip
        };
        $[0] = skip;
        $[1] = variables;
        $[2] = t1;
    } else t1 = $[2];
    return (0, $dK51B.useExperimentalQuery)(t1);
};
const $082cea242d4d809f$export$e6614be55e8365cd = ()=>{
    const $ = (0, $bDgLe.c)(24);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { hasJira: hasJira } = (0, $1jJCz.useLicensedProducts)();
    const [cacheNeedsRefresh, setCacheNeedsRefresh] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] !== cacheNeedsRefresh) {
        t0 = !((0, $9wGTI.fg)("twcg-460-personalised-invite-notifications-m2-gate") && cacheNeedsRefresh) || (0, $6mKj3.expVal)("cc_ce_mau_deprecated_tap_wrappers_migration", "isEnabled", false);
        $[0] = cacheNeedsRefresh;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = userId || "";
    let t2;
    if ($[2] !== cloudId || $[3] !== t1) {
        t2 = {
            cloudId: cloudId,
            userId: t1
        };
        $[2] = cloudId;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t0 || $[6] !== t2) {
        t3 = {
            skip: t0,
            variables: t2
        };
        $[5] = t0;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const legacyUserTraits = (0, $gqypm.useExperimentalSiteUserPersonalization)(t3);
    let t4;
    if ($[8] !== cacheNeedsRefresh) {
        t4 = !((0, $9wGTI.fg)("twcg-460-personalised-invite-notifications-m2-gate") && cacheNeedsRefresh) || !(0, $6mKj3.expVal)("cc_ce_mau_deprecated_tap_wrappers_migration", "isEnabled", false);
        $[8] = cacheNeedsRefresh;
        $[9] = t4;
    } else t4 = $[9];
    const t5 = userId || "";
    let t6;
    if ($[10] !== cloudId || $[11] !== t5) {
        t6 = {
            cloudId: cloudId,
            userId: t5
        };
        $[10] = cloudId;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t4 || $[14] !== t6) {
        t7 = {
            skip: t4,
            variables: t6
        };
        $[13] = t4;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    const directTapUserTraits = $082cea242d4d809f$var$useInvitedAppShortcutsSiteUserTraits(t7);
    let t8;
    if ($[16] !== directTapUserTraits || $[17] !== legacyUserTraits) {
        t8 = (0, $6mKj3.expVal)("cc_ce_mau_deprecated_tap_wrappers_migration", "isEnabled", false) ? directTapUserTraits : legacyUserTraits;
        $[16] = directTapUserTraits;
        $[17] = legacyUserTraits;
        $[18] = t8;
    } else t8 = $[18];
    const userTraits = t8;
    let t9;
    if ($[19] !== cloudId || $[20] !== hasJira || $[21] !== userId || $[22] !== userTraits) {
        t9 = (0, $9wGTI.fg)("twcg-460-personalised-invite-notifications-m2-gate") ? {
            enabled: true,
            targetProducts: hasJira ? $082cea242d4d809f$var$targetProductsJira : $082cea242d4d809f$var$targetProductsEmpty,
            sourceProduct: "confluence",
            cloudId: cloudId,
            userId: userId,
            traits: userTraits.data?.experimentalSiteUserPersonalization?.attributes ?? null,
            cache: $082cea242d4d809f$export$5e0574c563aa74b8(),
            onCacheNeedsRefresh: ()=>{
                setCacheNeedsRefresh(true);
            }
        } : {
            enabled: false
        };
        $[19] = cloudId;
        $[20] = hasJira;
        $[21] = userId;
        $[22] = userTraits;
        $[23] = t9;
    } else t9 = $[23];
    return (0, $1rYMO.useInvitedAppShortcuts)(t9);
};
let $082cea242d4d809f$var$cache;
const $082cea242d4d809f$export$5e0574c563aa74b8 = ()=>{
    if (!$082cea242d4d809f$var$cache) $082cea242d4d809f$var$cache = new (0, $ccb124cb90058c47$export$7bddb475c47d45d)({
        setCookie: (0, $68uaC.Cookies).set,
        getCookie: (0, $68uaC.Cookies).get
    });
    return $082cea242d4d809f$var$cache;
};
function $082cea242d4d809f$var$_temp(t0) {
    const { cloudId: cloudId, userId: userId } = t0;
    return `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
}
function $082cea242d4d809f$var$_temp2(json) {
    return {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
        }
    };
}
module.exports["useResolveInvitedAppShortcuts"] = $082cea242d4d809f$export$e6614be55e8365cd;
module.exports["getInvitedAppShortcutsCache"] = $082cea242d4d809f$export$5e0574c563aa74b8;

});

parcelRegister("1rYMO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5yEp5 = parcelRequire("5yEp5");


var $3H3Mp = parcelRequire("3H3Mp");


var $afGU4 = parcelRequire("afGU4");




const $f1d25947eb4f426e$export$12e73c04b5fd5da2 = new Set([
    ...(0, $5yEp5.INVITED_APP_SHORTCUTS_ALLOWED_SOURCE_APPS),
    ...(0, $5yEp5.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)
]);
const $f1d25947eb4f426e$export$130cf0f0f2a54797 = {
    EXPERIMENT_OFF: 'EXPERIMENT_OFF',
    ERROR: 'ERROR',
    CACHE_EMPTY: 'CACHE_EMPTY',
    CACHE_EMPTY_USER_MISMATCH: 'CACHE_EMPTY_USER_MISMATCH',
    CACHE_EXPIRED: 'CACHE_EXPIRED',
    NO_TARGET_PRODUCTS: 'NO_TARGET_PRODUCTS',
    NO_ACCESS_TO_TARGET_PRODUCTS: 'NO_ACCESS_TO_TARGET_PRODUCTS',
    TARGET_PRODUCTS_NOT_VISIBLE: 'TARGET_PRODUCTS_NOT_VISIBLE',
    TARGET_PRODUCTS_ALL_ACTIVE: 'TARGET_PRODUCTS_ALL_ACTIVE',
    SOURCE_PRODUCT_TOO_NEW: 'SOURCE_PRODUCT_TOO_NEW',
    /**
   * Returned in `mode: 'productionisation'` when the caller passes an
   * empty `recommendedApps` array — no target product was recommended.
   */ NO_RECOMMENDED_APPS: 'NO_RECOMMENDED_APPS'
};
const $f1d25947eb4f426e$export$fd93bc3ed8f14580 = 'updateId';
const $f1d25947eb4f426e$export$110c7428ebac4f9a = 5000;
const $f1d25947eb4f426e$export$ebd0d23278a50416 = {
    NOT_CHECKED: undefined,
    INACTIVE: null
};



var $cXtTj = parcelRequire("cXtTj");

const $94ad97d6f20da745$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue, options = {})=>{
    // If client is not initialized, we return the default value
    if (!(0, $cXtTj.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $cXtTj.default).getExperimentValue(experimentName, experimentParam, defaultValue, options);
    return experimentValue;
};






var $5xvpm = parcelRequire("5xvpm");


/** Serializes every `enqueueUpdate` globally; `lastCommittedStateByCache` still scopes `prev` per cache instance. */ const $5016bf9938979f54$var$queue = [];
/**
 * Last state successfully persisted per cache, from this module's queue only.
 * `cache.read()` can lag behind `cache.write()` (e.g. async cookies), so sequential
 * updaters must not rely on read() alone for `prev`.
 *
 * Updated only after `cache.write` resolves **true** (confirmed persist). Not updated
 * when the updater returns null/`prev`, when `write` resolves false, on throw from the
 * updater or `write`, or in `catch` below — so failed updates do not advance the chain.
 */ const $5016bf9938979f54$var$lastCommittedStateByCache = new WeakMap();
const $5016bf9938979f54$export$3f9c9dc8b61499e9 = (cache, updater)=>{
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    const processUpdate = async ()=>{
        const prev = $5016bf9938979f54$var$lastCommittedStateByCache.get(cache) ?? cache.read({
            ssr: false
        }) ?? {};
        try {
            const result = updater(prev);
            if (result === null || result === prev) resolve(prev);
            else {
                const writeSucceeded = await cache.write(result);
                if (writeSucceeded) {
                    $5016bf9938979f54$var$lastCommittedStateByCache.set(cache, result);
                    resolve(result);
                } else // Do not set lastCommittedStateByCache — storage may not match `result`.
                resolve(prev);
            }
        } catch (error) {
            // Do not update lastCommittedStateByCache; queue still advances below.
            reject(error);
        }
        $5016bf9938979f54$var$queue.shift(); // Remove the processed update
        if ($5016bf9938979f54$var$queue.length > 0) {
            const nextProcessUpdate = $5016bf9938979f54$var$queue[0];
            nextProcessUpdate(); // Start the next update, keep it in the queue (blocking) until processed
        }
    };
    $5016bf9938979f54$var$queue.push(processUpdate);
    if ($5016bf9938979f54$var$queue.length === 1) processUpdate();
    return promise;
};



var $8SIV6 = parcelRequire("8SIV6");

const $5a97f3a58ec0ddb1$export$2331136d2a146e0b = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, userId: userId, cache: cache })=>{
    if (targetProducts.length === 0) return {
        eligibility: $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).NO_TARGET_PRODUCTS)
    };
    const cached = cache.read({
        ssr: true
    });
    if (userId && cached && cached.uid && userId !== cached.uid) {
        // Extra protection: clear cache asynchronously in the background, ignoring errors.
        // The hook will then fill the cache for the correct, current user.
        Promise.resolve().then(()=>(0, $5016bf9938979f54$export$3f9c9dc8b61499e9)(cache, ()=>({
                    uid: cached.uid
                }))).catch(()=>{});
        return {
            eligibility: $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).CACHE_EMPTY_USER_MISMATCH)
        };
    }
    if (!(cached && cached.apps)) return {
        eligibility: $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).CACHE_EMPTY)
    };
    const resolvedDetails = $5a97f3a58ec0ddb1$export$6d313cb53294e81({
        sourceProduct: sourceProduct,
        targetProducts: targetProducts
    }, cached);
    return {
        eligibility: resolvedDetails,
        state: cached
    };
};
const $5a97f3a58ec0ddb1$export$6d313cb53294e81 = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, timestamp: timestamp = Date.now() }, cachedState)=>{
    if (targetProducts.length === 0) return $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).NO_TARGET_PRODUCTS);
    let invitedApps = {};
    let hasAccessToAtLeastOneTarget = null;
    let atLeastOneTargetVisible = null;
    let atLeastOneTargetInactive = false;
    const ignoreVisibility = $5a97f3a58ec0ddb1$var$shouldIgnoreVisibility({
        sourceProduct: sourceProduct
    });
    for (const targetProduct of targetProducts){
        const cachedApp = cachedState.apps?.[targetProduct];
        if (!cachedApp) continue;
        if (cachedApp.access != null) hasAccessToAtLeastOneTarget = hasAccessToAtLeastOneTarget || cachedApp.access;
        if (cachedApp.visible != null) atLeastOneTargetVisible = atLeastOneTargetVisible || cachedApp.visible;
        if (cachedApp.access && (cachedApp.visible || ignoreVisibility) && cachedApp.firstActive === (0, $f1d25947eb4f426e$export$ebd0d23278a50416).INACTIVE) {
            atLeastOneTargetInactive = true;
            invitedApps[targetProduct] = {
                eligible: true,
                collaborators: Array.from({
                    length: cachedApp.collaboratorCount ?? 0
                }).map((_, index)=>cachedApp.collaboratorDetails?.[index] ?? null),
                firstImpressionAt: cachedApp?.firstImpressionAt ?? null
            };
        }
    }
    if (hasAccessToAtLeastOneTarget === null || !ignoreVisibility && atLeastOneTargetVisible === null) return $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).CACHE_EMPTY);
    if (!hasAccessToAtLeastOneTarget) return $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).NO_ACCESS_TO_TARGET_PRODUCTS);
    if (!atLeastOneTargetVisible && !ignoreVisibility) return $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).TARGET_PRODUCTS_NOT_VISIBLE);
    if (!cachedState.firstActiveUpdatedTimestamp) return $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).CACHE_EMPTY);
    if (!(timestamp <= cachedState.firstActiveUpdatedTimestamp + (0, $8SIV6.getConfig)().CACHE_TIME_UNTIL_EXPIRY)) return $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).CACHE_EXPIRED);
    if (sourceProduct !== 'home') {
        const firstActiveInSourceProduct = cachedState.apps?.[sourceProduct]?.firstActive;
        if (!firstActiveInSourceProduct) return $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).CACHE_EMPTY);
        if (timestamp - firstActiveInSourceProduct < (0, $8SIV6.getConfig)().TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE) return $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).SOURCE_PRODUCT_TOO_NEW);
    }
    if (!atLeastOneTargetInactive) return $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).TARGET_PRODUCTS_ALL_ACTIVE);
    return {
        ineligibilityReason: null,
        invitedApps: invitedApps
    };
};
const $5a97f3a58ec0ddb1$export$2f93f852bd951b = ({ recommendedApps: recommendedApps })=>{
    if (recommendedApps.length === 0) return {
        eligibility: $5a97f3a58ec0ddb1$export$16cb62545527283a((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).NO_RECOMMENDED_APPS)
    };
    const invitedApps = {};
    for (const app of recommendedApps)invitedApps[app] = {
        eligible: true
    };
    return {
        eligibility: {
            ineligibilityReason: null,
            invitedApps: invitedApps
        }
    };
};
const $5a97f3a58ec0ddb1$export$16cb62545527283a = (reason)=>({
        ineligibilityReason: reason
    });
const $5a97f3a58ec0ddb1$export$fe1089e917806f3c = (cachedState)=>!cachedState?.firstActiveUpdatedTimestamp || Date.now() > cachedState.firstActiveUpdatedTimestamp + (0, $8SIV6.getConfig)().CACHE_TIME_UNTIL_REFRESH;
const $5a97f3a58ec0ddb1$export$b97783bc9c26cb8b = async ({ access: accessMap, visibility: visibilityMap, traits: traits, userId: userId, cache: cache })=>(0, $5016bf9938979f54$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const draft = {
            ...prev,
            uid: userId,
            apps: {
                ...prev?.apps
            }
        };
        const traitsByName = $5a97f3a58ec0ddb1$var$groupTraitsByName(traits);
        for (const product of (0, $f1d25947eb4f426e$export$12e73c04b5fd5da2)){
            const appAccess = accessMap[product];
            const appVisibility = visibilityMap[product];
            const traitValue = $5a97f3a58ec0ddb1$var$getProductFirstActiveTraitValue(product, traitsByName);
            if (traitValue !== $5a97f3a58ec0ddb1$var$FIRST_ACTIVE_NOT_APPLICABLE) {
                const firstActive = traitValue ? $5a97f3a58ec0ddb1$export$bca6124add6e242(traitValue) : null;
                const draftApp = {
                    ...draft.apps[product]
                };
                if (firstActive) draftApp.firstActive = firstActive;
                else if (appAccess === true) draftApp.firstActive = (0, $f1d25947eb4f426e$export$ebd0d23278a50416).INACTIVE;
                if (appAccess !== undefined) draftApp.access = appAccess;
                if (appVisibility !== undefined) draftApp.visible = appVisibility;
                draft.apps[product] = draftApp;
            }
        }
        draft.firstActiveUpdatedTimestamp = Date.now();
        return draft;
    });
const $5a97f3a58ec0ddb1$var$FIRST_ACTIVE_NOT_APPLICABLE = Symbol('FIRST_ACTIVE_NOT_APPLICABLE');
const $5a97f3a58ec0ddb1$var$getProductFirstActiveTraitValue = (product, traitsByName)=>{
    switch(product){
        case 'jira':
            return traitsByName['jira_first_active'] || traitsByName['jira-software_first_active'];
        case 'confluence':
            return traitsByName['confluence_first_active'];
        case 'home':
            return $5a97f3a58ec0ddb1$var$FIRST_ACTIVE_NOT_APPLICABLE;
        default:
            product;
    }
};
const $5a97f3a58ec0ddb1$var$shouldIgnoreVisibility = ({ sourceProduct: sourceProduct })=>sourceProduct === 'confluence';
const $5a97f3a58ec0ddb1$export$8788f7a1e6d8fdb0 = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, dynamicEligibility: dynamicEligibility })=>!!dynamicEligibility && targetProducts.some((product)=>dynamicEligibility.access[product] === true && (dynamicEligibility.visibility[product] === true || $5a97f3a58ec0ddb1$var$shouldIgnoreVisibility({
            sourceProduct: sourceProduct
        })));
const $5a97f3a58ec0ddb1$export$8ec65f29d950d5d3 = ({ getFilteredProductLinks: getFilteredProductLinks, limitToOnlyApsKeys: limitToOnlyApsKeys = [
    ...(0, $5yEp5.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const access = {};
    let atLeastOneComplete = false;
    for (const apsKey of limitToOnlyApsKeys){
        const app = (0, $5xvpm.getAppKeyByApsKey)(apsKey);
        const { links: links, status: status } = getFilteredProductLinks(apsKey);
        if (status === 'complete') {
            atLeastOneComplete = true;
            const hasAccess = links.length > 0;
            access[app] = hasAccess;
        }
    }
    return atLeastOneComplete ? access : undefined;
};
const $5a97f3a58ec0ddb1$var$menuIdToApsKey = {
    // Jira to Confluence
    'jira.sidebar.globalApp.confluence': 'CONFLUENCE',
    // Confluence to Jira
    jiraShortcut: 'JIRA_SOFTWARE'
};
const $5a97f3a58ec0ddb1$export$ef01d2a4fe4032bb = ({ shortcuts: shortcuts, limitToOnlyApsKeys: limitToOnlyApsKeys = [
    ...(0, $5yEp5.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const access = Object.values(shortcuts).reduce((acc, shortcut)=>{
        if (shortcut.type === 'link' && shortcut.apsKey) {
            const { apsKey: apsKey, url: url } = shortcut;
            // if the url is valid then we assume the user has access to the product
            if (url && limitToOnlyApsKeys.includes(apsKey)) try {
                const appKey = (0, $5xvpm.getAppKeyByApsKey)(apsKey);
                acc[appKey] = true;
            // eslint-disable-next-line no-unused-vars
            } catch (_) {
            // if fails to get the app key then it's not an allowed app, skip it
            }
        }
        return acc;
    }, {});
    return $5a97f3a58ec0ddb1$var$applyDefaultsForApsKeys(access, limitToOnlyApsKeys, false);
};
const $5a97f3a58ec0ddb1$var$applyDefaultsForApsKeys = (appMap, apsKeys, defaultValue)=>{
    const result = {
        ...appMap
    };
    for (let apsKey of apsKeys){
        const app = (0, $5xvpm.getAppKeyByApsKey)(apsKey);
        if (result[app] === undefined) result[app] = defaultValue;
    }
    return result;
};
const $5a97f3a58ec0ddb1$export$a8f7dcbfec997a77 = ({ visibleMenuIds: visibleMenuIds, limitToOnlyApsKeys: apsKeys = [
    ...(0, $5yEp5.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const visibleApsKeys = new Set(visibleMenuIds.map((menuId)=>$5a97f3a58ec0ddb1$var$menuIdToApsKey[menuId]).filter(Boolean));
    const visibilityMap = {};
    for (const apsKey of apsKeys){
        const appKey = (0, $5xvpm.getAppKeyByApsKey)(apsKey);
        visibilityMap[appKey] = visibleApsKeys.has(apsKey);
    }
    return visibilityMap;
};
const $5a97f3a58ec0ddb1$export$1c471c34a84a4f55 = async ({ access: accessMap, visibility: visibilityMap, cache: cache })=>(0, $5016bf9938979f54$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        let updated = false;
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        for (const app of (0, $f1d25947eb4f426e$export$12e73c04b5fd5da2)){
            const appAccess = accessMap[app];
            const appVisibility = visibilityMap[app];
            const prevApp = draft.apps[app] ?? {};
            if (appAccess !== undefined && appAccess !== prevApp.access || appVisibility !== undefined && appVisibility !== prevApp.visible) {
                const draftApp = {
                    ...prevApp
                };
                if (appAccess !== undefined) draftApp.access = appAccess;
                if (appVisibility !== undefined) draftApp.visible = appVisibility;
                draft.apps[app] = draftApp;
                updated = true;
            }
        }
        return updated ? draft : null;
    });
const $5a97f3a58ec0ddb1$export$e238a4387f5f61d6 = async ({ productsSeen: productsSeen, seenTimestamp: seenTimestamp = Date.now(), cache: cache })=>(0, $5016bf9938979f54$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        let updated = false;
        for (const product of productsSeen){
            const prevApp = draft.apps[product];
            if (!prevApp?.firstImpressionAt) {
                updated = true;
                draft.apps[product] = {
                    ...prevApp,
                    firstImpressionAt: seenTimestamp
                };
            }
        }
        return updated ? draft : null;
    });
const $5a97f3a58ec0ddb1$export$a3cc74cdee943c7f = async ({ cache: cache, product: product, timestamp: timestamp = Date.now() })=>(0, $5016bf9938979f54$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        draft.apps[product] = {
            ...draft.apps[product],
            firstActive: timestamp
        };
        return draft;
    });
const $5a97f3a58ec0ddb1$export$606587d4eb77e23d = async ({ products: products, collaboratorsWithProducts: collaboratorsWithProducts, cache: cache })=>(0, $5016bf9938979f54$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const collaboratorsByProduct = $5a97f3a58ec0ddb1$var$groupCollaboratorsByProduct(collaboratorsWithProducts);
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        for (const product of products){
            const collabs = collaboratorsByProduct[product] ?? [];
            draft.apps[product] = {
                ...draft.apps[product],
                // We display:
                // - 1x avatar for 1 collaborator
                // - 2x avatars for exactly 2 collaborators
                // - 1x avatar + number of remaining collaborators for 3+
                // So store exactly as much detailed data as we need to display:
                collaboratorDetails: collabs.slice(0, collabs.length === 2 ? 2 : 1).map((c)=>({
                        avatar: c.avatar
                    })),
                collaboratorCount: collabs.length
            };
        }
        return draft;
    });
const $5a97f3a58ec0ddb1$export$a0ae147fc3589eac = async ({ productLinks: productLinks, cache: cache })=>(0, $5016bf9938979f54$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        if (Object.keys(productLinks).length === 0) return null;
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        let updated = false;
        for (const product of (0, $5yEp5.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)){
            const links = productLinks[product];
            if (!links) continue;
            const prevLinks = draft.apps[product]?.productLinks;
            if (!$5a97f3a58ec0ddb1$var$areProductLinksEqual(prevLinks, links)) {
                draft.apps[product] = {
                    ...draft.apps[product],
                    productLinks: links
                };
                updated = true;
            }
        }
        return updated ? draft : null;
    });
const $5a97f3a58ec0ddb1$var$areProductLinksEqual = (prevLinks, nextLinks)=>{
    if (!prevLinks) return false;
    if (prevLinks.length !== nextLinks.length) return false;
    const prevUrls = new Set(prevLinks.map((link)=>link?.url ?? ''));
    const nextUrls = new Set(nextLinks.map((link)=>link?.url ?? ''));
    if (prevUrls.size !== nextUrls.size) return false;
    for (const url of prevUrls){
        if (!nextUrls.has(url)) return false;
    }
    return true;
};
/**
 * Get the cached apps from the cache
 * @param cache - The cache to get the apps from
 * @returns The cached apps, or an empty object if the cache is empty or the cookie value is malformed/truncated
 */ const $5a97f3a58ec0ddb1$var$getCachedApps = ({ cache: cache })=>{
    try {
        const cachedState = cache.read({
            ssr: true
        });
        return cachedState?.apps ?? {};
    } catch  {
        // During SSR, if the cookie value is malformed/truncated, JSON.parse will throw.
        // Catch the error and treat it as a cache miss, returning an empty product links map.
        return {};
    }
};
const $5a97f3a58ec0ddb1$export$b58ff4178d893ad6 = ({ cache: cache })=>{
    const apps = $5a97f3a58ec0ddb1$var$getCachedApps({
        cache: cache
    });
    if (Object.keys(apps).length === 0) return {};
    const cachedProductLinks = {};
    for (const product of (0, $5yEp5.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)){
        const productLinks = apps?.[product]?.productLinks;
        if (productLinks) cachedProductLinks[product] = productLinks;
    }
    return cachedProductLinks;
};
const $5a97f3a58ec0ddb1$var$groupCollaboratorsByProduct = (collaboratorsWithProducts)=>{
    const result = {};
    for (const cwp of collaboratorsWithProducts)for (const product of cwp.products){
        if (!result[product]) result[product] = [];
        result[product].push(cwp.collaborator);
    }
    return result;
};
const $5a97f3a58ec0ddb1$var$groupTraitsByName = (traits)=>{
    const traitsByName = {};
    for (const trait of traits)traitsByName[trait.name] = trait.value;
    return traitsByName;
};
const $5a97f3a58ec0ddb1$export$bca6124add6e242 = (traitValue)=>typeof traitValue === 'string' && +new Date(traitValue) || null;






const $32765dc3fbb5e830$export$55467fcd9e2bb73a = ()=>{
    const canWriteRef = (0, $cozmU.useRef)(null);
    return (0, $cozmU.useCallback)(async ({ cache: cache })=>{
        if (canWriteRef.current === null) canWriteRef.current = $32765dc3fbb5e830$var$canWriteToCache({
            cache: cache
        });
        return await canWriteRef.current;
    }, []);
};
/**
 * This implementation does retries.
 *
 * Needed because the browser control library's async `setCookie()` function
 * has a bug/limitation when it doesn't correctly wait for the product context
 * to init. If we call the function "too early", it says the cookie is blocked
 * and doesn't do the write, even though once the product context loads,
 * the write would succeed.
 */ const $32765dc3fbb5e830$var$canWriteToCache = async ({ maxRetries: maxRetries = 2, retry: retry = 0, retryDelay: retryDelay = 1000, cache: cache })=>{
    try {
        const initialRead = cache.read({
            ssr: false
        });
        const writtenId = (initialRead?.[0, $f1d25947eb4f426e$export$fd93bc3ed8f14580] ?? 0) + 1;
        const writeResult = await cache.write({
            ...initialRead,
            [(0, $f1d25947eb4f426e$export$fd93bc3ed8f14580)]: writtenId
        });
        const wroteSuccessfully = writeResult === true && cache.read({
            ssr: false
        })?.[0, $f1d25947eb4f426e$export$fd93bc3ed8f14580] === writtenId;
        if (!wroteSuccessfully && retry < maxRetries) {
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return await $32765dc3fbb5e830$var$canWriteToCache({
                retry: retry + 1,
                maxRetries: maxRetries,
                retryDelay: retryDelay,
                cache: cache
            });
        }
        return wroteSuccessfully;
    } catch  {
        return false;
    }
};


const $cbb96754ef12a174$export$c2e2a02c27ed0bc1 = (input)=>{
    const { enabled: enabled, sourceProduct: sourceProduct, targetProducts: targetProducts, cloudId: cloudId, userId: userId, cache: cache, onCacheNeedsRefresh: onCacheNeedsRefresh } = input;
    const mode = input.mode ?? 'experiment';
    // Productionisation-only field; safe to read because the discriminated union
    // guarantees it is present when `mode === 'productionisation'` and `enabled`.
    const recommendedApps = enabled && input.mode === 'productionisation' ? input.recommendedApps : [];
    // Experiment-only fields; ignored in productionisation mode.
    const traitsArg = enabled && input.mode !== 'productionisation' ? input.traits : undefined;
    const fetchTraits = enabled && input.mode !== 'productionisation' ? input.fetchTraits : undefined;
    const fetchTraitsPolicy = enabled && input.mode !== 'productionisation' ? input.fetchTraitsPolicy : undefined;
    // In productionisation mode, reads and state changes are suppressed
    // (eligibility is delegated to `InvitedAppShortcutsRecommendationsProvider`).
    // Cache writes still flow through; see the JSDoc on `UseInvitedAppShortcutsMode`.
    const isProductionisation = enabled && mode === 'productionisation';
    // This implementation prioritizes performance: avoiding re-renders and state updates.
    // That's why it doesn't have dynamic React state at all.
    const analytics = (0, $afGU4.useInvitedAppAnalytics)();
    const canWriteToCache = (0, $32765dc3fbb5e830$export$55467fcd9e2bb73a)();
    /**
   * Stores traits fetch status.
   *
   * Resolved from props: either directly from `traits` or from `fetchTraits`.
   */ const traitsDeferredRef = (0, $cozmU.useRef)(// Memoize initial ref value to compute it only once:
    (0, $cozmU.useMemo)(()=>{
        let resolve;
        const promise = new Promise((res)=>{
            resolve = res;
        });
        return {
            promise: promise,
            resolve: resolve,
            status: 'initial'
        };
    }, []));
    /**
   * A lock preventing duplicate cache refreshes.
   */ const isCacheRefreshLockedRef = (0, $cozmU.useRef)(false);
    const lostAccessTimeoutRef = (0, $cozmU.useRef)(null);
    /**
   * Main read used to resolve the returned eligibility.
   *
   * Read only once, and then stable (non-reactive), ensured by useState with a functional initializer.
   *
   * In `mode: 'productionisation'`, eligibility is derived from the
   * caller-supplied `recommendedApps` (typically produced by
   * `InvitedAppShortcutsRecommendationsProvider`). The cookie cache is not
   * consulted; consumers see a populated `invitedApps` map directly.
   *
   * In `mode: 'experiment'`, eligibility is read from the cookie cache as before.
   */ const [cached] = (0, $cozmU.useState)(()=>{
        if (!enabled) return {
            eligibility: (0, $5a97f3a58ec0ddb1$export$16cb62545527283a)((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).EXPERIMENT_OFF)
        };
        if (mode === 'productionisation') return (0, $5a97f3a58ec0ddb1$export$2f93f852bd951b)({
            recommendedApps: recommendedApps
        });
        try {
            return (0, $5a97f3a58ec0ddb1$export$2331136d2a146e0b)({
                sourceProduct: sourceProduct,
                targetProducts: targetProducts,
                cache: cache,
                userId: userId
            });
        // eslint-disable-next-line no-unused-vars
        } catch (_ignoredError) {
            return {
                eligibility: (0, $5a97f3a58ec0ddb1$export$16cb62545527283a)((0, $f1d25947eb4f426e$export$130cf0f0f2a54797).ERROR)
            };
        }
    });
    /**
   * Synchronize traits state with the supplied traits arg.
   *
   * This arg is passed by Confluence, based on a Confluence GraphQL query. The query
   * is initially skipped. It stops being skipped when our hook calls `onCacheNeedsRefresh`,
   * which it does only when it decides that the cache needs a refresh.
   *
   * Skipped in `mode: 'productionisation'` — traits feed the legacy
   * eligibility resolver, which is not run in that mode.
   *
   * This effect should be removed when tidying up the A/A test for productionisation
   */ (0, $cozmU.useEffect)(()=>{
        if (enabled && !isProductionisation && traitsArg && traitsDeferredRef.current.status === 'initial') {
            traitsDeferredRef.current.resolve(traitsArg);
            traitsDeferredRef.current.status = 'fulfilled';
        }
    }, [
        enabled,
        isProductionisation,
        traitsArg
    ]);
    /**
   * Fire analytics when the user is ineligible
   *
   * Skipped in `mode: 'productionisation'` because we did not check
   * eligibility ourselves — firing this event would be misleading.
   *
   * This effect should be removed when tidying up the A/A test for productionisation
   */ (0, $cozmU.useEffect)(()=>{
        if (enabled && !isProductionisation && cached.eligibility.ineligibilityReason) analytics.fireInvitedAppShortcutsEligibilityChecked({
            ineligibilityReason: cached.eligibility.ineligibilityReason,
            userId: userId,
            cloudId: cloudId
        });
    }, [
        enabled,
        isProductionisation,
        cached.eligibility.ineligibilityReason,
        analytics,
        userId,
        cloudId
    ]);
    /**
   * Clear lost access analytics timeout on unmount
   */ (0, $cozmU.useEffect)(()=>()=>{
            if (lostAccessTimeoutRef.current) clearTimeout(lostAccessTimeoutRef.current);
        }, []);
    return (0, $cozmU.useMemo)(()=>{
        const updateFromDynamicEligibility = async ({ access: access, visibility: visibility })=>{
            if (!enabled || !userId) return;
            await (0, $5a97f3a58ec0ddb1$export$1c471c34a84a4f55)({
                access: access ?? {},
                visibility: visibility,
                cache: cache
            });
            if (access === undefined) return;
            maybeFireLostAccessAnalytics(access);
            await $cbb96754ef12a174$var$maybeRefreshEligibility({
                access: access,
                visibility: visibility,
                cache: cache,
                sourceProduct: sourceProduct,
                targetProducts: targetProducts,
                traitsDeferred: traitsDeferredRef.current,
                obtainRefreshLock: obtainRefreshLock,
                userId: userId,
                cloudId: cloudId,
                cached: cached,
                canWriteToCache: canWriteToCache,
                onCacheNeedsRefresh: onCacheNeedsRefresh,
                fetchTraits: fetchTraits,
                fetchTraitsPolicy: fetchTraitsPolicy,
                analytics: analytics
            });
        };
        /*
     * Fire telemetry in the rare case when we returned cached eligibility,
     * but then we learn that user lost access to the eligible target product(s).
     *
     * Do it after a timeout because we might receive multiple dynamic eligibility
     * updates, and initial ones might happen when not all of the data is loaded,
     * which could be indistinguishable from "no access" and lead to false positives.
     * If, during the timeout delay, we get an update indicating that the user has access
     * after all, we clear the timeout.
     */ const maybeFireLostAccessAnalytics = (access)=>{
            const lostAccess = lostAccessToAnyEligibleTargetProduct(access);
            if (lostAccess && lostAccessTimeoutRef.current === null) lostAccessTimeoutRef.current = setTimeout(()=>{
                analytics.fireAppAccessRemoved({
                    targetApps: getEligibleInvitedApps().filter((app)=>access[app] === false)
                });
            }, (0, $f1d25947eb4f426e$export$110c7428ebac4f9a));
            else if (!lostAccess && lostAccessTimeoutRef.current) clearTimeout(lostAccessTimeoutRef.current);
        };
        const lostAccessToAnyEligibleTargetProduct = (access)=>{
            const eligibleInvitedApps = getEligibleInvitedApps();
            return eligibleInvitedApps.some((app)=>access[app] === false);
        };
        /**
     * One-way lock only (no ability to unlock) because we want to make sure we only
     * do a deep cache refresh once.
     */ const obtainRefreshLock = ()=>{
            if (isCacheRefreshLockedRef.current) return false;
            isCacheRefreshLockedRef.current = true;
            return true;
        };
        const getEligibleInvitedApps = ()=>Object.keys(cached.eligibility.invitedApps || {}).filter((appName)=>cached.eligibility.invitedApps?.[appName]?.eligible);
        return {
            ...cached.eligibility,
            /**
       * Call this function when BFF yields a new version of the `getFilteredProductLinks` function.
       *
       * It will update our eligibility cache based on app access info from the BFF,
       * using that filter function.
       *
       * Depending on where you're calling the hook from (legacy GAS Nav or new GSN Nav), and the data available,
       * call EITHER `updateFromAppAccessFilter` OR `updateFromHydratedShortcuts`.
       *
       * This function should be removed when tidying up the A/A test for productionisation
       */ updateFromAppAccessFilter: ({ getFilteredProductLinks: getFilteredProductLinks, limitToOnlyApsKeys: limitToOnlyApsKeys, visibleMenuIds: visibleMenuIds })=>{
                // Active in both modes — the cookie cache is kept warm as
                // a fallback against cohort flips / gate-off.
                if (!enabled) return;
                const access = (0, $5a97f3a58ec0ddb1$export$8ec65f29d950d5d3)({
                    getFilteredProductLinks: getFilteredProductLinks,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                const visibility = (0, $5a97f3a58ec0ddb1$export$a8f7dcbfec997a77)({
                    visibleMenuIds: visibleMenuIds,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                updateFromDynamicEligibility({
                    access: access,
                    visibility: visibility
                });
            },
            /**
       * Call this function when BFF yields a new version of the `getFilteredProductLinks` function.
       *
       * It will update our eligibility cache based on app access info from the BFF,
       * using that filter function.
       *
       * Depending on where you're calling the hook from (legacy GAS Nav or new GSN Nav), and the data available,
       * call EITHER `updateFromAppAccessFilter` OR `updateFromHydratedShortcuts`.
       *
       * This function should be removed when tidying up the A/A test for productionisation
       */ updateFromHydratedShortcuts: ({ shortcuts: shortcuts, limitToOnlyApsKeys: limitToOnlyApsKeys, visibleMenuIds: visibleMenuIds })=>{
                // Active in both modes — see `updateFromAppAccessFilter`.
                if (!enabled) return;
                const access = (0, $5a97f3a58ec0ddb1$export$ef01d2a4fe4032bb)({
                    shortcuts: shortcuts,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                const visibility = (0, $5a97f3a58ec0ddb1$export$a8f7dcbfec997a77)({
                    visibleMenuIds: visibleMenuIds,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                updateFromDynamicEligibility({
                    access: access,
                    visibility: visibility
                });
            },
            /**
       * This function should be removed when tidying up the A/A test for productionisation
       */ updateHydratedProductLinks: (productLinks)=>{
                // Active in both modes — see `updateFromHydratedShortcuts`.
                if (!enabled) return;
                (0, $5a97f3a58ec0ddb1$export$a0ae147fc3589eac)({
                    productLinks: productLinks,
                    cache: cache
                });
            },
            /**
       * This function should be removed when tidying up the A/A test for productionisation
       */ getCachedProductLinks: ()=>{
                // No-op in `mode: 'productionisation'` — callers should read
                // product links from the Relay store seeded by
                // `InvitedAppShortcutsRecommendationsProvider`.
                if (!enabled || isProductionisation) return {};
                return (0, $5a97f3a58ec0ddb1$export$b58ff4178d893ad6)({
                    cache: cache
                });
            },
            /**
       * Call when the user has seen our invited app shortcut in the UI.
       *
       * Adds `firstImpressionAt` info to the cache. UI reads that to only
       * show the `Invited` lozenge animation once (when there hasn't been
       * a previous impression).
       *
       * This function should be removed when tidying up the A/A test for productionisation
       */ registerImpression: ({ products: products = getEligibleInvitedApps() } = {})=>{
                // Active in both modes — see `updateFromHydratedShortcuts`.
                if (enabled) (0, $5a97f3a58ec0ddb1$export$e238a4387f5f61d6)({
                    productsSeen: products,
                    cache: cache
                });
            },
            /**
       * Call when the user converted, i.e. clicked on our invited app shortcut
       * and went on to activate in the target product.
       *
       * Used to mark the user as ineligible so that the treatment does not
       * show up on the next visit, without having to wait for cache to expire.
       *
       * Active in both modes — the cookie cache is kept warm as a
       * fallback against cohort flips / gate-off.
       *
       * This function should be removed when tidying up the A/A test for
       * productionisation.
       */ registerActivation: (product)=>{
                if (enabled) (0, $5a97f3a58ec0ddb1$export$a3cc74cdee943c7f)({
                    product: product,
                    cache: cache
                });
            },
            /**
       * Fire exposure analytics (when the user is eligible).
       */ fireFeatureExposed: (input)=>{
                if (enabled) analytics.fireFeatureExposed({
                    ...input,
                    userId: userId,
                    cloudId: cloudId,
                    mode: input.overrideMode ?? mode
                });
            }
        };
    }, [
        cache,
        cached,
        enabled,
        isProductionisation,
        mode,
        userId,
        cloudId,
        sourceProduct,
        targetProducts,
        canWriteToCache,
        onCacheNeedsRefresh,
        fetchTraits,
        fetchTraitsPolicy,
        analytics
    ]);
};
/**
 * Main cache refresh flow.
 *
 * Triggers a deep cache refresh (fetch traits, collaborators), but only if
 * access/eligibility prefilters indicate possible eligibility, and cache is empty
 * or needs refresh.
 */ async function $cbb96754ef12a174$var$maybeRefreshEligibility({ traitsDeferred: traitsDeferred, analytics: analytics, visibility: visibility, access: access, sourceProduct: sourceProduct, targetProducts: targetProducts, userId: userId, cloudId: cloudId, cache: cache, cached: cached, canWriteToCache: canWriteToCache, onCacheNeedsRefresh: onCacheNeedsRefresh, obtainRefreshLock: obtainRefreshLock, fetchTraits: fetchTraits, fetchTraitsPolicy: fetchTraitsPolicy }) {
    if ((0, $5a97f3a58ec0ddb1$export$8788f7a1e6d8fdb0)({
        targetProducts: targetProducts,
        sourceProduct: sourceProduct,
        dynamicEligibility: {
            visibility: visibility,
            access: access
        }
    })) {
        const cacheNeedsRefresh = doesCacheNeedRefresh();
        // XXX: The 'always-fetch' check was kept here to avoid runtime code changes before QA.
        // But we removed 'always-fetch' from the set of allowed values of fetchTraitsPolicy,
        // because it was dangerous: using it would put unnaceptable load on CollabGraph,
        // even though could be okay for Traits (because Traits are memoized in Jira & already fetched
        // by other experiences). The problem is that fetching collaborators is currently
        // coupled to fetching traits, and 'always-fetch' would also trigger fetching collaborators (!),
        // putting CollabGraph under unnaceptable load.
        // TODO: Remove 'always-fetch' from here, or decouple fetching Collabs from fetching Traits.
        const shouldRefresh = cacheNeedsRefresh || fetchTraits && fetchTraitsPolicy === 'always-fetch';
        if (shouldRefresh && await canWriteToCache({
            cache: cache
        }) && obtainRefreshLock()) {
            if (cacheNeedsRefresh) onCacheNeedsRefresh?.();
            await refreshEligibility();
        }
    }
    function doesCacheNeedRefresh() {
        return cached.eligibility.ineligibilityReason === (0, $f1d25947eb4f426e$export$130cf0f0f2a54797).CACHE_EMPTY || cached.eligibility.ineligibilityReason === (0, $f1d25947eb4f426e$export$130cf0f0f2a54797).CACHE_EMPTY_USER_MISMATCH || cached.eligibility.ineligibilityReason === (0, $f1d25947eb4f426e$export$130cf0f0f2a54797).CACHE_EXPIRED || (0, $5a97f3a58ec0ddb1$export$fe1089e917806f3c)(cached.state);
    }
    async function refreshEligibility() {
        try {
            const traits = await getTraits();
            const updatedCacheState = await (0, $5a97f3a58ec0ddb1$export$b97783bc9c26cb8b)({
                traits: traits,
                access: access,
                visibility: visibility,
                userId: userId,
                cache: cache
            });
            const updatedEligibility = (0, $5a97f3a58ec0ddb1$export$6d313cb53294e81)({
                sourceProduct: sourceProduct,
                targetProducts: targetProducts
            }, updatedCacheState);
            const willNowBeEligible = updatedEligibility.ineligibilityReason === null;
            if (willNowBeEligible && (0, $94ad97d6f20da745$export$9db1624a8af791a4)('twcg-460-personalised-invite-notifications-m2', 'isEnabled', false, {
                fireExperimentExposure: false
            })) {
                const products = (0, $5yEp5.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS);
                const collaboratorsAccess = await getCollaborators({
                    products: products
                });
                (0, $5a97f3a58ec0ddb1$export$606587d4eb77e23d)({
                    collaboratorsWithProducts: collaboratorsAccess,
                    products: products,
                    cache: cache
                });
            }
            analytics.fireEligibilityUpdateSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
        } catch (error) {
            analytics.fireEligibilityUpdateFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                error: error instanceof Error ? error.message : `${error}`
            });
        }
    }
    async function getTraits() {
        if (traitsDeferred.status !== 'initial' || !fetchTraits) return traitsDeferred.promise;
        traitsDeferred.status = 'loading';
        try {
            const traitsPromise = fetchTraits({
                cloudId: cloudId,
                userId: userId
            });
            // Resolving with traitsPromise adopts traitsPromise's fulfillment/rejection:
            traitsDeferred.resolve(traitsPromise);
            const traits = await traitsDeferred.promise;
            traitsDeferred.status = 'fulfilled';
            analytics.fireFetchInvitedAppShortcutsTraitsSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
            return traits;
        } catch (error) {
            traitsDeferred.status = 'rejected';
            analytics.fireFetchInvitedAppShortcutsTraitsFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
            throw error;
        }
    }
    async function getCollaborators({ products: products }) {
        return (0, $3H3Mp.getCollaboratorsInProducts)({
            products: products,
            cloudId: cloudId,
            userId: userId
        }).then((collaboratorsAccess)=>{
            analytics.fireFetchCollaboratorsAccessSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                collaborators: collaboratorsAccess.length
            });
            return collaboratorsAccess;
        }).catch((error)=>{
            analytics.fireFetchCollaboratorsAccessFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                error: error instanceof Error ? error.message : `${error}`
            });
            // fallback to empty collaborators access rather than failing the whole process
            return [];
        });
    }
}
module.exports["useInvitedAppShortcuts"] = $cbb96754ef12a174$export$c2e2a02c27ed0bc1;

});

parcelRegister("1jJCz", function(module, exports) {

var $aQN68 = parcelRequire("aQN68");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");

const $fbb15aeb32df38cf$var$useLicensedProductsQueryForGlobalAppShortcuts = (0, $aQN68.default);
const $fbb15aeb32df38cf$export$54d534cc91e54850 = ()=>{
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($fbb15aeb32df38cf$var$useLicensedProductsQueryForGlobalAppShortcuts, {
        __callerPackage__: "side-navigation"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($fbb15aeb32df38cf$var$useLicensedProductsQueryForGlobalAppShortcuts, {
        __callerPackage__: "side-navigation"
    });
    const { data: data } = queryResult;
    return (0, $cozmU.useMemo)(()=>{
        const licensedProducts = data?.confluence_tenantContext?.licensedProducts || [];
        return licensedProducts.reduce((acc, product)=>{
            if (product.licenseStatus !== 'ACTIVE') return acc;
            switch(product.productKey){
                case 'jira-software':
                    acc.hasJira = true;
                    break;
                case 'loom':
                    acc.hasLoom = true;
                    break;
                default:
                    break;
            }
            return acc;
        }, {
            hasJira: false,
            hasLoom: false
        });
    }, [
        data
    ]);
};
module.exports["useLicensedProducts"] = $fbb15aeb32df38cf$export$54d534cc91e54850;

});

parcelRegister("eI95o", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");


var $7CeAz = parcelRequire("7CeAz");


var $1ytiN = parcelRequire("1ytiN");


var $jyPfN = parcelRequire("jyPfN");

// TODO: there is a large useMenuItems.ts file that might need refactoring, but for the moment lets just duplicate the keys where they are needed
// to avoid coupling the new side navigation code with the old menu item code. We can look at unifying these in the future when we have more clarity on what the new side navigation needs to do.
const $b91cdc93c54e2058$var$SPACE_DIRECTORY_KEY = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $b91cdc93c54e2058$var$PEOPLE_DIRECTORY_KEY = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $b91cdc93c54e2058$export$4873f44d198fe46c = ()=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            allowedWebItems: [
                $b91cdc93c54e2058$var$SPACE_DIRECTORY_KEY,
                $b91cdc93c54e2058$var$PEOPLE_DIRECTORY_KEY
            ]
        };
        $[0] = t0;
    } else t0 = $[0];
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)(t0);
    const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const { frontCoverState: frontCoverState, loading: loading } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    let t1;
    if ($[1] !== hasViewUserProfilePermission || $[2] !== webItems || $[3] !== webItemsLoading) {
        t1 = !webItemsLoading && (hasViewUserProfilePermission || !!webItems.find($b91cdc93c54e2058$var$_temp));
        $[1] = hasViewUserProfilePermission;
        $[2] = webItems;
        $[3] = webItemsLoading;
        $[4] = t1;
    } else t1 = $[4];
    const isPeopleVisible = t1;
    const isCompanyHubVisible = !loading && isCompanyHubEntryPointEnabled && !!frontCoverState;
    let t2;
    if ($[5] !== isCompanyHubVisible || $[6] !== isPeopleVisible) {
        t2 = {
            isPeopleVisible: isPeopleVisible,
            isCompanyHubVisible: isCompanyHubVisible
        };
        $[5] = isCompanyHubVisible;
        $[6] = isPeopleVisible;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
function $b91cdc93c54e2058$var$_temp(item) {
    return item.completeKey === $b91cdc93c54e2058$var$PEOPLE_DIRECTORY_KEY;
}
module.exports["useShortcutVisibilityOverrides"] = $b91cdc93c54e2058$export$4873f44d198fe46c;

});

parcelRegister("h7d8T", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eW61a = parcelRequire("eW61a");


var $1NBp8 = parcelRequire("1NBp8");


var $bQm3c = parcelRequire("bQm3c");


var $5XsiK = parcelRequire("5XsiK");

const $3fcbe4d85cbec684$export$597036aedc68c98f = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId || $[1] !== orgId) {
        t0 = (0, $eW61a.navigateToTeamsApp)({
            type: "LANDING",
            cloudId: cloudId,
            orgId: orgId,
            userHasNav4Enabled: true
        });
        $[0] = cloudId;
        $[1] = orgId;
        $[2] = t0;
    } else t0 = $[2];
    const { href: href } = t0;
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.COMPANY_HUB).toUrl();
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== href) {
        t2 = (0, $5XsiK.isTeamsAppEnabled)() ? href : "";
        $[4] = href;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            companyHubShortcut: t1,
            teamsShortcut: t2
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["useFallbackUrls"] = $3fcbe4d85cbec684$export$597036aedc68c98f;

});

parcelRegister("asbHm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $4aRua = parcelRequire("4aRua");


var $9chzr = parcelRequire("9chzr");


var $2K2hA = parcelRequire("2K2hA");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $2Vz7H = parcelRequire("2Vz7H");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $3eYzF = parcelRequire("3eYzF");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $lsxnT = parcelRequire("lsxnT");


var $u7mpJ = parcelRequire("u7mpJ");

/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */ // Not a good idea to use experiment prefix in potentially long-lasting i18n strings



const $3b8a0fc692cee1ba$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    weAddedFeatures: {
        id: "creation-focused-nav.we-added-features",
        defaultMessage: "We added features to your sidebar"
    },
    toChangeYourView: {
        id: "creation-focused-nav.toChangeYourView",
        defaultMessage: "To change your view, customize your sidebar in the {menuName} menu"
    },
    more: {
        id: "creation-focused-nav.more",
        defaultMessage: "More"
    },
    customizeSidebar: {
        id: "creation-focused-nav.customizeSidebar",
        defaultMessage: "Customize sidebar"
    },
    gotIt: {
        id: "creation-focused-nav.gotIt",
        defaultMessage: "Got it"
    }
});


// Stable reference so SpotlightUpdateOnChange doesn't rewire its MutationObserver each render.
const $f373027e4dce4138$var$DEFAULT_REPOSITION_SELECTORS = [
    'nav#side-navigation'
];
const $f373027e4dce4138$export$ea3b4f1126b4c509 = ({ isCollapsed: isCollapsed, children: children, repositionSelectors: repositionSelectors = $f373027e4dce4138$var$DEFAULT_REPOSITION_SELECTORS })=>{
    const { isSpotlightVisible: isSpotlightVisible, onSpotlightShown: onSpotlightShown } = (0, $u7mpJ.useCreationFocusedNavLand)();
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [hasDismissed, setHasDismissed] = (0, $cozmU.useState)(false);
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isSpotlightVisible) setShouldShowSpotlight(true);
    }, [
        isSpotlightVisible
    ]);
    const onDismiss = (reason)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissedCreationFocusedNavSpotlight',
                source: 'creation-focused-nav-button-spotlight',
                attributes: {
                    reason: reason
                }
            }
        }).fire();
        setHasDismissed(true);
    };
    const onShown = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'spotlight',
                actionSubjectId: 'creationFocusedNavSpotlight',
                source: 'creation-focused-nav-button-spotlight'
            }
        }).fire();
        onSpotlightShown?.();
    };
    const isVisible = !isCollapsed && !hasDismissed && shouldShowSpotlight;
    if (!isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9chzr.UNSAFE_UpdateOnChange), {
        selectors: repositionSelectors
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PopoverContent, {
        messageId: "creation-focused-nav-more-features-spotlight",
        messageType: "engagement",
        placement: "right-end",
        dismiss: ()=>onDismiss('auto'),
        isVisible: isVisible,
        onMessageDisposition: (status)=>{
            if (status === 'started') onShown();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).weAddedFeatures)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
        onClick: ()=>onDismiss('dismiss-control')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).toChangeYourView,
        values: {
            menuName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                as: "strong"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).more))
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: ()=>onDismiss('primary-action')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).gotIt)))))));
};
module.exports["AddFeaturesSidebarSpotlight"] = $f373027e4dce4138$export$ea3b4f1126b4c509;

});

parcelRegister("7DAwP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");








var $bltJZ = parcelRequire("bltJZ");


var $cXPtd = parcelRequire("cXPtd");


var $jlJcq = parcelRequire("jlJcq");


var $kSwu1 = parcelRequire("kSwu1");

const $21ddb7fe117e7703$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.company-hub",
        defaultMessage: "Company Hub"
    }
});


const $06220aed8ea29e60$var$icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.HubIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $06220aed8ea29e60$export$50e5fd99bfef1a4a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (fallbackUrl, t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    let t2;
    if ($[2] !== options) {
        t2 = {
            analyticsName: (0, $cXPtd.Products).ATLAS_HUB,
            ...options
        };
        $[2] = options;
        $[3] = t2;
    } else t2 = $[3];
    return (0, $jlJcq.useAppGlobalShortcutLinkItem)($06220aed8ea29e60$var$icon, (0, $21ddb7fe117e7703$export$defe85febe8b728c).label, fallbackUrl, t2);
} : (fallbackUrl, options = {})=>(0, $jlJcq.useAppGlobalShortcutLinkItem)($06220aed8ea29e60$var$icon, (0, $21ddb7fe117e7703$export$defe85febe8b728c).label, fallbackUrl, {
        analyticsName: (0, $cXPtd.Products).ATLAS_HUB,
        ...options
    });



var $aJMnP = parcelRequire("aJMnP");






















const $77020e4dafdf788c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.loom",
        defaultMessage: "Loom"
    }
});


const $69df8e54deacec7c$var$icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.LoomIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $69df8e54deacec7c$export$ef6b4021b8157342 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (fallbackUrl, t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    let t2;
    if ($[2] !== options) {
        t2 = {
            apsKey: (0, $cXPtd.Products).LOOM,
            analyticsName: (0, $cXPtd.Products).LOOM,
            ...options
        };
        $[2] = options;
        $[3] = t2;
    } else t2 = $[3];
    return (0, $jlJcq.useAppGlobalShortcutLinkItem)($69df8e54deacec7c$var$icon, (0, $77020e4dafdf788c$export$defe85febe8b728c).label, fallbackUrl, t2);
} : (fallbackUrl, options = {})=>(0, $jlJcq.useAppGlobalShortcutLinkItem)($69df8e54deacec7c$var$icon, (0, $77020e4dafdf788c$export$defe85febe8b728c).label, fallbackUrl, {
        apsKey: (0, $cXPtd.Products).LOOM,
        analyticsName: (0, $cXPtd.Products).LOOM,
        ...options
    });



var $6ptdq = parcelRequire("6ptdq");


var $5XsiK = parcelRequire("5XsiK");


var $8dN99 = parcelRequire("8dN99");


var $eI95o = parcelRequire("eI95o");


var $h7d8T = parcelRequire("h7d8T");


var $1jJCz = parcelRequire("1jJCz");

const $f02b9571823f0450$export$ed2673425deb0c2f = (props)=>{
    const $ = (0, $bDgLe.c)(21);
    const fallbackUrls = (0, $h7d8T.useFallbackUrls)();
    const { hasLoom: hasLoom, hasJira: hasJira } = (0, $1jJCz.useLicensedProducts)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $5XsiK.isTeamsAppEnabled)();
        $[0] = t0;
    } else t0 = $[0];
    const teamsAppEnabled = t0;
    const { isPeopleVisible: isPeopleVisible, isCompanyHubVisible: isCompanyHubVisible } = (0, $eI95o.useShortcutVisibilityOverrides)();
    const companyHubShortcutWithoutComponent = (0, $06220aed8ea29e60$export$50e5fd99bfef1a4a)(fallbackUrls.companyHubShortcut);
    const jiraShortcut = (0, $aJMnP.useJira)("");
    const loomShortcut = (0, $69df8e54deacec7c$export$ef6b4021b8157342)("");
    const teamsShortcut = (0, $6ptdq.useTeams)(fallbackUrls.teamsShortcut);
    props?.teamsShortcutConfig;
    let t1;
    if ($[1] !== companyHubShortcutWithoutComponent) {
        t1 = {
            ...companyHubShortcutWithoutComponent,
            menuItemId: "companyHubShortcut",
            type: "component",
            isReorderable: true,
            component: $f02b9571823f0450$var$_temp
        };
        $[1] = companyHubShortcutWithoutComponent;
        $[2] = t1;
    } else t1 = $[2];
    const companyHubShortcut = t1;
    let t2;
    if ($[3] !== companyHubShortcut || $[4] !== isCompanyHubVisible) {
        t2 = isCompanyHubVisible ? {
            companyHubShortcut: companyHubShortcut
        } : {};
        $[3] = companyHubShortcut;
        $[4] = isCompanyHubVisible;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== hasJira || $[7] !== jiraShortcut) {
        t3 = hasJira ? {
            jiraShortcut: jiraShortcut
        } : {};
        $[6] = hasJira;
        $[7] = jiraShortcut;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== hasLoom || $[10] !== loomShortcut) {
        t4 = hasLoom ? {
            loomShortcut: loomShortcut
        } : {};
        $[9] = hasLoom;
        $[10] = loomShortcut;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== isPeopleVisible || $[13] !== props?.teamsShortcutConfig || $[14] !== teamsShortcut) {
        t5 = isPeopleVisible && teamsAppEnabled ? {
            teamsShortcut: props?.teamsShortcutConfig ?? teamsShortcut
        } : {};
        $[12] = isPeopleVisible;
        $[13] = props?.teamsShortcutConfig;
        $[14] = teamsShortcut;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
        t6 = {
            ...t2,
            ...t3,
            ...t4,
            ...t5
        };
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
};
function $f02b9571823f0450$var$_temp(itemProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8dN99.CompanyHubItem), itemProps);
}
module.exports["useShortcutItemsConfig"] = $f02b9571823f0450$export$ed2673425deb0c2f;

});

parcelRegister("aGiXn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $4aRua = parcelRequire("4aRua");


var $9DHhW = parcelRequire("9DHhW");


var $6ptdq = parcelRequire("6ptdq");


var $bQm3c = parcelRequire("bQm3c");


var $hSHWm = parcelRequire("hSHWm");


var $gqqjz = parcelRequire("gqqjz");


var $koZ31 = parcelRequire("koZ31");








var $aRGok = parcelRequire("aRGok");


var $gE9bl = parcelRequire("gE9bl");


var $jmjWc = parcelRequire("jmjWc");





const $063311bef2820fe3$var$LazyTeamCreateDialog = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dULDy",
    name: "LazyTeamCreateDialog",
    loader: ()=>(parcelRequire("bdbYY")).then(({ TeamCreateDialog: TeamCreateDialog })=>TeamCreateDialog),
    loading: ()=>null
});
function $063311bef2820fe3$export$9169fd4d2562e042(t0) {
    const $ = (0, $bDgLe.c)(10);
    const { isOpen: isOpen, onClose: onClose, addFlag: addFlag } = t0;
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== addFlag) {
        t1 = (flag)=>{
            const { title: title, description: description, appearance: appearance, actions: actions } = flag;
            addFlag({
                type: appearance === "success" || appearance === "normal" ? "success-circle" : appearance,
                title: title,
                description: description,
                close: "auto",
                actions: actions,
                id: flag.id
            });
        };
        $[0] = addFlag;
        $[1] = t1;
    } else t1 = $[1];
    const addFlagFn = t1;
    let t2;
    if ($[2] !== addFlagFn || $[3] !== cloudId || $[4] !== isOpen || $[5] !== onClose || $[6] !== orgId) {
        t2 = isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gE9bl.PeopleAndTeamsConfigurationProvider), {
            product: "confluence"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($063311bef2820fe3$var$LazyTeamCreateDialog, {
            cloudId: cloudId,
            product: "confluence",
            orgId: orgId,
            onClose: onClose,
            enableMembershipSettingsChoice: true,
            enableTeamPermissionCheck: true,
            onCreateTeamSuccess: onClose,
            onCreateTeamFailed: onClose,
            addFlag: addFlagFn
        }))) : null;
        $[2] = addFlagFn;
        $[3] = cloudId;
        $[4] = isOpen;
        $[5] = onClose;
        $[6] = orgId;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t2);
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
}



var $h7d8T = parcelRequire("h7d8T");

const $276167d1ecf073e2$var$ACTION_SUBJECT_ID = 'teamsAppShortcut';
const $276167d1ecf073e2$var$CREATE_A_TEAM = 'createATeam';
const $276167d1ecf073e2$var$INVITE_PEOPLE = 'invitePeople';
const $276167d1ecf073e2$export$68b2e4594fafcb97 = ()=>{
    const $ = (0, $bDgLe.c)(24);
    const hasFiredExposure = (0, $cozmU.useRef)(false);
    const fallbackUrls = (0, $h7d8T.useFallbackUrls)();
    const shortcutUrl = fallbackUrls.teamsShortcut;
    const teamsShortcut = (0, $6ptdq.useTeams)(shortcutUrl);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openCoreInvites: openCoreInvites } = (0, $cozmU.useContext)((0, $hSHWm.CoreInvitesContext));
    const [isCreateTeamModalOpen, setCreateTeamModalOpen] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = ()=>{
            if (!hasFiredExposure.current) {
                hasFiredExposure.current = true;
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        source: "globalNavigation",
                        action: "mouseEnter",
                        actionSubject: "navigationItem",
                        actionSubjectId: $276167d1ecf073e2$var$ACTION_SUBJECT_ID
                    }
                }).fire();
            }
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== cloudId || $[3] !== formatMessage || $[4] !== openCoreInvites) {
        t1 = openCoreInvites ? [
            {
                onClick: ()=>{
                    openCoreInvites((0, $koZ31.CoreInvitesSource).PEOPLE_MENU, {
                        onModalClosed: $276167d1ecf073e2$var$_temp,
                        onInviteCompleted: $276167d1ecf073e2$var$_temp2
                    }, undefined, {
                        resourceAri: `ari:cloud:confluence::site/${cloudId}`,
                        source: $276167d1ecf073e2$var$ACTION_SUBJECT_ID
                    });
                },
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage($276167d1ecf073e2$var$messages.invitePeople)),
                itemId: $276167d1ecf073e2$var$INVITE_PEOPLE
            }
        ] : [];
        $[2] = cloudId;
        $[3] = formatMessage;
        $[4] = openCoreInvites;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setCreateTeamModalOpen(true);
        };
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== formatMessage) {
        t3 = formatMessage($276167d1ecf073e2$var$messages.createTeam);
        $[7] = formatMessage;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t3) {
        t4 = {
            onClick: t2,
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, t3),
            itemId: $276167d1ecf073e2$var$CREATE_A_TEAM
        };
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t1 || $[12] !== t4) {
        t5 = [
            ...t1,
            t4
        ];
        $[11] = t1;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t0 || $[15] !== t5 || $[16] !== teamsShortcut) {
        t6 = {
            ...teamsShortcut,
            onMouseEnter: t0,
            actions: t5
        };
        $[14] = t0;
        $[15] = t5;
        $[16] = teamsShortcut;
        $[17] = t6;
    } else t6 = $[17];
    const config = t6;
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== isCreateTeamModalOpen) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t7
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $063311bef2820fe3$export$9169fd4d2562e042), {
                isOpen: isCreateTeamModalOpen,
                onClose: ()=>setCreateTeamModalOpen(false),
                addFlag: flags.showFlag
            }));
        $[19] = isCreateTeamModalOpen;
        $[20] = t8;
    } else t8 = $[20];
    const createTeamModalComponent = t8;
    let t9;
    if ($[21] !== config || $[22] !== createTeamModalComponent) {
        t9 = {
            config: config,
            component: createTeamModalComponent
        };
        $[21] = config;
        $[22] = createTeamModalComponent;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
};
const $276167d1ecf073e2$var$messages = (0, $kSwu1.defineMessages)({
    invitePeople: {
        id: "side-navigation.custom.teams-app-shortcut.invite-people",
        defaultMessage: "Invite people"
    },
    createTeam: {
        id: "side-navigation.custom.teams-app-shortcut.create-team",
        defaultMessage: "Create team"
    }
});
function $276167d1ecf073e2$var$_temp() {
    return null;
}
function $276167d1ecf073e2$var$_temp2() {
    return null;
}
module.exports["useTeamsAppShortcut"] = $276167d1ecf073e2$export$68b2e4594fafcb97;

});

parcelRegister("bdbYY", function(module, exports) {

let $829a340db8b498d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $829a340db8b498d4$var$load("3Yccm"),
    $829a340db8b498d4$var$load("eaKki"),
    $829a340db8b498d4$var$load("6wr18"),
    $829a340db8b498d4$var$load("7PNtH"),
    $829a340db8b498d4$var$load("cjxKe"),
    $829a340db8b498d4$var$load("1RnD4"),
    $829a340db8b498d4$var$load("hE9re"),
    $829a340db8b498d4$var$load("fWgnv"),
    $829a340db8b498d4$var$load("9uywJ"),
    $829a340db8b498d4$var$load("kHXvF"),
    $829a340db8b498d4$var$load("ffEVr"),
    $829a340db8b498d4$var$load("5Mm1x"),
    $829a340db8b498d4$var$load("hhss7"),
    $829a340db8b498d4$var$load("Wowvf"),
    $829a340db8b498d4$var$load("eRhBr"),
    $829a340db8b498d4$var$load("7EorR"),
    $829a340db8b498d4$var$load("jtobV")
]).then(()=>parcelRequire('eCvkM'));

});

parcelRegister("9vJRo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aDe4X = parcelRequire("aDe4X");

/* eslint-disable import/no-duplicates */ 



var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $jYwSK = parcelRequire("jYwSK");


var $ivb8S = parcelRequire("ivb8S");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $b3j2Y = parcelRequire("b3j2Y");


var $lsxnT = parcelRequire("lsxnT");


var $b4VFP = parcelRequire("b4VFP");














var $3SChL = parcelRequire("3SChL");

const $996603fe96782b8b$export$8f136d122118bae4 = ({ skip: skip = false } = {})=>{
    const isOnHomeOrWikiRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.WIKI).name || routeName === (0, $1NBp8.HOME).name;
        }
    };
    const isOnHome = (0, $dPJCf.useRouteName)(isOnHomeOrWikiRouteArgs);
    const { active: isNthUserOrientationActive } = (0, $3SChL.useNthUserOrientationState)();
    const localSkip = skip || isOnHome || isNthUserOrientationActive;
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS)), localSkip);
    const { hasSeenHomeNudge: hasSeenHomeNudge, takeoverSeenAt: takeoverSeenAt, hasDismissedTakeover: hasDismissedTakeover, isHomeNudgeScheduledAt: isHomeNudgeScheduledAt } = (0, $ivb8S.deserializeState)(data);
    if (localSkip || loading || error) return {
        isEligibleForHomeNudge: false,
        isOnHome: isOnHome,
        loading: loading,
        error: error
    };
    return {
        isEligibleForHomeNudge: Boolean(!hasSeenHomeNudge && !takeoverSeenAt && !hasDismissedTakeover),
        isHomeNudgeScheduledAt: isHomeNudgeScheduledAt,
        isOnHome: isOnHome,
        loading: loading,
        error: error
    };
};



var $gi4qj = parcelRequire("gi4qj");


var $6Yblc = parcelRequire("6Yblc");


var $2K2hA = parcelRequire("2K2hA");


var $3eYzF = parcelRequire("3eYzF");


var $2Vz7H = parcelRequire("2Vz7H");


var $uyMbP = parcelRequire("uyMbP");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $dOlTT = parcelRequire("dOlTT");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

const $d3cc8422fc7cecaf$var$i18n = (0, $kSwu1.defineMessages)({
    homeSpotlightHeader: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.title",
        defaultMessage: "More ways to get started \uD83D\uDCA1"
    },
    homeSpotlightText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.description",
        defaultMessage: "When you\u2019re ready, discover tailored onboarding suggestions in For You."
    },
    homeSpotlightCloseButtonText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.button-got-it",
        defaultMessage: "Got it"
    },
    homeSpotlightTryItButtonText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.button-go-to-for-you",
        defaultMessage: "Go to For You"
    }
});
const $d3cc8422fc7cecaf$export$8ee05f5dc902d0f5 = ({ children: children })=>{
    const [isHomeNudgeHidden, setIsHomeNudgeHidden] = (0, $cozmU.useState)(true);
    const wasEligibleForOnboardingNudgeRef = (0, $cozmU.useRef)(false);
    const timeoutRef = (0, $cozmU.useRef)(undefined);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    // This is the onboarding state hidden
    const { isEligibleForHomeNudge: isEligibleForHomeNudge, isOnHome: isOnHome, error: error, isHomeNudgeScheduledAt: isHomeNudgeScheduledAt } = (0, $996603fe96782b8b$export$8f136d122118bae4)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const expandSideNav = (0, $jYwSK.useExpandSideNav)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const transitionIdRef = (0, $cozmU.useRef)(null);
    const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer('nth-user-home-onboarding-takeover-v2-home-nudge', {
        start: ()=>setIsHomeNudgeHidden(false),
        stop: ()=>setIsHomeNudgeHidden(true)
    });
    const handleDismiss = ()=>{
        setIsHomeNudgeHidden(true);
        stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'nthUserHomeOnboardingTakeoverV2HomeNudgeDismiss',
                source: 'onboarding'
            }
        }).fire();
    };
    const handleGoHome = ()=>{
        push((0, $1NBp8.HOME).toUrl());
        stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'nthUserHomeOnboardingTakeoverV2HomeNudgeGoHome',
                source: 'onboarding'
            }
        }).fire();
    };
    (0, $cozmU.useEffect)(()=>{
        const showNudge = ()=>{
            setOnboardingState({
                key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasSeenHomeNudge,
                value: 'true'
            });
            startMessage();
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    action: 'viewed',
                    name: 'nthUserHomeOnboardingTakeoverV2HomeNudge'
                }
            }).fire();
            expandSideNav();
        };
        if (isEligibleForHomeNudge && isHomeNudgeHidden && (!wasEligibleForOnboardingNudgeRef.current || transitionIdRef.current !== transitionId)) {
            // first time about to show nudge, wait 2mins seconds before showing
            // Upon subsequent reloads or navigation, show the nudge immediately
            if (!timeoutRef.current && !isHomeNudgeScheduledAt) {
                timeoutRef.current = setTimeout(()=>{
                    showNudge();
                    clearTimeout(timeoutRef.current);
                }, 120000);
                setOnboardingState({
                    key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).isHomeNudgeScheduledAt,
                    value: new Date().toISOString()
                });
            } else if (isHomeNudgeScheduledAt && (transitionId === 0 || transitionIdRef.current !== transitionId)) {
                showNudge();
                clearTimeout(timeoutRef.current);
            }
            wasEligibleForOnboardingNudgeRef.current = true;
        }
        transitionIdRef.current = transitionId;
    }, [
        createAnalyticsEvent,
        isEligibleForHomeNudge,
        isHomeNudgeHidden,
        setOnboardingState,
        startMessage,
        stopMessage,
        expandSideNav,
        transitionId,
        isHomeNudgeScheduledAt
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const isNudgeHidden = !isHomeNudgeHidden && (wasEligibleForOnboardingNudgeRef.current || isEligibleForHomeNudge);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: handleDismiss,
        placement: "right-end",
        isVisible: isNudgeHidden && !isOnHome
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
        onClick: handleDismiss
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: handleGoHome
    }, formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightTryItButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Yblc.SpotlightSecondaryAction), {
        onClick: handleDismiss
    }, formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightCloseButtonText)))))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
};


const $4ac6d1a639d952f5$export$7f711697718dffe7 = ({ children: children })=>{
    const { isEligible: v2NthUserEligible, loading: v2NthUserLoading } = (0, $aDe4X.useNthUserHomeOnboardingTakeoverV2Eligibility)();
    if (v2NthUserLoading) return children;
    if (v2NthUserEligible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3cc8422fc7cecaf$export$8ee05f5dc902d0f5), {
        position: "bottom-start"
    }, children);
    return children;
};
module.exports["HomeOnboardingTakeoverV2HomeNudge"] = $4ac6d1a639d952f5$export$7f711697718dffe7;

});

parcelRegister("aKkeT", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6GD8y = parcelRequire("6GD8y");


var $dPJCf = parcelRequire("dPJCf");

const $d2fc0c31cdd9908e$export$65c30f73882c92dc = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { href: href, keyboardShortcut: keyboardShortcut, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut, isAppNavigationShortcut: isAppNavigationShortcut, children: children, onShortcutTriggered: onShortcutTriggered } = t0;
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t1;
    if ($[0] !== href || $[1] !== onShortcutTriggered || $[2] !== push) {
        t1 = ()=>{
            onShortcutTriggered?.();
            href && push(href);
        };
        $[0] = href;
        $[1] = onShortcutTriggered;
        $[2] = push;
        $[3] = t1;
    } else t1 = $[3];
    const listenerCallback = t1;
    let t2;
    if ($[4] !== deprecatedKeyboardShortcut || $[5] !== isAppNavigationShortcut || $[6] !== keyboardShortcut || $[7] !== listenerCallback) {
        t2 = keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: deprecatedKeyboardShortcut,
            accelerator: keyboardShortcut,
            listener: listenerCallback,
            isAppNavigationShortcut: isAppNavigationShortcut || false
        });
        $[4] = deprecatedKeyboardShortcut;
        $[5] = isAppNavigationShortcut;
        $[6] = keyboardShortcut;
        $[7] = listenerCallback;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== children || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children, t2);
        $[9] = children;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
});
module.exports["KeyboardShortcutWrapper"] = $d2fc0c31cdd9908e$export$65c30f73882c92dc;

});

parcelRegister("4ByCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dzwLE = parcelRequire("dzwLE");


var $asbHm = parcelRequire("asbHm");


var $9vJRo = parcelRequire("9vJRo");


var $166II = parcelRequire("166II");


var $4RzTC = parcelRequire("4RzTC");


var $41KFX = parcelRequire("41KFX");


var $86Bi3 = parcelRequire("86Bi3");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $hjygH = parcelRequire("hjygH");

var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $6mKj3 = parcelRequire("6mKj3");


var $efvKr = parcelRequire("efvKr");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $de2j9 = parcelRequire("de2j9");


var $bQm3c = parcelRequire("bQm3c");


var $gnkil = parcelRequire("gnkil");


var $XO4by = parcelRequire("XO4by");


var $eLFsG = parcelRequire("eLFsG");


var $aKkeT = parcelRequire("aKkeT");


var $hl4GB = parcelRequire("hl4GB");


var $jmjWc = parcelRequire("jmjWc");


const $9a55ff81647e826c$export$af1f39df90a1145e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "F33DL",
    name: "RecentContentMenuLoader",
    loader: async ()=>(await (parcelRequire("1eSiZ"))).RecentContentMenu
});



var $eoKnG = parcelRequire("eoKnG");





const $b70cb2d8a5778044$export$17b89e6a36c6b530 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r7JbD",
    name: "StarredContentMenuLoader",
    loader: async ()=>(await (parcelRequire("drwFS"))).StarredContentMenu
});



var $7iBL4 = parcelRequire("7iBL4");


var $iQcdJ = parcelRequire("iQcdJ");


var $26Pni = parcelRequire("26Pni");

const $b9f550940f484a79$var$recentAttributes = {
    navVersion: '4',
    dropdownType: 'recent'
};
// This wrapper is the Recent item's ItemWrapper, so it only renders when GSN renders Recent — i.e.
// Recent is in the nav. useSimplifiedNavSpotlight derives isRecentInMainNav by checking for a
// 'recent' entry, so we pass a single-item list to signal "Recent is present".
const $b9f550940f484a79$var$RECENT_IN_MAIN_NAV = [
    {
        menuId: 'recent'
    }
];
// GSN's <nav> has no stable id, so spotlights observe its (non-localized) aria-label to reposition
// on nav mutations.
const $b9f550940f484a79$var$GSN_NAV_SELECTORS = [
    'nav[aria-label="Sidebar"]'
];
const $b9f550940f484a79$var$starredAttributes = {
    navVersion: '4',
    dropdownType: 'starred'
};
const $b9f550940f484a79$var$StopRecent = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjygH.ExperienceStop), {
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            attributes: $b9f550940f484a79$var$recentAttributes
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $b9f550940f484a79$var$StopStarred = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjygH.ExperienceStop), {
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            attributes: $b9f550940f484a79$var$starredAttributes
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $b9f550940f484a79$var$RecentEmptyStateExperiment = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $6mKj3.expVal)("cc_mohiti_nav_empty_states", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hl4GB.DiscoErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eoKnG.RecentsEmptyStateLoader), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dzwLE.NavFlyoutEmptyState), null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $b9f550940f484a79$var$StarredEmptyStateExperiment = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $6mKj3.expVal)("cc_mohiti_nav_empty_states", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hl4GB.DiscoErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7iBL4.StarredEmptyStateLoader), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dzwLE.NavFlyoutEmptyState), {
            variant: "starred"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $b9f550940f484a79$var$ForYouItemWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, homeUrl: homeUrl, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9vJRo.HomeOnboardingTakeoverV2HomeNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $166II.EditorForYouSpotlight), null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== deprecatedKeyboardShortcut || $[3] !== homeUrl || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hl4GB.DiscoErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKkeT.KeyboardShortcutWrapper), {
            href: homeUrl,
            deprecatedKeyboardShortcut: deprecatedKeyboardShortcut,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_HOME_SHORTCUT),
            isAppNavigationShortcut: true
        }, t1));
        $[2] = deprecatedKeyboardShortcut;
        $[3] = homeUrl;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
const $b9f550940f484a79$var$GenericItemWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut, keyboardShortcut: keyboardShortcut, onMouseEnter: onMouseEnter, onShortcutTriggered: onShortcutTriggered } = t0;
    let t1;
    if ($[0] !== children || $[1] !== deprecatedKeyboardShortcut || $[2] !== keyboardShortcut || $[3] !== onShortcutTriggered) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKkeT.KeyboardShortcutWrapper), {
            deprecatedKeyboardShortcut: deprecatedKeyboardShortcut,
            keyboardShortcut: keyboardShortcut,
            isAppNavigationShortcut: true,
            onShortcutTriggered: onShortcutTriggered
        }, children);
        $[0] = children;
        $[1] = deprecatedKeyboardShortcut;
        $[2] = keyboardShortcut;
        $[3] = onShortcutTriggered;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== onMouseEnter || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hl4GB.DiscoErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: onMouseEnter,
            onFocus: onMouseEnter
        }, t1));
        $[5] = onMouseEnter;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
// New-nav eligibility for the simplify-nav (5565) spotlight. Anchored to Recent, so Recent is always
// in main nav. The gate is evaluated in RecentSpotlights, not here.
const $b9f550940f484a79$var$useSimplifyNavSpotlightForNewNav = ()=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $9wGTI.fg)("simplify_nav_gsn");
        $[0] = t0;
    } else t0 = $[0];
    const { navStyle: navStyle, isWithinD0: isWithinD0, source: source } = (0, $41KFX.useSimplifiedNavNewUsers)(!t0);
    let t1;
    if ($[1] !== isWithinD0 || $[2] !== navStyle) {
        t1 = {
            globalMenuItems: $b9f550940f484a79$var$RECENT_IN_MAIN_NAV,
            navStyle: navStyle,
            isWithinD0: isWithinD0
        };
        $[1] = isWithinD0;
        $[2] = navStyle;
        $[3] = t1;
    } else t1 = $[3];
    const { shouldShowSpotlight: shouldShowSpotlight } = (0, $86Bi3.useSimplifiedNavSpotlight)(t1);
    let t2;
    if ($[4] !== shouldShowSpotlight || $[5] !== source) {
        t2 = {
            shouldShowSpotlight: shouldShowSpotlight,
            source: source
        };
        $[4] = shouldShowSpotlight;
        $[5] = source;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
/**
 * Wraps Recent with the two onboarding spotlights previously mounted in the old nav, gated by
 * `simplify_nav_gsn`:
 *  - `SimplifyNavNewUserSpotlight` (5565) — driven by parent eligibility.
 *  - `AddFeaturesSidebarSpotlight` (4473) — self-contained; reads its own onboarding state.
 */ const $b9f550940f484a79$var$RecentSpotlights = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { shouldShowSpotlight: shouldShowSpotlight, source: source } = $b9f550940f484a79$var$useSimplifyNavSpotlightForNewNav();
    if (!(0, $9wGTI.fg)("simplify_nav_gsn")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children || $[3] !== shouldShowSpotlight || $[4] !== source) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $asbHm.AddFeaturesSidebarSpotlight), {
            repositionSelectors: $b9f550940f484a79$var$GSN_NAV_SELECTORS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4RzTC.SimplifyNavNewUserSpotlight), {
            shouldShowSpotlight: shouldShowSpotlight,
            source: source,
            repositionSelectors: $b9f550940f484a79$var$GSN_NAV_SELECTORS
        }, children));
        $[2] = children;
        $[3] = shouldShowSpotlight;
        $[4] = source;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $b9f550940f484a79$export$f29dcc074aa4bb66 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const homeUrl = (0, $1NBp8.HOME).toUrl();
    const isHomeSelected = (0, $dPJCf.useRouteUrl)($b9f550940f484a79$var$isOnHomeSelector);
    const isRecentOpenRef = (0, $cozmU.useRef)(false);
    const recentsFilterConfig = (0, $iQcdJ.useRecentsFilterConfig)();
    const recentViewAllUrl = (0, $1NBp8.HOME).toUrl({
        view: 'recent'
    });
    const [isRecentOpen, setIsRecentOpen] = (0, $cozmU.useState)(false);
    const isRecentSelected = (0, $dPJCf.useRouteUrl)($b9f550940f484a79$var$isOnRecentRoute);
    const onRecentMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (!isRecentOpenRef.current) {
            (0, $9a55ff81647e826c$export$af1f39df90a1145e).preload();
            (0, $XO4by.preloadRecentContentMenu)(cloudId);
        }
    }, [
        cloudId
    ]);
    const onRecentShortcut = (0, $cozmU.useCallback)(()=>{
        const next = !isRecentOpenRef.current;
        isRecentOpenRef.current = next;
        setIsRecentOpen(next);
        if (next) {
            isStarredOpenRef.current = false;
            setIsStarredOpen(false);
        }
    }, []);
    const isStarredOpenRef = (0, $cozmU.useRef)(false);
    const starredViewAllUrl = (0, $1NBp8.HOME).toUrl({
        view: 'starred'
    });
    const [isStarredOpen, setIsStarredOpen] = (0, $cozmU.useState)(false);
    const isStarredSelected = (0, $dPJCf.useRouteUrl)($b9f550940f484a79$var$isOnStarredRoute);
    const onStarredMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (!isStarredOpenRef.current) {
            (0, $b70cb2d8a5778044$export$17b89e6a36c6b530).preload();
            (0, $eLFsG.preloadStarredContentMenu)();
        }
    }, []);
    const onStarredShortcut = (0, $cozmU.useCallback)(()=>{
        const next_0 = !isStarredOpenRef.current;
        isStarredOpenRef.current = next_0;
        setIsStarredOpen(next_0);
        if (next_0) {
            isRecentOpenRef.current = false;
            setIsRecentOpen(false);
        }
    }, []);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const startExperienceTracker = (0, $cozmU.useCallback)((experienceName)=>{
        experienceTracker.start({
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
            attributes: {
                navVersion: '4',
                dropdownType: experienceName
            }
        });
    }, [
        experienceTracker
    ]);
    const onRecentOpenChange = (0, $cozmU.useCallback)((isOpen)=>{
        if (isOpen) startExperienceTracker('recent');
        isRecentOpenRef.current = isOpen;
        setIsRecentOpen(isOpen);
    }, [
        startExperienceTracker
    ]);
    const onStarredOpenChange = (0, $cozmU.useCallback)((isOpen_0)=>{
        if (isOpen_0) startExperienceTracker('starred');
        isStarredOpenRef.current = isOpen_0;
        setIsStarredOpen(isOpen_0);
    }, [
        startExperienceTracker
    ]);
    const isKeyboardShortcutEnabled = !(isLiveEditMode || isOnEditRoute);
    const ForYouWrapper = (0, $cozmU.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9f550940f484a79$var$ForYouItemWrapper, {
            ...props,
            homeUrl: homeUrl,
            deprecatedKeyboardShortcut: isKeyboardShortcutEnabled ? (0, $gnkil.GO_HOME_SHORTCUT) : undefined
        }), [
        homeUrl,
        isKeyboardShortcutEnabled
    ]);
    const RecentWrapper = (0, $cozmU.useCallback)((props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9f550940f484a79$var$GenericItemWrapper, {
            deprecatedKeyboardShortcut: isKeyboardShortcutEnabled ? (0, $gnkil.GO_TO_RECENT_SHORTCUT) : undefined,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_RECENT_SHORTCUT),
            onMouseEnter: onRecentMouseEnter,
            onShortcutTriggered: onRecentShortcut
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9f550940f484a79$var$RecentSpotlights, null, props_0.children)), [
        isKeyboardShortcutEnabled,
        onRecentMouseEnter,
        onRecentShortcut
    ]);
    const StarredWrapper = (0, $cozmU.useCallback)((props_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9f550940f484a79$var$GenericItemWrapper, {
            ...props_1,
            deprecatedKeyboardShortcut: isKeyboardShortcutEnabled ? (0, $gnkil.GO_TO_STARRED_SHORTCUT) : undefined,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_STARRED_SHORTCUT),
            onMouseEnter: onStarredMouseEnter,
            onShortcutTriggered: onStarredShortcut
        }), [
        isKeyboardShortcutEnabled,
        onStarredMouseEnter,
        onStarredShortcut
    ]);
    return (0, $cozmU.useMemo)(()=>({
            forYouItem: {
                type: 'link',
                menuItemId: 'yourWork',
                url: homeUrl,
                isSelected: isHomeSelected,
                ItemWrapper: ForYouWrapper
            },
            recent: {
                menuItemId: 'recent',
                useItems: (0, $iQcdJ.useRecentItems),
                viewAllUrl: recentViewAllUrl,
                hideActionsWhenEmpty: (0, $6mKj3.UNSAFE_expValNoExposure)('cc_mohiti_nav_empty_states', 'isEnabled', false),
                emptyElem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9f550940f484a79$var$RecentEmptyStateExperiment, null),
                isSearchable: true,
                filterConfig: recentsFilterConfig,
                isSelected: isRecentSelected,
                isOpen: isRecentOpen,
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9a55ff81647e826c$export$af1f39df90a1145e), null),
                experienceEndTracker: $b9f550940f484a79$var$StopRecent,
                onOpenChange: onRecentOpenChange,
                ItemWrapper: RecentWrapper
            },
            starred: {
                menuItemId: 'starred',
                useItems: (0, $26Pni.useStarredItems),
                viewAllUrl: starredViewAllUrl,
                hideActionsWhenEmpty: (0, $6mKj3.UNSAFE_expValNoExposure)('cc_mohiti_nav_empty_states', 'isEnabled', false),
                isSearchable: true,
                isOpen: isStarredOpen,
                isSelected: isStarredSelected,
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b70cb2d8a5778044$export$17b89e6a36c6b530), null),
                emptyElem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9f550940f484a79$var$StarredEmptyStateExperiment, null),
                experienceEndTracker: $b9f550940f484a79$var$StopStarred,
                onOpenChange: onStarredOpenChange,
                ItemWrapper: StarredWrapper
            }
        }), [
        homeUrl,
        isHomeSelected,
        isRecentOpen,
        isRecentSelected,
        isStarredOpen,
        isStarredSelected,
        recentViewAllUrl,
        recentsFilterConfig,
        starredViewAllUrl,
        onRecentOpenChange,
        onStarredOpenChange,
        ForYouWrapper,
        RecentWrapper,
        StarredWrapper
    ]);
};
const $b9f550940f484a79$var$isOnHomeSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl() || routeUrl === (0, $1NBp8.WIKI).toUrl();
    }
};
const $b9f550940f484a79$var$isOnStarredRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'starred'
        })
};
const $b9f550940f484a79$var$isOnRecentRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'recent'
        })
};
module.exports["useForYouConfig"] = $b9f550940f484a79$export$f29dcc074aa4bb66;

});

parcelRegister("dzwLE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aA2ps = parcelRequire("aA2ps");


var $iecTK = parcelRequire("iecTK");

const $0835e086b0f2f992$export$47c3c0e3d1c149f1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function NavFlyoutEmptyState(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { variant: t1 } = t0;
    const variant = t1 === undefined ? "default" : t1;
    let t2;
    if ($[0] !== variant) {
        t2 = variant === "starred" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iecTK.ObjectListStarredEmptyState), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aA2ps.ObjectListFlyoutEmptyState), null);
        $[0] = variant;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : function NavFlyoutEmptyState({ variant: variant = 'default' }) {
    return variant === 'starred' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iecTK.ObjectListStarredEmptyState), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aA2ps.ObjectListFlyoutEmptyState), null);
};
module.exports["NavFlyoutEmptyState"] = $0835e086b0f2f992$export$47c3c0e3d1c149f1;

});

parcelRegister("166II", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $c9Rq0 = parcelRequire("c9Rq0");


var $4aRua = parcelRequire("4aRua");


var $cJ0FD = parcelRequire("cJ0FD");


var $57p4j = parcelRequire("57p4j");


var $iDrrr = parcelRequire("iDrrr");


var $lsxnT = parcelRequire("lsxnT");

var $9c403c382bb45aba$exports = {};
$9c403c382bb45aba$exports = new URL("Home.eb3dbfc7.gif", import.meta.url).toString();


var $f6d122b6e068b931$exports = {};
$f6d122b6e068b931$exports = new URL("Home-dark.b4541437.gif", import.meta.url).toString();



var $3Awqk = parcelRequire("3Awqk");


var $3SChL = parcelRequire("3SChL");


var $2AgON = parcelRequire("2AgON");

var $f78a17f302f015ba$exports = {};
$f78a17f302f015ba$exports = new URL("Home-placeholder.72eb75ff.png", import.meta.url).toString();


var $b409843d0cf32a7e$exports = {};
$b409843d0cf32a7e$exports = new URL("Home-placeholder-dark.86521bfc.png", import.meta.url).toString();



var $35Nok = parcelRequire("35Nok");


var $aPGTj = parcelRequire("aPGTj");


var $6Yblc = parcelRequire("6Yblc");


var $2K2hA = parcelRequire("2K2hA");


var $6OwHS = parcelRequire("6OwHS");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $2Vz7H = parcelRequire("2Vz7H");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $3eYzF = parcelRequire("3eYzF");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

const $3472cc1e48bf28c2$var$STEP_ID = 'nth-user-orientation-editor-for-you-spotlight';
const $3472cc1e48bf28c2$export$9cb1114290a9ed04 = ({ children: children })=>{
    const { reset: reset, next: next, back: back, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted, active: active } = (0, $3SChL.useTour)($3472cc1e48bf28c2$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isVisible = currentStep === $3472cc1e48bf28c2$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const currentSrc = (0, $35Nok.usePreloadGif)({
        gif: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($9c403c382bb45aba$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($f6d122b6e068b931$exports)))
        },
        placeholder: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($f78a17f302f015ba$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($b409843d0cf32a7e$exports)))
        },
        skip: !active
    });
    const { handleNext: handleNext, handleBack: handleBack, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $3472cc1e48bf28c2$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onBack: back,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9Rq0.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        next: handleNext,
        back: handleBack,
        dismiss: handleDismiss,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $3472cc1e48bf28c2$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, (()=>{
        const spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
            testId: $3472cc1e48bf28c2$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorForYouSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: currentSrc,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage((0, $3Awqk.editorForYouSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aPGTj.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Yblc.SpotlightSecondaryAction), null, formatMessage((0, $3Awqk.spotlight).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next)))));
        return (0, $iDrrr.fg)('platform-dst-motion-uplift-spotlight') ? spotlightCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, spotlightCard));
    })())));
};
module.exports["EditorForYouSpotlight"] = $3472cc1e48bf28c2$export$9cb1114290a9ed04;

});

parcelRegister("XO4by", function(module, exports) {

var $kTGj5 = parcelRequire("kTGj5");


var $dYU3e = parcelRequire("dYU3e");


var $36tM8 = parcelRequire("36tM8");


var $djzYv = parcelRequire("djzYv");

function $f64f22d885b98eec$export$603721ee0464e7fd(cloudId) {
    return (0, $dYU3e.queryAgg)({
        query: (0, $djzYv.default),
        variables: {
            cloudId: (0, $kTGj5.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: (0, $36tM8.PAGE_SIZE),
            eventTypes: [],
            objectTypes: (0, $36tM8.objectTypes)()
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "side-navigation"
    });
}
module.exports["preloadRecentContentMenu"] = $f64f22d885b98eec$export$603721ee0464e7fd;

});

parcelRegister("eLFsG", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $gSytF = parcelRequire("gSytF");


var $6KZ8B = parcelRequire("6KZ8B");

function $db09a4ff30df6c3f$export$4c74f8426e49d30c() {
    return (0, $dYU3e.query)({
        query: (0, $gSytF.default),
        variables: (0, $6KZ8B.starredContentMenuQueryVars),
        fetchPolicy: 'network-only',
        __callerPackage__: "side-navigation"
    });
}
module.exports["preloadStarredContentMenu"] = $db09a4ff30df6c3f$export$4c74f8426e49d30c;

});

parcelRegister("gSytF", function(module, exports) {
/**
 * @generated SignedSource<<0903db17d3aee61b35f5de4aa02dc68a>>
 * @relayHash 0913aa0e7f577fc63dfd041de0b5136e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae0bd328ec8252dd2e2f88475c08a5447b0ace0d9051443e47deaca0e2dcd468
const $5baefebdfa73b4d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": 30,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "start"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "start",
                    "variableName": "start"
                }
            ],
            "concreteType": "PaginatedContentList",
            "kind": "LinkedField",
            "name": "favoriteContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContributionStatusSummary",
                                            "kind": "LinkedField",
                                            "name": "lastcontributed",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "when"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "emoji",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                },
                {
                    "concreteType": "ContentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StarredContentMenuQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StarredContentMenuQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "0913aa0e7f577fc63dfd041de0b5136e",
            "id": "ae0bd328ec8252dd2e2f88475c08a5447b0ace0d9051443e47deaca0e2dcd468",
            "metadata": {},
            "name": "StarredContentMenuQuery",
            "operationKind": "query",
            "text": "query StarredContentMenuQuery($limit:Int=30,$start:Int!){favoriteContent(limit:$limit,start:$start){nodes{id,type,subType,title,status,space{id,name},links{webui,editui},metadata{currentuser{favourited{isFavourite,favouritedDate},lastcontributed{status,when}}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}}},pageInfo{hasNextPage},edges{cursor}}}"
        }
    };
}();
$5baefebdfa73b4d2$var$node.hash = "d919f41ac18e2cfc51a95f7043552fc1";
var $5baefebdfa73b4d2$export$2e2bcd8739ae039 = $5baefebdfa73b4d2$var$node;
module.exports["default"] = $5baefebdfa73b4d2$export$2e2bcd8739ae039;

});

parcelRegister("6KZ8B", function(module, exports) {
/**
 * Shared constants for the Starred Content Menu.
 *
 * These are extracted into a separate lightweight file to avoid pulling the
 * full StarredContentMenu component into chunks that only need these constants
 * (e.g. preloaders and hooks). This prevents tree-shaking defeats where a
 * back-reference from a lazy-loaded child would drag in the parent's heavy
 * dependencies.
 */ const $b7ba8e1c5f70de6c$export$776b5788fd07993d = {
    start: 0
};
module.exports["starredContentMenuQueryVars"] = $b7ba8e1c5f70de6c$export$776b5788fd07993d;

});

parcelRegister("hl4GB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $3IBnw = parcelRequire("3IBnw");

const $c6d4cc9cc1625e13$export$4af2c0efbfc684e8 = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            errorBoundaryId: "sideNavigation-globalNavigation"
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO,
            attributes: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
module.exports["DiscoErrorBoundary"] = $c6d4cc9cc1625e13$export$4af2c0efbfc684e8;

});

parcelRegister("1eSiZ", function(module, exports) {

let $0e7139278c9848ce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0e7139278c9848ce$var$load("eRhBr"),
    $0e7139278c9848ce$var$load("arKPj"),
    $0e7139278c9848ce$var$load("lgIhe"),
    $0e7139278c9848ce$var$load("Wowvf"),
    $0e7139278c9848ce$var$load("2yM8Y")
]).then(()=>parcelRequire('kIWbA'));

});

parcelRegister("eoKnG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a1c665f15a3ff236$export$45a9fae3fa5f3d54 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "NgxO1",
    name: "RecentsEmptyStateLoader",
    loader: async ()=>(await (parcelRequire("ceacY"))).RecentsEmptyState
});
module.exports["RecentsEmptyStateLoader"] = $a1c665f15a3ff236$export$45a9fae3fa5f3d54;

});

parcelRegister("ceacY", function(module, exports) {

let $8e6eb5fadb5fb5e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e6eb5fadb5fb5e4$var$load("8c3ts").then(()=>parcelRequire('di5zj'));

});

parcelRegister("drwFS", function(module, exports) {

let $9c97246e62ff7a1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9c97246e62ff7a1e$var$load("arKPj"),
    $9c97246e62ff7a1e$var$load("Wowvf"),
    $9c97246e62ff7a1e$var$load("1cMUZ")
]).then(()=>parcelRequire('1IQhI'));

});

parcelRegister("7iBL4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3d27dc2a2cbfe772$export$3b1909bf8dcb54da = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "lZVsx",
    name: "StarredEmptyStateLoader",
    loader: async ()=>(await (parcelRequire("9MftH"))).StarredEmptyState
});
module.exports["StarredEmptyStateLoader"] = $3d27dc2a2cbfe772$export$3b1909bf8dcb54da;

});

parcelRegister("9MftH", function(module, exports) {

let $71e49a62c6103f20$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $71e49a62c6103f20$var$load("Wowvf"),
    $71e49a62c6103f20$var$load("eRhBr"),
    $71e49a62c6103f20$var$load("7EorR"),
    $71e49a62c6103f20$var$load("5IeO9")
]).then(()=>parcelRequire('kJVjC'));

});

parcelRegister("iQcdJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iKWdo = parcelRequire("iKWdo");


var $f922E = parcelRequire("f922E");


var $eDtFr = parcelRequire("eDtFr");


var $gC2EJ = parcelRequire("gC2EJ");


var $g9ioO = parcelRequire("g9ioO");


var $9KSWX = parcelRequire("9KSWX");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $1YXTQ = parcelRequire("1YXTQ");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $bCECL = parcelRequire("bCECL");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $WG1VM = parcelRequire("WG1VM");


var $5V1fS = parcelRequire("5V1fS");

const $1195428fc846c248$export$bc82a767d3a2a41 = (params)=>{
    const $ = (0, $bDgLe.c)(16);
    const intl = (0, $kSwu1.useIntl)();
    const selectedFilter = params.selectedFilters?.[0] || "ALL";
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t0;
    if ($[0] !== params.searchText || $[1] !== selectedFilter) {
        t0 = {
            searchText: params.searchText,
            selectedFilter: selectedFilter
        };
        $[0] = params.searchText;
        $[1] = selectedFilter;
        $[2] = t0;
    } else t0 = $[2];
    const { data: data, loading: loading, error: error, isUnauthorized: isUnauthorized, sections: rawSections, hasNextPage: hasNextPage, loadMore: loadMore } = $1195428fc846c248$export$5b0ada08b9b7bd62(t0);
    let t1;
    bb0: {
        if (error) {
            let t2;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = [];
                $[3] = t2;
            } else t2 = $[3];
            t1 = t2;
            break bb0;
        }
        let result;
        if ($[4] !== intl || $[5] !== rawSections || $[6] !== selectedFilter) {
            result = [];
            for (const section of rawSections){
                if (section.nodes.length === 0) continue;
                const items = [];
                for (const node of section.nodes){
                    const content = node?.object?.content;
                    const url = node?.object?.url || "";
                    const { emoji: emoji, title: title } = content ? (0, $5V1fS.getContentEmojiAndTitle)(content) : {
                        emoji: undefined,
                        title: undefined
                    };
                    const isDraft = content?.status === "draft";
                    items.push({
                        elemBefore: content?.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
                            type: content.type,
                            subType: content?.subType,
                            emoji: emoji
                        }) : null,
                        elemAfter: isDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                            appearance: "neutral"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1195428fc846c248$export$a7357cdd1f0b0168.draftLozengeTextUpdated)),
                        primaryLabel: title || intl.formatMessage((0, $5V1fS.i18n).untitled),
                        secondaryLabel: content?.space?.name || "",
                        tertiaryLabel: node?.timestamp ? (0, $1YXTQ.formatTimeAgo)(intl, node?.timestamp) : undefined,
                        href: url,
                        extendedSubItemAnalyticsAttributes: content ? {
                            componentType: "customItem",
                            contentType: content.type ?? null,
                            contentId: content.id ?? null,
                            contentStatus: content.status ?? null,
                            section: intl.formatMessage(section.title),
                            selectedFilter: selectedFilter,
                            isLivePage: content.subType === "live"
                        } : undefined
                    });
                }
                result.push({
                    header: intl.formatMessage(section.title),
                    items: items
                });
            }
            $[4] = intl;
            $[5] = rawSections;
            $[6] = selectedFilter;
            $[7] = result;
        } else result = $[7];
        t1 = result;
    }
    const sections = t1;
    let t2;
    bb1: {
        if (isUnauthorized) {
            let t3;
            if ($[8] !== intl) {
                t3 = new Error(intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.authErrorMessageTitle));
                $[8] = intl;
                $[9] = t3;
            } else t3 = $[9];
            t2 = t3;
            break bb1;
        }
        if (error) experienceTracker.stopOnError({
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            error: error,
            attributes: {
                navVersion: "4",
                dropdownType: "recent"
            }
        });
        t2 = error;
    }
    const returnError = t2;
    const t3 = loading && !data;
    let t4;
    if ($[10] !== hasNextPage || $[11] !== loadMore || $[12] !== returnError || $[13] !== sections || $[14] !== t3) {
        t4 = {
            sections: sections,
            hasMore: hasNextPage,
            isLoading: t3,
            loadMore: loadMore,
            error: returnError
        };
        $[10] = hasNextPage;
        $[11] = loadMore;
        $[12] = returnError;
        $[13] = sections;
        $[14] = t3;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
};
const $1195428fc846c248$export$5b0ada08b9b7bd62 = (params)=>{
    const $ = (0, $bDgLe.c)(35);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = (0, $WG1VM.getQueryOptions)(cloudId);
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const queryOptions = t0;
    const selectedFilter = params.selectedFilter || "ALL";
    const searchText = params.searchText || "";
    const t1 = queryOptions[selectedFilter];
    let t2;
    if ($[2] !== params.onCompleted || $[3] !== params.onError || $[4] !== t1.initialVars) {
        t2 = {
            variables: t1.initialVars,
            fetchPolicy: "cache-and-network",
            interopApolloAggClient: true,
            onCompleted: params.onCompleted,
            onError: params.onError
        };
        $[2] = params.onCompleted;
        $[3] = params.onError;
        $[4] = t1.initialVars;
        $[5] = t2;
    } else t2 = $[5];
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)(queryOptions[selectedFilter].query, {
        ...t2,
        __callerPackage__: "side-navigation"
    });
    let t3;
    if ($[6] !== error) {
        t3 = error && (0, $1uFM6.isUnauthorizedError)(error);
        $[6] = error;
        $[7] = t3;
    } else t3 = $[7];
    const isUnauthorized = !!t3;
    let t4;
    bb0: {
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            let t5;
            if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
                t5 = [];
                $[8] = t5;
            } else t5 = $[8];
            t4 = t5;
            break bb0;
        }
        let t5;
        if ($[9] !== data || $[10] !== queryOptions || $[11] !== searchText || $[12] !== selectedFilter) {
            const lowerFilterText = searchText.toLowerCase();
            const nodes = queryOptions[selectedFilter].transformNodes(data);
            t5 = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(nodes?.filter((node)=>!searchText || node?.object?.content?.title?.toLowerCase().includes(lowerFilterText)).filter($1195428fc846c248$var$_temp).filter($1195428fc846c248$var$_temp2), $1195428fc846c248$var$_temp3) ?? [];
            $[9] = data;
            $[10] = queryOptions;
            $[11] = searchText;
            $[12] = selectedFilter;
            $[13] = t5;
        } else t5 = $[13];
        t4 = t5;
    }
    const filteredNodes = t4;
    let t5;
    if ($[14] !== filteredNodes) {
        t5 = $1195428fc846c248$export$19e8d4a05b9bbef(filteredNodes);
        $[14] = filteredNodes;
        $[15] = t5;
    } else t5 = $[15];
    const sections = t5;
    const t6 = queryOptions[selectedFilter];
    let t7;
    if ($[16] !== data || $[17] !== t6) {
        t7 = t6.getPaginationParams(data);
        $[16] = data;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    const { endCursor: endCursor, hasNextPage: hasNextPage } = t7;
    let t8;
    if ($[19] !== endCursor || $[20] !== fetchMore || $[21] !== hasNextPage || $[22] !== loading || $[23] !== queryOptions || $[24] !== selectedFilter) {
        t8 = ()=>{
            if (hasNextPage && endCursor && !loading) fetchMore({
                variables: queryOptions[selectedFilter].fetchMoreVars(endCursor),
                updateQuery: (prev, t9)=>{
                    const { fetchMoreResult: fetchMoreResult } = t9;
                    if (!fetchMoreResult) return prev;
                    return queryOptions[selectedFilter].updatePaginationResults(prev, fetchMoreResult);
                }
            });
        };
        $[19] = endCursor;
        $[20] = fetchMore;
        $[21] = hasNextPage;
        $[22] = loading;
        $[23] = queryOptions;
        $[24] = selectedFilter;
        $[25] = t8;
    } else t8 = $[25];
    const loadMore = t8;
    let t9;
    if ($[26] !== data || $[27] !== error || $[28] !== filteredNodes || $[29] !== hasNextPage || $[30] !== isUnauthorized || $[31] !== loadMore || $[32] !== loading || $[33] !== sections) {
        t9 = {
            data: data,
            loading: loading,
            error: error,
            isUnauthorized: isUnauthorized,
            filteredNodes: filteredNodes,
            sections: sections,
            hasNextPage: hasNextPage,
            loadMore: loadMore
        };
        $[26] = data;
        $[27] = error;
        $[28] = filteredNodes;
        $[29] = hasNextPage;
        $[30] = isUnauthorized;
        $[31] = loadMore;
        $[32] = loading;
        $[33] = sections;
        $[34] = t9;
    } else t9 = $[34];
    return t9;
};
const $1195428fc846c248$export$bf18e6ec9b4e3f2e = ()=>{
    const $ = (0, $bDgLe.c)(29);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "ALL"
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== intl) {
        t1 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.all);
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: ""
        });
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1) {
        t3 = {
            key: "ALL",
            label: t1,
            elemBefore: t2
        };
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== intl) {
        t4 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.collaboratedOn);
        $[6] = intl;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: ""
        });
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t4) {
        t6 = {
            key: "COLLABORATED_ON",
            label: t4,
            elemBefore: t5
        };
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== intl) {
        t7 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.workedOn);
        $[11] = intl;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            label: ""
        });
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== t7) {
        t9 = {
            key: "WORKED_ON",
            label: t7,
            elemBefore: t8
        };
        $[14] = t7;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== intl) {
        t10 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.ownedByMe);
        $[16] = intl;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
            label: ""
        });
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== t10) {
        t12 = {
            key: "CREATED_BY_ME",
            label: t10,
            elemBefore: t11
        };
        $[19] = t10;
        $[20] = t12;
    } else t12 = $[20];
    let t13;
    if ($[21] !== t12 || $[22] !== t3 || $[23] !== t6 || $[24] !== t9) {
        t13 = [
            t3,
            t6,
            t9,
            t12
        ];
        $[21] = t12;
        $[22] = t3;
        $[23] = t6;
        $[24] = t9;
        $[25] = t13;
    } else t13 = $[25];
    let t14;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = [
            "ALL"
        ];
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== t13) {
        t15 = {
            defaultSelected: t0,
            filters: t13,
            hideSelectedFilterTag: t14
        };
        $[27] = t13;
        $[28] = t15;
    } else t15 = $[28];
    return t15;
};
const $1195428fc846c248$export$19e8d4a05b9bbef = (nodes)=>{
    const sections = [
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.today,
            daysAgo: 0,
            nodes: [],
            sectionId: 'today'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.yesterday,
            daysAgo: 1,
            nodes: [],
            sectionId: 'yesterday'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.lastWeek,
            daysAgo: 7,
            nodes: [],
            sectionId: 'lastWeek'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.lastMonth,
            daysAgo: 30,
            nodes: [],
            sectionId: 'lastMonth'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.moreThanMonth,
            daysAgo: -1,
            nodes: [],
            sectionId: 'moreThanMonth'
        }
    ];
    let sectionIndex = 0;
    const startOfToday = new Date().setHours(0, 0, 0, 0);
    nodes?.forEach((node)=>{
        if (!node?.timestamp) {
            sections[4].nodes.push(node);
            return;
        }
        const nodeDate = new Date(node.timestamp).getTime();
        const daysDiff = Math.floor((startOfToday - nodeDate) / (1000 * 60 * 60 * 24));
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        while(sectionIndex < sections.length - 1 && daysDiff >= sections[sectionIndex].daysAgo)sectionIndex++;
        sections[sectionIndex].nodes.push(node);
    });
    return sections;
};
const $1195428fc846c248$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    today: {
        id: "side-navigation.recent-content-menu.section.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "side-navigation.recent-content-menu.section.yesterday",
        defaultMessage: "Yesterday"
    },
    lastWeek: {
        id: "side-navigation.recent-content-menu.section.last-week",
        defaultMessage: "In the last week"
    },
    lastMonth: {
        id: "side-navigation.recent-content-menu.section.last-month",
        defaultMessage: "In the last month"
    },
    moreThanMonth: {
        id: "side-navigation.recent-content-menu.section.more-than-month",
        defaultMessage: "More than a month ago"
    },
    authErrorMessageTitle: {
        id: "side-navigation.recent-content-menu.auth-error-message.title",
        defaultMessage: "You are not authorized to load recent items"
    },
    all: {
        id: "side-navigation.recent-content-menu.filter.all",
        defaultMessage: "All"
    },
    collaboratedOn: {
        id: "side-navigation.recent-content-menu.filter.collaborated-on",
        defaultMessage: "Collaborated on"
    },
    workedOn: {
        id: "side-navigation.recent-content-menu.filter.worked-on",
        defaultMessage: "Worked on"
    },
    ownedByMe: {
        id: "side-navigation.recent-content-menu.filter.owned-by-me",
        defaultMessage: "Owned by me"
    },
    draftLozengeText: {
        id: "side-navigation.content-menu.lozenge.draft",
        defaultMessage: "DRAFT"
    },
    draftLozengeTextUpdated: {
        id: "side-navigation.content-menu.lozenge.draft.updated",
        defaultMessage: "Draft"
    }
});
function $1195428fc846c248$var$_temp(node_0) {
    return node_0?.object?.content?.status !== "archived";
}
function $1195428fc846c248$var$_temp2(node_1) {
    return node_1?.object?.content?.status !== "trashed";
}
function $1195428fc846c248$var$_temp3(node_2) {
    return node_2?.object?.content?.id;
}
module.exports["useRecentItems"] = $1195428fc846c248$export$bc82a767d3a2a41;
module.exports["useRecentData"] = $1195428fc846c248$export$5b0ada08b9b7bd62;
module.exports["groupNodesIntoSections"] = $1195428fc846c248$export$19e8d4a05b9bbef;
module.exports["useRecentsFilterConfig"] = $1195428fc846c248$export$bf18e6ec9b4e3f2e;

});

parcelRegister("WG1VM", function(module, exports) {
/**
 * @generated SignedSource<<ad70e2cc4e8376bb9d178b6bc110e8c5>>
 * @relayHash 0a144d902b93856695a8c12b9d512eec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ff8525d88fa5d1fa95255b13d382870c671a08e32e60c2a73924261eb29a74da
const $fd8955b92689005e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "cqlcontext",
                    "variableName": "cqlcontext"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webui"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "editui"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "createdDate"
                                        },
                                        {
                                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                            "kind": "LinkedField",
                                            "name": "currentuser",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "FavouritedSummary",
                                                    "kind": "LinkedField",
                                                    "name": "favourited",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isFavourite"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "favouritedDate"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "ContributionStatusSummary",
                                                    "kind": "LinkedField",
                                                    "name": "lastcontributed",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "when"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "emoji",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "emoji-title-published",
                                                "emoji-title-draft"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsonContentProperty",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "recentQueryConfigRecentlyCreatedByMeQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "recentQueryConfigRecentlyCreatedByMeQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "0a144d902b93856695a8c12b9d512eec",
            "id": "ff8525d88fa5d1fa95255b13d382870c671a08e32e60c2a73924261eb29a74da",
            "metadata": {},
            "name": "recentQueryConfigRecentlyCreatedByMeQuery",
            "operationKind": "query",
            "text": "query recentQueryConfigRecentlyCreatedByMeQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{url,content{id,type,subType,title,status,space{id,name,alias},links{webui,editui},metadata{createdDate,currentuser{favourited{isFavourite,favouritedDate},lastcontributed{status,when}}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$fd8955b92689005e$var$node.hash = "44fd6e25d4e06d1237e8459f36641ec0";
var $fd8955b92689005e$export$2e2bcd8739ae039 = $fd8955b92689005e$var$node;



var $lSFbL = parcelRequire("lSFbL");


var $kTGj5 = parcelRequire("kTGj5");


var $jlIaF = parcelRequire("jlIaF");


var $c7GB4 = parcelRequire("c7GB4");


var $yuLaV = parcelRequire("yuLaV");


var $djzYv = parcelRequire("djzYv");

const $87679b46728de696$export$a62e7697f515af4e = (0, $djzYv.default);



var $36tM8 = parcelRequire("36tM8");

const $c69e7b592fedb17e$var$transformActivityNodeLegacyUrl = (activitiesNode)=>{
    const transformedNode = $c69e7b592fedb17e$var$transformActivityData(activitiesNode?.node);
    if (!transformedNode?.object?.content?.links?.webui) return transformedNode;
    return {
        ...transformedNode,
        object: {
            ...transformedNode.object,
            url: `${0, $jlIaF.CONTEXT_PATH}${transformedNode.object.content.links.webui}`,
            content: {
                ...transformedNode.object.content
            }
        }
    };
};
const $c69e7b592fedb17e$var$transformActivityData = (recent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
        // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
        recent.object.data = recent?.object?.data?.container;
    }
    // V3 -> V2 transformation widens strict GraphQL enum values (e.g. ConfluenceContentType,
    // ConfluenceContentStatus) to lowercase strings consumed by legacy V2 callers. The narrow
    // generated types reject these mutations, so we treat `content` as loosely typed here.
    // See TODO below — this whole block goes away in DISCO-4281.
    const content = recent?.object?.data;
    if (content) {
        content.type = content.type?.toLowerCase() === 'blog_post' ? 'blogpost' : content.type?.toLowerCase();
        content.subtype = content.subtype?.toLowerCase();
        // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
        // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
        // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
        content.status = [
            content.status,
            content.pageStatus,
            content.blogStatus
        ].find((status)=>status)?.toLowerCase();
        // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
        if (content.status === 'draft' && content.createdAt) content.status = 'current';
    }
    if (recent?.event) recent.event.eventType = recent.event.eventType?.toUpperCase();
    const transformedId = content?.id && (0, $c7GB4.getIdFromConfluenceContentAri)({
        ari: content.id,
        resourceType: content.type
    });
    const recentData = recent?.object?.data;
    // TODO: This is currently transforming activity V3 data into activity V2 format. This
    // tranformation will be simplified in DISCO-4281
    const transformedContent = {
        ...recentData,
        id: transformedId,
        metadata: {
            ...recentData?.metadata,
            currentuser: {
                favourited: {
                    isFavourite: recentData?.viewer?.favoritedSummary?.isFavorite
                }
            }
        },
        links: {
            webui: recentData?.links?.webUi,
            editui: recentData?.links?.editUi
        },
        subType: recentData?.subtype,
        emoji: {
            nodes: [
                {
                    key: 'emoji-title-published',
                    value: recentData?.metadata?.titleEmojiPublished?.value
                },
                {
                    key: 'emoji-title-draft',
                    value: recentData?.metadata?.titleEmojiDraft?.value
                }
            ]
        }
    };
    return {
        ...recent,
        id: transformedId,
        timestamp: recent?.event?.timestamp,
        object: {
            ...recent?.object,
            content: transformedContent
        }
    };
};
const $c69e7b592fedb17e$var$mergeActivityMyActivityAllEdges = (prev, fetchMoreResult)=>{
    const prevNodes = prev.activity?.myActivity?.all?.edges || [];
    const fetchMoreNodes = fetchMoreResult.activity?.myActivity?.all?.edges || [];
    const mergedNodes = [
        ...prevNodes,
        ...fetchMoreNodes
    ];
    const result = {
        ...fetchMoreResult
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($lSFbL)))(result, 'activity.myActivity.all.edges', mergedNodes);
    return result;
};
const $c69e7b592fedb17e$var$getMyActivityAllPaginationParams = (data)=>{
    const allActivity = data?.activity?.myActivity?.all;
    return {
        endCursor: allActivity?.pageInfo?.endCursor || '',
        hasNextPage: allActivity?.pageInfo?.hasNextPage || false
    };
};
const $c69e7b592fedb17e$var$getAllRecentQueryOptions = (cloudId)=>({
        query: (0, $87679b46728de696$export$a62e7697f515af4e),
        initialVars: {
            cloudId: (0, $kTGj5.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: (0, $36tM8.PAGE_SIZE),
            eventTypes: [],
            objectTypes: (0, $36tM8.objectTypes)()
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $kTGj5.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: $c69e7b592fedb17e$var$getMyActivityAllPaginationParams,
        updatePaginationResults: $c69e7b592fedb17e$var$mergeActivityMyActivityAllEdges
    });
const $c69e7b592fedb17e$var$getCollaboratedOnQueryOptions = (cloudId)=>({
        query: (0, $87679b46728de696$export$a62e7697f515af4e),
        initialVars: {
            cloudId: (0, $kTGj5.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: (0, $36tM8.PAGE_SIZE),
            eventTypes: (0, $36tM8.WORKED_ON_EVENT_TYPES),
            objectTypes: [
                ...(0, $36tM8.objectTypes)(),
                (0, $36tM8.ActivityObjectType).COMMENT
            ]
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $kTGj5.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: $c69e7b592fedb17e$var$getMyActivityAllPaginationParams,
        updatePaginationResults: $c69e7b592fedb17e$var$mergeActivityMyActivityAllEdges
    });
const $c69e7b592fedb17e$var$getWorkedOnQueryOptions = (cloudId)=>({
        query: (0, $87679b46728de696$export$a62e7697f515af4e),
        initialVars: {
            cloudId: (0, $kTGj5.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: (0, $36tM8.PAGE_SIZE),
            eventTypes: (0, $36tM8.WORKED_ON_EVENT_TYPES),
            objectTypes: (0, $36tM8.objectTypes)()
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $kTGj5.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: $c69e7b592fedb17e$var$getMyActivityAllPaginationParams,
        updatePaginationResults: $c69e7b592fedb17e$var$mergeActivityMyActivityAllEdges
    });
const $c69e7b592fedb17e$var$mapCreatedByMeTabNodes = (node)=>{
    return {
        ...node,
        // Fall back to the content's creation date only when there's no `lastcontributed` value at all
        // - e.g. content was created with Rovo but hasn't been manually edited by the user.
        timestamp: node?.content?.metadata?.currentuser?.lastcontributed?.when ?? node?.content?.metadata?.createdDate,
        object: {
            url: `${0, $jlIaF.CONTEXT_PATH}${node.url}`,
            content: node.content
        }
    };
};
const $c69e7b592fedb17e$var$getCreatedByMeQueryOptions = ()=>{
    return {
        query: (0, $fd8955b92689005e$export$2e2bcd8739ae039),
        initialVars: {
            cql: `type in (page, blogpost, embed, whiteboard, database${(0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide') ? ', slide' : ''}) and owner=currentUser() and created >= startOfDay("-90d") order by created desc`,
            cqlcontext: `{"contentStatuses":["draft", "current"]}`,
            after: '',
            first: (0, $36tM8.PAGE_SIZE)
        },
        fetchMoreVars: (endCursor)=>({
                after: endCursor
            }),
        transformNodes: (data)=>(data?.search?.nodes || []).map($c69e7b592fedb17e$var$mapCreatedByMeTabNodes),
        getPaginationParams: (data)=>({
                endCursor: data?.search?.pageInfo?.endCursor || '',
                hasNextPage: data?.search?.pageInfo?.hasNextPage || false
            }),
        updatePaginationResults: (prev, fetchMoreResult)=>{
            const prevNodes = prev.search?.nodes || [];
            const fetchMoreNodes = fetchMoreResult.search?.nodes || [];
            const mergedNodes = [
                ...prevNodes,
                ...fetchMoreNodes
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($lSFbL)))(result, 'search.nodes', mergedNodes);
            return result;
        }
    };
};
const $c69e7b592fedb17e$export$175d7f1f999191e6 = (cloudId)=>{
    const queryOptions = {
        ALL: $c69e7b592fedb17e$var$getAllRecentQueryOptions(cloudId),
        COLLABORATED_ON: $c69e7b592fedb17e$var$getCollaboratedOnQueryOptions(cloudId),
        WORKED_ON: $c69e7b592fedb17e$var$getWorkedOnQueryOptions(cloudId),
        CREATED_BY_ME: $c69e7b592fedb17e$var$getCreatedByMeQueryOptions()
    };
    return queryOptions;
};
module.exports["getQueryOptions"] = $c69e7b592fedb17e$export$175d7f1f999191e6;

});

parcelRegister("26Pni", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lSFbL = parcelRequire("lSFbL");


var $iKWdo = parcelRequire("iKWdo");


var $9DHhW = parcelRequire("9DHhW");


var $5T18X = parcelRequire("5T18X");


var $jMyy4 = parcelRequire("jMyy4");


var $1YXTQ = parcelRequire("1YXTQ");


var $bCECL = parcelRequire("bCECL");


var $eFm27 = parcelRequire("eFm27");


var $jlIaF = parcelRequire("jlIaF");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6KZ8B = parcelRequire("6KZ8B");


var $gSytF = parcelRequire("gSytF");


var $6y3LW = parcelRequire("6y3LW");


var $5V1fS = parcelRequire("5V1fS");

const $17ab53893dbb998b$export$9a473b3d087f0f67 = (params)=>{
    const $ = (0, $bDgLe.c)(12);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== params.searchText) {
        t0 = {
            searchText: params.searchText
        };
        $[0] = params.searchText;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading, error: error, filteredNodes: filteredNodes, hasNextPage: hasNextPage, loadMore: loadMore } = $17ab53893dbb998b$export$e3e9588fd2c1abdd(t0);
    let t1;
    bb0: {
        if (error) {
            let t2;
            if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = [];
                $[2] = t2;
            } else t2 = $[2];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[3] !== filteredNodes || $[4] !== intl) {
            const items = [];
            for (const node of filteredNodes){
                if (!node) continue;
                const { emoji: emoji, title: title } = (0, $5V1fS.getContentEmojiAndTitle)(node);
                items.push({
                    elemBefore: node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
                        type: node.type,
                        subType: node.subType,
                        emoji: emoji
                    }) : null,
                    elemAfter: node.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17ab53893dbb998b$var$StarButton, {
                        contentId: node.id,
                        contentType: node.type,
                        isStarred: node.metadata?.currentuser?.favourited?.isFavourite || false
                    }) : undefined,
                    primaryLabel: title || intl.formatMessage((0, $5V1fS.i18n).untitled),
                    secondaryLabel: node.space?.name || "",
                    tertiaryLabel: node.metadata?.currentuser?.favourited?.favouritedDate ? (0, $1YXTQ.formatTimeAgo)(intl, node.metadata.currentuser.favourited.favouritedDate) : undefined,
                    href: `${(0, $jlIaF.CONTEXT_PATH)}${node.links?.webui || ""}`,
                    extendedSubItemAnalyticsAttributes: {
                        componentType: "customItem",
                        contentType: node.type ?? null,
                        contentId: node.id ?? null,
                        contentStatus: node.status ?? null,
                        isLivePage: node.subType === "live"
                    }
                });
            }
            t2 = items.length > 0 ? [
                {
                    header: "",
                    items: items
                }
            ] : [];
            $[3] = filteredNodes;
            $[4] = intl;
            $[5] = t2;
        } else t2 = $[5];
        t1 = t2;
    }
    const sections = t1;
    const t2 = loading && !data;
    const t3 = error || undefined;
    let t4;
    if ($[6] !== hasNextPage || $[7] !== loadMore || $[8] !== sections || $[9] !== t2 || $[10] !== t3) {
        t4 = {
            sections: sections,
            hasMore: hasNextPage,
            isLoading: t2,
            loadMore: loadMore,
            error: t3
        };
        $[6] = hasNextPage;
        $[7] = loadMore;
        $[8] = sections;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
};
const $17ab53893dbb998b$export$e3e9588fd2c1abdd = (params)=>{
    const $ = (0, $bDgLe.c)(17);
    const searchText = params.searchText || "";
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            variables: (0, $6KZ8B.starredContentMenuQueryVars),
            fetchPolicy: "cache-and-network"
        };
        $[0] = t0;
    } else t0 = $[0];
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, networkStatus: networkStatus } = (0, $jMyy4.useQueryInterop)((0, $gSytF.default), {
        ...t0,
        __callerPackage__: "side-navigation"
    });
    const hasNextPage = data?.favoriteContent?.pageInfo?.hasNextPage || false;
    let t1;
    bb0: {
        if (error) {
            let t2;
            if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = [];
                $[1] = t2;
            } else t2 = $[1];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[2] !== data?.favoriteContent?.nodes || $[3] !== searchText) {
            const lowerFilterText = searchText.toLowerCase();
            t2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(data?.favoriteContent?.nodes?.filter((content)=>content !== null && content !== undefined && (!searchText || (content.title?.toLowerCase() || "").includes(lowerFilterText))), $17ab53893dbb998b$var$_temp) ?? [];
            $[2] = data?.favoriteContent?.nodes;
            $[3] = searchText;
            $[4] = t2;
        } else t2 = $[4];
        t1 = t2;
    }
    const filteredNodes = t1;
    let t2;
    if ($[5] !== data?.favoriteContent?.nodes?.length || $[6] !== fetchMore || $[7] !== hasNextPage || $[8] !== networkStatus) {
        t2 = ()=>{
            if (networkStatus === (0, $5T18X.NetworkStatus).ready && hasNextPage) $17ab53893dbb998b$export$102f63446941fd83(fetchMore, data?.favoriteContent?.nodes?.length || 0);
        };
        $[5] = data?.favoriteContent?.nodes?.length;
        $[6] = fetchMore;
        $[7] = hasNextPage;
        $[8] = networkStatus;
        $[9] = t2;
    } else t2 = $[9];
    data?.favoriteContent?.nodes;
    const loadMore = t2;
    if (error) experienceTracker.stopOnError({
        name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
        error: error,
        attributes: {
            navVersion: "4",
            dropdownType: "starred"
        }
    });
    let t3;
    if ($[10] !== data || $[11] !== error || $[12] !== filteredNodes || $[13] !== hasNextPage || $[14] !== loadMore || $[15] !== loading) {
        t3 = {
            data: data,
            loading: loading,
            error: error,
            filteredNodes: filteredNodes,
            hasNextPage: hasNextPage,
            loadMore: loadMore
        };
        $[10] = data;
        $[11] = error;
        $[12] = filteredNodes;
        $[13] = hasNextPage;
        $[14] = loadMore;
        $[15] = loading;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
};
const $17ab53893dbb998b$export$102f63446941fd83 = (fetchMore, start)=>{
    fetchMore({
        variables: {
            start: start
        },
        updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
            if (!fetchMoreResult) return prev;
            const prevEdges = prev.favoriteContent?.nodes || [];
            const fetchMoreEdges = fetchMoreResult.favoriteContent?.nodes || [];
            const mergedEdges = [
                ...prevEdges,
                ...fetchMoreEdges
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($lSFbL)))(result, 'favoriteContent.nodes', mergedEdges);
            return result;
        }
    });
};
const $17ab53893dbb998b$var$StarButton = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { contentId: contentId, contentType: contentType, isStarred: isStarred } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== createAnalyticsEvent) {
        t1 = ()=>{
            (0, $6y3LW.fireContentMenuItemClickedAnalytics)(createAnalyticsEvent, "starredNavigationMenuItem", {
                componentType: "customItemAction",
                itemId: "star",
                parentContentType: contentType,
                parentContentId: contentId
            })();
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = createAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const onStar = t1;
    let t2;
    if ($[4] !== contentId || $[5] !== contentType || $[6] !== createAnalyticsEvent) {
        t2 = ()=>{
            (0, $6y3LW.fireContentMenuItemClickedAnalytics)(createAnalyticsEvent, "starredNavigationMenuItem", {
                componentType: "customItemAction",
                itemId: "unstar",
                parentContentType: contentType,
                parentContentId: contentId
            })();
        };
        $[4] = contentId;
        $[5] = contentType;
        $[6] = createAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    const onUnstar = t2;
    let t3;
    if ($[8] !== contentId || $[9] !== isStarred || $[10] !== onStar || $[11] !== onUnstar) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFm27.PageStarButton), {
            contentId: contentId,
            isStarred: isStarred,
            size: "small",
            tooltipPosition: "top",
            onStar: onStar,
            onUnstar: onUnstar,
            spacing: "none"
        });
        $[8] = contentId;
        $[9] = isStarred;
        $[10] = onStar;
        $[11] = onUnstar;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
};
function $17ab53893dbb998b$var$_temp(content_0) {
    return content_0?.id;
}
module.exports["useStarredItems"] = $17ab53893dbb998b$export$9a473b3d087f0f67;
module.exports["useStarredData"] = $17ab53893dbb998b$export$e3e9588fd2c1abdd;
module.exports["fetchMoreStarredContent"] = $17ab53893dbb998b$export$102f63446941fd83;

});

parcelRegister("6y3LW", function(module, exports) {
const $aac5b14b108aa083$export$744f6d2ef9fc49d7 = (createAnalyticsEvent, actionSubjectId, options)=>()=>{
        const { componentType: componentType, itemId: itemId, contentType: contentType, contentId: contentId, contentStatus: contentStatus, section: section, selectedFilter: selectedFilter, parentContentType: parentContentType, parentContentId: parentContentId } = options;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: actionSubjectId,
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    navVersion: '4',
                    componentType: componentType,
                    itemId: itemId,
                    contentType: contentType,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    section: section,
                    selectedFilter: selectedFilter,
                    parentContentType: parentContentType,
                    parentContentId: parentContentId
                }
            }
        }).fire();
    };
module.exports["fireContentMenuItemClickedAnalytics"] = $aac5b14b108aa083$export$744f6d2ef9fc49d7;

});

parcelRegister("fafDF", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e773f359142271d6$export$f5724c4dd6c3c6c8 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2aohX",
    name: "SpacesEmptyStateLoader",
    loader: async ()=>(await (parcelRequire("eLEop"))).SpacesEmptyState
});
module.exports["SpacesEmptyStateLoader"] = $e773f359142271d6$export$f5724c4dd6c3c6c8;

});

parcelRegister("eLEop", function(module, exports) {

let $ac04c9a00e081987$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac04c9a00e081987$var$load("7LG7h").then(()=>parcelRequire('aJqUp'));

});

parcelRegister("9srY1", function(module, exports) {
/**
 * Render-prop provider that normalises a raw Invited App Shortcuts
 * recommendations response into `InvitedAppShortcutsRecommendationsResult`.
 *
 * ## Why this is a pure translator (not a Relay component)
 *
 * The previous version of this provider owned the `graphql\`...\`` document, the
 * `usePreloadedQuery` call, and the `__generated__/<Query>.graphql.ts` import.
 * That coupled the package to a single Relay artifact that lived inside this
 * package's `src/.../__generated__/` directory.
 *
 * Jira and Confluence entrypoint files cannot import that artifact:
 *
 * - Jira's `@atlassian/react-entrypoint/no-imports-in-entrypoint-file` lint rule
 *   restricts imports inside `*.entrypoint.tsx` files to a narrow allowlist
 *   (relative `*\/__generated__/*` paths, `@atlassian/ari/*`, the feature-gate
 *   modules, etc). A subpath export like
 *   `@atlassian/cross-join-nudges/.../recommendations-provider/query` matches
 *   `*\/__generated__/*` after module resolution, but the rule matches against
 *   the literal import-path string and so still rejects it.
 *
 * - There is no comparable rule in Confluence today, but Confluence's SSR
 *   preload pattern follows the same shape (load the query at route resolution
 *   time, render with `usePreloadedQuery`), and we want to keep both consumers
 *   on the same architecture.
 *
 * To unblock SSR preload in both products without a per-product allowlist
 * carve-out, this provider now operates on the **raw AGG response shape** that
 * consumers obtain from their own preloaded Relay query. Each consumer:
 *
 *   1. Owns a local `.graphql` file with the canonical query body (kept in sync
 *      via the drift test exported from `@atlassian/cross-join-nudges/test-helpers`).
 *   2. Preloads that query in their entrypoint and reads it with
 *      `usePreloadedQuery` in their renderer.
 *   3. Passes the resulting raw data to this provider as
 *      `recommendationsResponse`.
 *
 * This file therefore deliberately:
 *
 * - Does NOT `import` anything from `react-relay`. Consumers own the Relay
 *   integration; this file is pure data normalisation.
 * - Does NOT carry a `graphql\`...\`` template literal. The canonical query
 *   source is exported from `./test-helpers` so consumers (and the drift test)
 *   can read it as plain text.
 * - Defines a structural `InvitedAppShortcutsRecommendationsResponse` type that
 *   any Relay-generated type matching the canonical selection set will satisfy.
 *
 * For non-React callers (e.g. SSR adapters, unit tests, analytics middleware)
 * the same normalisation is available via the stand-alone
 * `buildInvitedAppShortcutsRecommendationsResult(response)` helper.
 */ function $7d5d602142df410d$export$1d36738cc02616ef(recommendationsResponse) {
    const node = recommendationsResponse.growthRecommendations?.recommendations;
    if (!node) return {
        kind: 'empty'
    };
    if (node.__typename === 'GrowthRecRecommendations') {
        const growthRecNode = node;
        const recommendations = (growthRecNode.data ?? []).map((item)=>({
                entityId: item.entityId,
                reasons: item.reasons ?? [],
                // GRS can return null/undefined; default to 0 so consumers can rank
                // without null-checking every score.
                score: item.score ?? 0
            }));
        return {
            kind: 'recommendations',
            recommendations: recommendations,
            context: {
                tenantId: growthRecNode.context?.tenantId ?? null,
                product: growthRecNode.context?.product ?? null,
                useCase: growthRecNode.context?.useCase ?? null,
                sessionId: growthRecNode.context?.sessionId ?? null
            }
        };
    }
    if (node.__typename === 'QueryError') {
        const errorNode = node;
        // `extensions` is an array of {statusCode, errorType} per the AGG schema;
        // surface the first entry which is what AGG conventionally populates.
        const firstExtension = errorNode.extensions?.[0];
        return {
            kind: 'error',
            identifier: errorNode.identifier ?? null,
            message: errorNode.message ?? null,
            statusCode: firstExtension?.statusCode ?? null,
            errorType: firstExtension?.errorType ?? null
        };
    }
    return {
        kind: 'error',
        identifier: null,
        message: `Unknown InvitedAppShortcutsRecommendations response __typename: ${node.__typename}`,
        statusCode: null,
        errorType: null
    };
}
function $7d5d602142df410d$export$ffe033da16b39f1b({ recommendationsResponse: recommendationsResponse, children: children }) {
    // No `useMemo`: `buildInvitedAppShortcutsRecommendationsResult` is a cheap
    // object walk + a `.map()` over `recommendations.data` (typically <10
    // items), and the wrapping `useMemo` only paid off when callers passed a
    // stable `recommendationsResponse` reference. Avoiding the memo removes
    // the foot-gun where fresh-object-literal callers silently re-run the
    // translator on every render and gives a single, predictable code path.
    return children($7d5d602142df410d$export$1d36738cc02616ef(recommendationsResponse));
}
module.exports["buildInvitedAppShortcutsRecommendationsResult"] = $7d5d602142df410d$export$1d36738cc02616ef;

});

parcelRegister("laxxL", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4YUBg = parcelRequire("4YUBg");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $4Mzej = parcelRequire("4Mzej");


var $5xvpm = parcelRequire("5xvpm");


var $1rYMO = parcelRequire("1rYMO");


var $9srY1 = parcelRequire("9srY1");


var $3IBnw = parcelRequire("3IBnw");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $fPgmM = parcelRequire("fPgmM");


var $cwUrm = parcelRequire("cwUrm");

const $a870a7935c180a3b$var$SOURCE_APP = 'confluence';
const $a870a7935c180a3b$export$17e9db4c99e5bef7 = (0, $4YUBg.default);
function $a870a7935c180a3b$export$e32afd5717d291e0(t0) {
    const $ = (0, $bDgLe.c)(26);
    const { Component: Component, cloudId: cloudId, shortcutsConfig: shortcutsConfig, userId: userId } = t0;
    let t1;
    if ($[0] !== cloudId) {
        t1 = (0, $cwUrm.buildInvitedAppShortcutsRecommendationsVariables)(cloudId);
        $[0] = cloudId;
        $[1] = t1;
    } else t1 = $[1];
    const variables = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fetchPolicy: "store-or-network"
        };
        $[2] = t2;
    } else t2 = $[2];
    const data = (0, $6SsN4.useLazyLoadQuery)($a870a7935c180a3b$export$17e9db4c99e5bef7, variables, t2);
    let t3;
    if ($[3] !== data) {
        bb0: {
            const result = (0, $9srY1.buildInvitedAppShortcutsRecommendationsResult)(data);
            if (result.kind !== "recommendations") {
                let t4;
                if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
                    t4 = [];
                    $[5] = t4;
                } else t4 = $[5];
                t3 = t4;
                break bb0;
            }
            t3 = result.recommendations.reduce($a870a7935c180a3b$var$_temp, []);
        }
        $[3] = data;
        $[4] = t3;
    } else t3 = $[4];
    const recommendedApps = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $fPgmM.getInvitedAppShortcutsCache)();
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== cloudId || $[8] !== recommendedApps || $[9] !== userId) {
        t5 = {
            enabled: true,
            mode: "productionisation",
            sourceProduct: $a870a7935c180a3b$var$SOURCE_APP,
            targetProducts: recommendedApps,
            cloudId: cloudId,
            userId: userId,
            cache: t4,
            recommendedApps: recommendedApps
        };
        $[7] = cloudId;
        $[8] = recommendedApps;
        $[9] = userId;
        $[10] = t5;
    } else t5 = $[10];
    const resolverResult = (0, $1rYMO.useInvitedAppShortcuts)(t5);
    let t6;
    if ($[11] !== recommendedApps.length || $[12] !== resolverResult) {
        t6 = ()=>{
            if (recommendedApps.length > 0) resolverResult.fireFeatureExposed({
                isEnabled: (0, $6mKj3.expVal)("twcg-460-preload-grs-invited-app-shortcuts", "isEnabled", false)
            });
        };
        $[11] = recommendedApps.length;
        $[12] = resolverResult;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== recommendedApps || $[15] !== resolverResult) {
        t7 = [
            recommendedApps,
            resolverResult
        ];
        $[14] = recommendedApps;
        $[15] = resolverResult;
        $[16] = t7;
    } else t7 = $[16];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[17] !== Component) {
        t8 = (t9)=>{
            const { referrableShortcuts: referrableShortcuts } = t9;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                shortcutItems: Object.values(referrableShortcuts)
            });
        };
        $[17] = Component;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== cloudId || $[20] !== recommendedApps || $[21] !== resolverResult || $[22] !== shortcutsConfig || $[23] !== t8 || $[24] !== userId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Mzej.InvitedAppShortcutsContainer), {
            mode: "productionisation",
            cloudId: cloudId,
            userId: userId,
            recommendedApps: recommendedApps,
            sourceApp: $a870a7935c180a3b$var$SOURCE_APP,
            shortcutsConfig: shortcutsConfig,
            resolverResult: resolverResult
        }, t8);
        $[19] = cloudId;
        $[20] = recommendedApps;
        $[21] = resolverResult;
        $[22] = shortcutsConfig;
        $[23] = t8;
        $[24] = userId;
        $[25] = t9;
    } else t9 = $[25];
    return t9;
}
function $a870a7935c180a3b$var$_temp(acc, rec) {
    if ((0, $5xvpm.isAllowedTargetAppForInvitedAppShortcuts)(rec.entityId)) acc.push(rec.entityId);
    return acc;
}
/**
 * Fails the productionisation recommendations subtree open to the default
 * shortcuts menu. `useLazyLoadQuery` throws on a network/parse error above the
 * container's own error boundary, so we need a boundary here to keep the nav
 * rendering (control-cohort parity) rather than crashing.
 */ class $a870a7935c180a3b$var$FailOpenBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        // Report through the structured monitoring client (which scrubs/handles error payloads) rather
        // than logging the raw error, then mark it handled since we fail open to the default menu.
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).GROWTH_PUMA
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    render() {
        return this.state.hasError ? this.props.fallback : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
function $a870a7935c180a3b$export$4f68d932b5bfa21e(props) {
    const $ = (0, $bDgLe.c)(10);
    const { Component: Component } = props;
    let t0;
    if ($[0] !== Component) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, null);
        $[0] = Component;
        $[1] = t0;
    } else t0 = $[1];
    const fallback = t0;
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a870a7935c180a3b$export$e32afd5717d291e0, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== fallback || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a870a7935c180a3b$var$FailOpenBoundary, {
            fallback: fallback
        }, t1);
        $[4] = fallback;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== fallback || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: fallback
        }, t2);
        $[7] = fallback;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
}
module.exports["InvitedAppShortcutsRecommendationsQueryNode"] = $a870a7935c180a3b$export$17e9db4c99e5bef7;
module.exports["SafeInvitedAppShortcutsRecommendations"] = $a870a7935c180a3b$export$4f68d932b5bfa21e;

});

parcelRegister("5yEp5", function(module, exports) {
const $c4dc479476e86c0d$export$f817d2300729b821 = [
    'jira',
    'confluence'
];
const $c4dc479476e86c0d$export$180016b363be5dc = [
    'confluence',
    'jira',
    'home'
];
const $c4dc479476e86c0d$export$cebe16b091a89fcc = [
    'JIRA_SOFTWARE',
    'CONFLUENCE'
];
module.exports["INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS"] = $c4dc479476e86c0d$export$f817d2300729b821;
module.exports["INVITED_APP_SHORTCUTS_ALLOWED_SOURCE_APPS"] = $c4dc479476e86c0d$export$180016b363be5dc;
module.exports["INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS"] = $c4dc479476e86c0d$export$cebe16b091a89fcc;

});

parcelRegister("3H3Mp", function(module, exports) {

var $jo3kP = parcelRequire("jo3kP");


var $eZ9NQ = parcelRequire("eZ9NQ");

const $2e7bfaebd88bc476$export$5391c0e0cb095e8a = async ({ cloudId: cloudId, products: products, userId: userId })=>{
    const collaborators = await (0, $jo3kP.getUsersFromCollaborationGraph)('invitedAppShortcuts', cloudId, userId);
    if (collaborators.length === 0) return [];
    const collabsInProducts = await (0, $eZ9NQ.getPermittedUsersWithProducts)(products, cloudId, collaborators.map((c)=>c.id));
    return $2e7bfaebd88bc476$var$mapToCollaboratorsWithProducts(collaborators, collabsInProducts);
};
const $2e7bfaebd88bc476$var$mapToCollaboratorsWithProducts = (collaborators, usersWithProducts)=>collaborators.flatMap((collaborator)=>{
        const userWithProducts = usersWithProducts[collaborator.id];
        if (!(userWithProducts && userWithProducts.length > 0)) return [];
        return {
            collaborator: collaborator,
            products: userWithProducts
        };
    });
module.exports["getCollaboratorsInProducts"] = $2e7bfaebd88bc476$export$5391c0e0cb095e8a;

});

parcelRegister("8SIV6", function(module, exports) {
/**
 * This config setup allows us to debug/QA the experience by adjusting
 * some settings via localStorage overrides.
 *
 * Otherwise, we'd have to wait for days to observe cache expiry/refresh behavior,
 * and in-source-product minimum activity times.
 */ const $ddd0d5ba4d0e4cd4$export$44487a86467333c3 = ()=>$ddd0d5ba4d0e4cd4$var$CONSTANTS_AS_DEBUGGABLE_GETTERS;
const $ddd0d5ba4d0e4cd4$var$timespan = ({ days: days = 0, minutes: minutes = 0, seconds: seconds = 0 })=>((days * 1440 + minutes) * 60 + seconds) * 1000;
const $ddd0d5ba4d0e4cd4$var$CONSTANTS = {
    TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE: $ddd0d5ba4d0e4cd4$var$timespan({
        days: 3
    }),
    /**
   * When the customer visits after this time since we last wrote data to the cache,
   * we'll refresh the cache: refetch the required data.
   */ CACHE_TIME_UNTIL_REFRESH: $ddd0d5ba4d0e4cd4$var$timespan({
        days: 7
    }),
    /**
   * When the customer visits after this time since we last wrote data to the cache,
   * we'll consider the cache expired and invalid, and not eligible to see the experiment
   * (the user will not see the treatment on that visit).
   * We will refresh the cache at that time, but even if that comes back as eligible,
   * it will only affect future visits.
   */ CACHE_TIME_UNTIL_EXPIRY: $ddd0d5ba4d0e4cd4$var$timespan({
        days: 10
    })
};
const $ddd0d5ba4d0e4cd4$var$CONSTANTS_AS_DEBUGGABLE_GETTERS = {
    get TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE () {
        return $ddd0d5ba4d0e4cd4$var$getDebuggableTiming('TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE');
    },
    get CACHE_TIME_UNTIL_REFRESH () {
        return $ddd0d5ba4d0e4cd4$var$getDebuggableTiming('CACHE_TIME_UNTIL_REFRESH');
    },
    get CACHE_TIME_UNTIL_EXPIRY () {
        return $ddd0d5ba4d0e4cd4$var$getDebuggableTiming('CACHE_TIME_UNTIL_EXPIRY');
    }
};
function $ddd0d5ba4d0e4cd4$var$getDebuggableTiming(key) {
    if (typeof localStorage !== 'undefined' && localStorage) {
        const debugLocalStorageKey = `invitedAppShortcutsDebug_${key}_seconds`;
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const overrideValue = parseInt(localStorage[debugLocalStorageKey], 10);
        if (typeof overrideValue === 'number' && overrideValue >= 0) return $ddd0d5ba4d0e4cd4$var$timespan({
            seconds: overrideValue
        });
    }
    return $ddd0d5ba4d0e4cd4$var$CONSTANTS[key];
}
module.exports["getConfig"] = $ddd0d5ba4d0e4cd4$export$44487a86467333c3;

});

parcelRegister("jlJcq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

function $19551e57d2d1ae15$export$7613f0bd7ffe380c(icon, label, fallbackUrl, options) {
    const { labelElem: labelElem, apsKey: apsKey, ref: ref, analyticsName: analyticsName, menuItemId: menuItemId } = options ?? {};
    // Resolve the `MessageDescriptor` label up-front against the
    // `IntlProvider` in scope. The hook is called during render, so the
    // result tracks the active locale and re-resolves on locale change.
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelText = formatMessage(label);
    return (0, $cozmU.useMemo)(()=>({
            type: 'link',
            icon: icon,
            label: labelText,
            labelElem: labelElem,
            apsKey: apsKey,
            fallbackUrl: fallbackUrl,
            ref: ref,
            analyticsName: analyticsName,
            ...menuItemId ? {
                menuItemId: menuItemId
            } : {}
        }), // Intentionally remove the ref, as it isn't needed by useMemo, and can cause extra rendering.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        analyticsName,
        apsKey,
        fallbackUrl,
        icon,
        labelElem,
        labelText,
        menuItemId
    ]);
}
module.exports["useAppGlobalShortcutLinkItem"] = $19551e57d2d1ae15$export$7613f0bd7ffe380c;

});

parcelRegister("6ptdq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bltJZ = parcelRequire("bltJZ");


var $cXPtd = parcelRequire("cXPtd");


var $jlJcq = parcelRequire("jlJcq");


var $jx6Su = parcelRequire("jx6Su");

const $29a4efd0a72eabf6$var$icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.TeamsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $29a4efd0a72eabf6$export$6fe02dcc2001dcb0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (fallbackUrl, t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    let t2;
    if ($[2] !== options) {
        t2 = {
            apsKey: (0, $cXPtd.Products).ATLAS_TEAMS,
            analyticsName: (0, $cXPtd.Products).ATLAS_TEAMS,
            ...options
        };
        $[2] = options;
        $[3] = t2;
    } else t2 = $[3];
    return (0, $jlJcq.useAppGlobalShortcutLinkItem)($29a4efd0a72eabf6$var$icon, (0, $jx6Su.messages).label, fallbackUrl, t2);
} : (fallbackUrl, options = {})=>(0, $jlJcq.useAppGlobalShortcutLinkItem)($29a4efd0a72eabf6$var$icon, (0, $jx6Su.messages).label, fallbackUrl, {
        apsKey: (0, $cXPtd.Products).ATLAS_TEAMS,
        analyticsName: (0, $cXPtd.Products).ATLAS_TEAMS,
        ...options
    });
module.exports["useTeams"] = $29a4efd0a72eabf6$export$6fe02dcc2001dcb0;

});

parcelRegister("djzYv", function(module, exports) {
/**
 * @generated SignedSource<<b627d3773a783b4d9fe8a0cbed3d62ed>>
 * @relayHash 9e08e7760b40221bcb9a0f22914592cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13d357d5508b58b6109bb3a8a72939d1f174b8e1998c8f52583485f1631551ef
const $a9c4878f84ab4b9b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "eventTypes"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "objectTypes"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "eventTypes",
                            "variableName": "eventTypes"
                        },
                        {
                            "kind": "Variable",
                            "name": "objectTypes",
                            "variableName": "objectTypes"
                        },
                        {
                            "kind": "Literal",
                            "name": "products",
                            "value": [
                                "CONFLUENCE"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "arguments"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "rootContainerIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "rootContainerIds"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "AND"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v11 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v12 = [
        v11 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "editUi"
        }
    ], v13 = [
        {
            "concreteType": "ConfluenceFavoritedSummary",
            "kind": "LinkedField",
            "name": "favoritedSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavorite"
                }
            ]
        }
    ], v14 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v16 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiDraft",
                "plural": false,
                "selections": v15 /*: any*/ 
            },
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiPublished",
                "plural": false,
                "selections": v15 /*: any*/ 
            }
        ]
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "alias": "pageStatus",
                "kind": "ScalarField",
                "name": "status"
            },
            v10 /*: any*/ ,
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v12 /*: any*/ 
            },
            {
                "concreteType": "ConfluencePageViewerSummary",
                "kind": "LinkedField",
                "name": "viewer",
                "plural": false,
                "selections": v13 /*: any*/ 
            },
            v14 /*: any*/ ,
            v16 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "alias": "blogStatus",
                "kind": "ScalarField",
                "name": "status"
            },
            v10 /*: any*/ ,
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v12 /*: any*/ 
            },
            {
                "concreteType": "ConfluenceBlogPostViewerSummary",
                "kind": "LinkedField",
                "name": "viewer",
                "plural": false,
                "selections": v13 /*: any*/ 
            },
            v14 /*: any*/ ,
            v16 /*: any*/ 
        ],
        "type": "ConfluenceBlogPost"
    }, v19 = {
        "kind": "ScalarField",
        "name": "status"
    }, v20 = [
        v11 /*: any*/ 
    ], v21 = {
        "concreteType": "ConfluenceContentViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            },
            v21 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceWhiteboard"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            },
            v21 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceDatabase"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceSlideLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            },
            v21 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceSlide"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceEmbedLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            },
            v21 /*: any*/ ,
            v14 /*: any*/ ,
            v16 /*: any*/ 
        ],
        "type": "ConfluenceEmbed"
    }, v26 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v27 = [
        v7 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v22 /*: any*/ 
            ]
        }
    ], v28 = {
        "concreteType": "ActivityEvent",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "ScalarField",
                "name": "eventType"
            }
        ]
    }, v29 = {
        "concreteType": "ActivityPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v31 = [
        v7 /*: any*/ 
    ], v32 = {
        "kind": "InlineFragment",
        "selections": v31 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v33 = [
        v7 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v30 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v22 /*: any*/ ,
                v32 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecentContentMenuQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v27 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v27 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v29 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecentContentMenuQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v30 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v33 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v33 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        },
                                                                        v32 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v31 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v31 /*: any*/ ,
                                                                            "type": "MercuryPortfolio"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v29 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "9e08e7760b40221bcb9a0f22914592cf",
            "id": "13d357d5508b58b6109bb3a8a72939d1f174b8e1998c8f52583485f1631551ef",
            "metadata": {},
            "name": "RecentContentMenuQuery",
            "operationKind": "query",
            "text": "query RecentContentMenuQuery($cloudId:ID!,$first:Int,$after:String,$eventTypes:[String!],$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on ConfluenceSlide{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceInlineComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on ConfluenceFooterComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}},event{id,timestamp,eventType}}},pageInfo{hasNextPage,endCursor}}}}}"
        }
    };
}();
$a9c4878f84ab4b9b$var$node.hash = "f9585d13f5d9c4885250268904a58e2a";
var $a9c4878f84ab4b9b$export$2e2bcd8739ae039 = $a9c4878f84ab4b9b$var$node;
module.exports["default"] = $a9c4878f84ab4b9b$export$2e2bcd8739ae039;

});

parcelRegister("36tM8", function(module, exports) {
/**
 * Shared constants for the Recent Content Menu.
 *
 * These are extracted into a separate lightweight file to avoid pulling the
 * full recentQueryConfig module (which contains heavy query-building logic,
 * data transforms, and GraphQL queries) into chunks that only need these
 * constants (e.g. the preloader). This prevents tree-shaking defeats.
 */ 
var $yuLaV = parcelRequire("yuLaV");

var $aae031cb24e89c49$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}({});
var $aae031cb24e89c49$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivityObjectType["DATABASE"] = "DATABASE";
    ActivityObjectType["SLIDE"] = "SLIDE";
    ActivityObjectType["EMBED"] = "EMBED";
    ActivityObjectType["CONTENT"] = "CONTENT";
    ActivityObjectType["COMMENT"] = "COMMENT";
    return ActivityObjectType;
}({});
const $aae031cb24e89c49$export$8ec3d08588d2eeda = 30;
const $aae031cb24e89c49$export$c49cfb2681596b20 = [
    "PAGE",
    "BLOGPOST",
    "WHITEBOARD",
    "DATABASE",
    "SLIDE",
    "EMBED",
    "CONTENT"
];
function $aae031cb24e89c49$export$e0c1f83af18ea809() {
    return $aae031cb24e89c49$export$c49cfb2681596b20.filter((t)=>t !== "SLIDE" || (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide'));
}
const $aae031cb24e89c49$export$507c2df9171a0432 = [
    "EDITED",
    "PUBLISHED",
    "UPDATED",
    "CREATED",
    "STARTED",
    "SNAPSHOTTED"
];
module.exports["ActivityObjectType"] = $aae031cb24e89c49$export$d02a56686be43f69;
module.exports["PAGE_SIZE"] = $aae031cb24e89c49$export$8ec3d08588d2eeda;
module.exports["objectTypes"] = $aae031cb24e89c49$export$e0c1f83af18ea809;
module.exports["WORKED_ON_EVENT_TYPES"] = $aae031cb24e89c49$export$507c2df9171a0432;

});

parcelRegister("5V1fS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $8rneB = parcelRequire("8rneB");


var $brn6e = parcelRequire("brn6e");


var $9wGTI = parcelRequire("9wGTI");

const $ae7788d51c7989c6$var$getEmoji = (content)=>{
    const emojiPropertyPublished = (0, $8rneB.getEmojiPublishedFromProperties)(content);
    const emojiPropertyDraft = (0, $8rneB.getEmojiDraftFromProperties)(content);
    const emoji = emojiPropertyPublished || emojiPropertyDraft || (0, $brn6e.getEmojiFromTitle)(content.title);
    return {
        hasEmojiProperty: Boolean(emojiPropertyPublished || emojiPropertyDraft),
        emoji: emoji
    };
};
const $ae7788d51c7989c6$var$isEmojiSupportedType = (type)=>!!type && (type !== 'whiteboard' || (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles'));
const $ae7788d51c7989c6$var$getTitle = (title, hasEmojiProperty)=>hasEmojiProperty ? title : (0, $brn6e.removeEmojiFromTitle)(title);
const $ae7788d51c7989c6$export$1d1036e75f38035e = (content)=>{
    if ($ae7788d51c7989c6$var$isEmojiSupportedType(content.type)) {
        const { emoji: emoji, hasEmojiProperty: hasEmojiProperty } = $ae7788d51c7989c6$var$getEmoji(content);
        return {
            emoji: emoji,
            title: $ae7788d51c7989c6$var$getTitle(content.title, hasEmojiProperty)
        };
    }
    return {
        emoji: undefined,
        title: content.title
    };
};
const $ae7788d51c7989c6$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    untitled: {
        id: "side-navigation.content-menu.untitled",
        defaultMessage: "Untitled"
    }
});
module.exports["getContentEmojiAndTitle"] = $ae7788d51c7989c6$export$1d1036e75f38035e;
module.exports["i18n"] = $ae7788d51c7989c6$export$a7357cdd1f0b0168;

});

parcelRegister("eZ9NQ", function(module, exports) {
const $a4b1db47d17cf12c$export$c25eadb566c78ee = async (products, cloudId, accountIds)=>{
    const response = await fetch('/gateway/api/growth/invite-notify-1p/get-permitted-users-with-products', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            products: products,
            accountIds: accountIds
        })
    });
    return await response.json();
};
module.exports["getPermittedUsersWithProducts"] = $a4b1db47d17cf12c$export$c25eadb566c78ee;

});

parcelRegister("jx6Su", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4be3071ab4b3e1eb$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.teams",
        defaultMessage: "Teams"
    }
});
module.exports["messages"] = $4be3071ab4b3e1eb$export$defe85febe8b728c;

});


//# sourceMappingURL=GlobalNavigationComponent.e24b8318.js.map
